webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _app = __webpack_require__(109);
	
	__webpack_require__(110);
	
	var _axios = __webpack_require__(111);
	
	var _socket = __webpack_require__(113);
	
	var _vueDebounce = __webpack_require__(289);
	
	var _vueDebounce2 = _interopRequireDefault(_vueDebounce);
	
	var _fileSaver = __webpack_require__(273);
	
	var _fileSaver2 = _interopRequireDefault(_fileSaver);
	
	__webpack_require__(225);
	
	__webpack_require__(224);
	
	__webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var env = __webpack_require__(78);
	
	var _createApp = (0, _app.createApp)(),
	    app = _createApp.app,
	    router = _createApp.router,
	    store = _createApp.store;
	
	router.onReady(function () {
	  if (window.__INITIAL_STATE__) {
	    store.replaceState(window.__INITIAL_STATE__);
	  }
	
	  store.commit('setApi', env.api);
	  store.commit('setDomain', env.domain);
	  store.commit('setLk', env.lk);
	  store.commit('setSocket', env.socket);
	
	  _vue2.default.prototype.$fileSeaver = _fileSaver2.default;
	  _vue2.default.use(_vueDebounce2.default, {
	    listenTo: ['input', 'textarea'],
	    defaultTime: '700ms'
	  });
	  _vue2.default.prototype.$axios = (0, _axios.createAxios)(store, router);
	  _vue2.default.prototype.$client = (0, _socket.createSocket)(store);
	
	  if (store.getters.getToken) {
	    _vue2.default.prototype.$axios.get('auth/me', {
	      mute: true
	    }).then(function (res) {
	      store.commit('setUser', res.data.result.user[0]);
	    }).finally(function () {});
	  }
	  app.$mount('#app');
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createStore = createStore;
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _error = __webpack_require__(117);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _actions = __webpack_require__(116);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _getters = __webpack_require__(118);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	var _mutations = __webpack_require__(119);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	function createStore() {
	  return new _vuex2.default.Store({
	    state: function state() {
	      return {
	        pageLoad: false,
	        lk: null,
	        api: null,
	        socket: null,
	        domain: null,
	        rules: {
	          isTrue: [function (v) {
	            return v || 'Обязательное поле';
	          }],
	          requared: [function (v) {
	            return Array.isArray(v) && !!v.length || !Array.isArray(v) && !!v || 'Поле обязательно к заполнению';
	          }],
	          requaredZero: [function (v) {
	            return !!v || v === 0 || 'Поле обязательно к заполнению';
	          }],
	          min: function min(_min) {
	            return function (v) {
	              return v && +v >= _min && (+v === 0 || v[0] !== 0) || '\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E ' + _min;
	            };
	          },
	          max: function max(_max) {
	            return function (v) {
	              return v && +v <= _max || '\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E ' + _max;
	            };
	          },
	          number: [function (value) {
	            return (/^\d+$/.test(value) || 'Только цифры'
	            );
	          }],
	          email: [function (v) {
	            return (/^(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){255,})(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){65,}@)(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22))(?:\.(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-+[a-z0-9]+)*\.){1,126})+(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-+[a-z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))]))$/i.test(v) || 'Неверный формат e-mail'
	            );
	          }]
	        },
	        error: _error2.default,
	        cityList: [],
	        token: null,
	        user: null
	      };
	    },
	    actions: _actions2.default,
	    mutations: _mutations2.default,
	    getters: _getters2.default
	  });
	}

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports) {

	module.exports = {"api":"https://api.mobileadvokat.ru/api/","domain":"mobileadvokat.ru","version":"1.2.4","lk":"https://lk.mobileadvokat.ru","socket":"https://socket.mobileadvokat.ru:443"}

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(266)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(128),
	  /* template */
	  __webpack_require__(376),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.createApp = createApp;
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(304);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _index = __webpack_require__(55);
	
	var _index2 = __webpack_require__(114);
	
	var _vuetify = __webpack_require__(120);
	
	var _vuetify2 = _interopRequireDefault(_vuetify);
	
	__webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createApp() {
	  var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  var router = (0, _index2.createRouter)();
	  var store = (0, _index.createStore)();
	  var app = new _vue2.default((0, _extends3.default)({
	    router: router,
	    store: store,
	    vuetify: _vuetify2.default
	  }, _App2.default, {
	    mounted: function mounted() {
	      var _this = this;
	
	      if (!ctx) {
	        this.$client.channel('bus').listen('BroadcastEvent', function (e) {
	          _this.$root.$emit(e.action, e.param);
	        });
	
	        this.$client.private.prefix('bus').listen('PrivateEvent', function (e) {
	          _this.$root.$emit(e.action, e.param);
	          _this.$root.$emit('dot.action');
	        });
	      }
	    },
	
	    methods: {}
	  }));
	  return { app: app, router: router, store: store };
	}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(56);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Notify = __webpack_require__(290);
	
	var _Notify2 = _interopRequireDefault(_Notify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultOptions = {
	    text: '',
	    title: null,
	    color: 'info',
	    timeout: 4500
	};
	var cmp = null;
	
	function create(options) {
	    var component = new _vue2.default(_Notify2.default);
	    options = (0, _extends3.default)({}, defaultOptions, options);
	    (0, _assign2.default)(component, options);
	    var app = document.getElementsByClassName('v-application--wrap');
	    app[0].appendChild(component.$mount().$el);
	
	    return component;
	}
	
	function show(text) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    options.text = text;
	    if (!options.timeout && options.color == 'error') {
	        options.timeout = 0;
	    }
	
	    var component = document.getElementsByClassName('v-notify');
	    if (component.length) {
	        component[0].remove();
	        if (cmp) {
	            cmp.$destroy();
	        }
	    }
	
	    if (!cmp) {
	        create(options);
	    }
	}
	
	function shorts(options) {
	    var colors = ['success', 'info', 'error', 'warning'];
	    var methods = {};
	
	    colors.forEach(function (color) {
	        methods[color] = function (message, options) {
	            return show(message, (0, _extends3.default)({ color: color }, options));
	        };
	    });
	
	    if (options.shorts) {
	        var _loop = function _loop(key) {
	            var localOptions = options.shorts[key];
	            methods[key] = function (message, options) {
	                return show(message, (0, _extends3.default)({}, localOptions, options));
	            };
	        };
	
	        for (var key in options.shorts) {
	            _loop(key);
	        }
	    }
	
	    return methods;
	}
	
	var index = (0, _assign2.default)(show, (0, _extends3.default)({
	    defaultOptions: defaultOptions
	}, shorts(defaultOptions)));
	window.notify = index;
	
	exports.default = index;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(57);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.createAxios = createAxios;
	
	var _axios = __webpack_require__(91);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAxios(store, router) {
	
	    _axios2.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
	    _axios2.default.defaults.timeout = 10000;
	
	    _axios2.default.interceptors.request.use(function (config) {
	        config.url = store.getters.getApi + config.url;
	        var token = store.getters.getToken;
	        config.headers.Authorization = 'Bearer ' + token;
	
	        return config;
	    });
	
	    _axios2.default.interceptors.response.use(function (res) {
	        var data = res.config.data && !(res.config.data instanceof FormData) ? JSON.parse(res.config.data) : {};
	
	        var newToken = res.headers['new-token'];
	
	        if (newToken && 'Bearer ' + newToken != _axios2.default.defaults.headers.common.Authorization) {
	            _axios2.default.defaults.headers.common.Authorization = 'Bearer ' + newToken;
	            localStorage.setItem('token', newToken);
	            store.commit('setToken', newToken);
	        }
	
	        if (res.data.message || res.data.info) {
	            if (!data.mute) {
	                if (res.data.message) notify.error(res.data.message);
	                if (res.data.info) notify.info(res.data.info);
	            }
	
	            if (res.data.message) {
	                return _promise2.default.reject(res);
	            }
	        }
	
	        return res;
	    }, function (error) {
	        var res = error.response;
	        if (res.config.mute) {
	            return _promise2.default.reject('Ошибка отправки запроса');
	        } else if (res) {
	            var code = +res.status;
	
	            if (code == 401) {
	                router.push({ path: '/', force: true });
	            }
	
	            var status = code < 500 && code != 419 && code != 401 ? 'warning' : 'error';
	            var title = store.getters.error(code).title;
	            var text = res.data.message;
	
	            if (!text) {
	                text = store.getters.error(code).message;
	            }
	
	            notify(text, {
	                title: '[' + code + '] ' + title,
	                color: status
	            });
	        } else {
	            notify.error('Ошибка отправки запроса');
	
	            return _promise2.default.reject('Ошибка отправки запроса');
	        }
	    });
	
	    return _axios2.default;
	}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _UiBtn = __webpack_require__(85);
	
	var _UiBtn2 = _interopRequireDefault(_UiBtn);
	
	var _UiInput = __webpack_require__(298);
	
	var _UiInput2 = _interopRequireDefault(_UiInput);
	
	var _UIText = __webpack_require__(301);
	
	var _UIText2 = _interopRequireDefault(_UIText);
	
	var _UITitleLine = __webpack_require__(303);
	
	var _UITitleLine2 = _interopRequireDefault(_UITitleLine);
	
	var _UISubText = __webpack_require__(299);
	
	var _UISubText2 = _interopRequireDefault(_UISubText);
	
	var _UiAuto = __webpack_require__(296);
	
	var _UiAuto2 = _interopRequireDefault(_UiAuto);
	
	var _UITextHref = __webpack_require__(295);
	
	var _UITextHref2 = _interopRequireDefault(_UITextHref);
	
	var _UiCheckbox = __webpack_require__(297);
	
	var _UiCheckbox2 = _interopRequireDefault(_UiCheckbox);
	
	var _UITitle = __webpack_require__(302);
	
	var _UITitle2 = _interopRequireDefault(_UITitle);
	
	var _UISubTitle = __webpack_require__(300);
	
	var _UISubTitle2 = _interopRequireDefault(_UISubTitle);
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('ui_sub_title_text', _UISubTitle2.default);
	_vue2.default.component('ui_text_href', _UITextHref2.default);
	_vue2.default.component('ui_btn', _UiBtn2.default);
	_vue2.default.component('ui_auto', _UiAuto2.default);
	_vue2.default.component('ui_input', _UiInput2.default);
	_vue2.default.component('ui_check', _UiCheckbox2.default);
	_vue2.default.component('ui_text', _UIText2.default);
	_vue2.default.component('ui_title', _UITitle2.default);
	_vue2.default.component('ui_title_line', _UITitleLine2.default);
	_vue2.default.component('ui_sub_text', _UISubText2.default);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createSocket = createSocket;
	
	var _laravelEcho = __webpack_require__(277);
	
	var _laravelEcho2 = _interopRequireDefault(_laravelEcho);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	global.io = __webpack_require__(281);
	
	function createSocket(store) {
	    if (typeof io !== 'undefined') {
	        var token = store.getters.getToken;
	        if (token) {
	            var xmlhttp = new XMLHttpRequest();
	            xmlhttp.open('GET', store.getters.getApi + 'auth/me', false);
	            xmlhttp.setRequestHeader('Authorization', 'Bearer ' + token);
	            xmlhttp.send(null);
	            xmlhttp.onload = function () {};
	            if (xmlhttp.status == 200) {
	                var res = JSON.parse(xmlhttp.response);
	                var client = new _laravelEcho2.default({
	                    broadcaster: 'socket.io',
	                    host: store.getters.getSocket,
	                    auth: {
	                        headers: {
	                            Authorization: 'Bearer ' + token,
	                            Accept: 'application/json'
	                        }
	                    }
	                });
	                client.private.prefix = function (room) {
	                    var uid = res.result.user[0].uid;
	                    return client.private(room + '.' + uid);
	                };
	            }
	        }
	    }
	
	    return client;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createRouter = createRouter;
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(383);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(115);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	function createRouter() {
	
	  return new _vueRouter2.default({
	    mode: 'history',
	    routes: _routes2.default,
	    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	      if (!to.hash) {
	        $('.v-application').scrollTop(0);
	        $('#app-content').scrollTop(0);
	        $('html').scrollTop(0);
	      } else {
	        $(to.hash)[0].scrollIntoView();
	      }
	    }
	  });
	}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Home = __webpack_require__(325);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _work = __webpack_require__(335);
	
	var _work2 = _interopRequireDefault(_work);
	
	var _insurance = __webpack_require__(326);
	
	var _insurance2 = _interopRequireDefault(_insurance);
	
	var _service = __webpack_require__(334);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _cancel = __webpack_require__(322);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	var _safety = __webpack_require__(332);
	
	var _safety2 = _interopRequireDefault(_safety);
	
	var _search = __webpack_require__(333);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _news = __webpack_require__(327);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _polit = __webpack_require__(329);
	
	var _polit2 = _interopRequireDefault(_polit);
	
	var _rate = __webpack_require__(331);
	
	var _rate2 = _interopRequireDefault(_rate);
	
	var _logout = __webpack_require__(307);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	var _payment = __webpack_require__(323);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _send = __webpack_require__(324);
	
	var _send2 = _interopRequireDefault(_send);
	
	var _privacy = __webpack_require__(330);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	var _article = __webpack_require__(316);
	
	var _article2 = _interopRequireDefault(_article);
	
	var _articleOne = __webpack_require__(319);
	
	var _articleOne2 = _interopRequireDefault(_articleOne);
	
	var _articleTwo = __webpack_require__(321);
	
	var _articleTwo2 = _interopRequireDefault(_articleTwo);
	
	var _articleThree = __webpack_require__(320);
	
	var _articleThree2 = _interopRequireDefault(_articleThree);
	
	var _articleFour = __webpack_require__(318);
	
	var _articleFour2 = _interopRequireDefault(_articleFour);
	
	var _articleFive = __webpack_require__(317);
	
	var _articleFive2 = _interopRequireDefault(_articleFive);
	
	var _payment3 = __webpack_require__(328);
	
	var _payment4 = _interopRequireDefault(_payment3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var env = __webpack_require__(78);
	
	var routes = [{ path: '/pay', component: _payment4.default }, {
	  path: '/send', component: _send2.default,
	  meta: {
	    title: 'info',
	    name: 'info'
	  }
	}, {
	  path: '/payment', component: _payment2.default,
	  meta: {
	    title: 'info',
	    name: 'info'
	  }
	}, { path: '/', component: _Home2.default }, { path: '/work', component: _work2.default }, { path: '/insurance', component: _insurance2.default }, { path: '/service', component: _service2.default }, { path: '/cancel', component: _cancel2.default }, { path: '/safety', component: _safety2.default }, { path: '/search', component: _search2.default }, { path: '/article', component: _article2.default }, { path: '/news', component: _news2.default }, { path: '/polit', component: _polit2.default }, { path: '/privacy', component: _privacy2.default }, { path: '/ussage', component: _polit2.default }, { path: '/rate', component: _rate2.default }, { path: '/article/how-to-choose-a-reliable-lawyer', component: _articleOne2.default }, { path: '/article/what-is-a-secure-transaction', component: _articleTwo2.default }, { path: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results', component: _articleThree2.default }, { path: '/article/lzheyuristi-v-rossii', component: _articleFour2.default }, { path: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator', component: _articleFive2.default }, {
	  path: '/profile',
	  beforeEnter: function beforeEnter(to, from, next) {
	    if (to.query.id) {
	      location.href = env.lk + '/profile?id=' + to.query.id;
	    } else {
	      location.href = env.lk + '/profile';
	    }
	  }
	}, {
	  path: '/preferences',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/preferences';
	  }
	}, {
	  path: '/support',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/support';
	  }
	}, {
	  path: '/finance',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/finance';
	  }
	}, {
	  path: '/deals',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/deals';
	  }
	}, {
	  path: '/chat',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/chat';
	  }
	}, {
	  path: '/create_ticket',
	  beforeEnter: function beforeEnter(to, from, next) {
	    if (to.query.id) {
	      location.href = env.lk + '/create_ticket?id=' + to.query.id;
	    } else {
	      location.href = env.lk + '/create_ticket';
	    }
	  }
	}, {
	  path: '/admin/finance_statistic',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/admin/finance_statistic';
	  }
	}, {
	  path: '/admin/ministry_of_justice',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/admin/ministry_of_justice';
	  }
	}, {
	  path: '/admin/help',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/admin/modals/help';
	  }
	}, {
	  path: '/admin/judges',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/admin/judges';
	  }
	}, {
	  path: '/admin/user',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/admin/user';
	  }
	}, {
	  path: '/admin/support',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/admin/support';
	  }
	}, {
	  path: '/admin/requests',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/admin/requests';
	  }
	}, {
	  path: '/admin/lawyers',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/admin/lawyers';
	  }
	}, {
	  path: '/admin/settings',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/admin/user';
	  }
	}, {
	  path: '/admin/list_disputes',
	  beforeEnter: function beforeEnter() {
	    location.href = env.lk + '/admin/list_disputes';
	  }
	}, { path: '/logout', component: _logout2.default }];
	
	exports.default = routes;

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  fetchCurrentPage: function fetchCurrentPage(_ref, data) {
	    var commit = _ref.commit,
	        state = _ref.state;
	  },
	  setToken: function setToken(_ref2, data) {
	    var commit = _ref2.commit,
	        state = _ref2.state;
	
	    console.log(data);
	    commit('setToken', data.token);
	
	    var set = function set(name, text, date) {
	      date = date.toUTCString();
	      document.cookie = name + '=' + text + '; domain=' + state.domain + '; expires=' + date + '; path=/';
	    };
	
	    if (data.isRemember) {
	      if (data.token) {
	        var date = new Date(Date.now() + 86400e3 * 30);
	        set('token', data.token, date);
	      } else {
	        var _date = new Date(Date.now() - 86400e3 * 30);
	        document.cookie = 'token' + '=' + 'token' + '; domain=' + state.domain + '; expires=' + _date + '; path=/';
	      }
	    }
	  },
	  setUser: function setUser(_ref3, data) {
	    var commit = _ref3.commit;
	
	    commit('setUser', data);
	  }
	};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var error = [{
	  code: 401,
	  title: 'Доступ запрещен',
	  message: 'Для просмотра этой страницы необходимо авторизоваться'
	}, {
	  code: 403,
	  title: 'Доступ запрещен',
	  message: 'У вас нет доступа для просмотра этой страницы'
	}, {
	  code: 404,
	  title: 'Не найдено',
	  message: 'Запрошенная страница не найдена'
	}, {
	  code: 419,
	  title: 'Сессия истекла',
	  message: 'Время сессии истекло. Авторизуйтесь повторно'
	}, {
	  code: 429,
	  title: 'Много запросов',
	  message: 'Вы выполнили слишком много запросов'
	}, {
	  code: 500,
	  title: 'Ошибка сервера',
	  message: 'Ошибка сервера. Обратитесь к администратору'
	}, {
	  code: 503,
	  title: 'Сервис недоступен',
	  message: 'Сервис недоступен. Обратитесь к администратору'
	}];
	
	exports.default = error;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  rules: function rules(state) {
	    return state.rules;
	  },
	  getPageLoad: function getPageLoad(state) {
	    return state.pageLoad;
	  },
	  getApi: function getApi(state) {
	    return state.api;
	  },
	  getLk: function getLk(state) {
	    return state.lk;
	  },
	  getSocket: function getSocket(state) {
	    return state.socket;
	  },
	  error: function error(state) {
	    return function (code) {
	      return state.error.find(function (n) {
	        return n.code === code;
	      }) || {
	        code: 500,
	        title: 'Неизвестная ошибка',
	        message: 'Неизвестная ошибка'
	      };
	    };
	  },
	  getToken: function getToken(state) {
	    var token = state.token;
	    if (!token) {
	      var getCookie = function getCookie(name) {
	        var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
	        return matches ? decodeURIComponent(matches[1]) : undefined;
	      };
	      return getCookie('token');
	    }
	    return token;
	  },
	  getUser: function getUser(state) {
	    return state.user;
	  }
	};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isPageLoad: function isPageLoad(state) {
	    state.pageLoad = true;
	    state.templateLoad = true;
	  },
	  pageLoad: function pageLoad(state) {
	    state.pageLoad = false;
	    state.templateLoad = false;
	  },
	  setApi: function setApi(state, data) {
	    state.api = data;
	  },
	  setLk: function setLk(state, data) {
	    state.lk = data;
	  },
	  setDomain: function setDomain(state, data) {
	    state.domain = data;
	  },
	  setToken: function setToken(state, data) {
	    state.token = data;
	  },
	  setSocket: function setSocket(state, data) {
	    state.socket = data;
	  },
	  setUser: function setUser(state, data) {
	    if (data) {
	      state.user = data;
	    }
	  }
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuetify = __webpack_require__(410);
	
	var _vuetify2 = _interopRequireDefault(_vuetify);
	
	var _ru = __webpack_require__(411);
	
	var _ru2 = _interopRequireDefault(_ru);
	
	var _vMask = __webpack_require__(288);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.directive('mask', _vMask.VueMaskDirective);
	_vue2.default.use(_vuetify2.default);
	
	exports.default = new _vuetify2.default({
	  lang: {
	    current: 'ru',
	    locales: { ru: _ru2.default }
	  },
	  icons: {
	    iconfont: 'mdi' }
	});

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(55);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        text: {
	            type: String
	        },
	        title: {
	            default: null
	        },
	        color: {
	            type: String
	        },
	        timeout: {
	            type: Number
	        }
	    },
	    data: function data() {
	        return {
	            show: false
	        };
	    },
	    computed: {
	        icon: function icon() {
	            switch (this.color) {
	                case 'error':
	                    return 'fas fa-exclamation-circle';
	                case 'warning':
	                    return 'fas fa-exclamation-triangle';
	                case 'success':
	                    return 'fas fa-check-circle';
	                default:
	                    return 'fas fa-info-circle';
	            }
	        }
	    },
	    mounted: function mounted() {
	        var _this = this;
	
	        this.$nextTick(function () {
	            var link = _this.$el.querySelector('#loginLink');
	            if (link) {
	                link.onclick = function () {
	                    _this.$axios.post('/update_token', {
	                        mute: true,
	                        logError: true
	                    }).then(function (response) {
	                        if (response.data.error) {
	                            _store2.default.dispatch('logout');
	
	                            return;
	                        }
	
	                        axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.token;
	                        localStorage.setItem('token', response.data.token);
	                    }).catch(function () {
	                        _store2.default.dispatch('logout');
	                    }).finally(function () {
	                        _this.destroy();
	                    });
	                };
	            }
	        });
	
	        setTimeout(function () {
	            _this.show = true;
	        }, 10);
	
	        if (this.timeout != 0) {
	            setTimeout(function () {
	                _this.destroy();
	            }, this.timeout);
	        }
	    },
	
	    methods: {
	        destroy: function destroy() {
	            var _this2 = this;
	
	            this.$el.style.opacity = 0;
	            setTimeout(function () {
	                if (_this2.$el.parentNode) {
	                    _this2.$el.parentNode.removeChild(_this2.$el);
	                }
	            }, 300);
	            this.$destroy();
	        }
	    }
	};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _UiBtn = __webpack_require__(85);
	
	var _UiBtn2 = _interopRequireDefault(_UiBtn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { UiBtn: _UiBtn2.default },
	
	  name: 'advCarusiel',
	
	  props: {
	    adv: {
	      default: []
	    }
	  },
	
	  data: function data() {
	    return {
	      customer1: "/static/img/customer1.png",
	      advBefore: 0,
	      advLate: 2,
	      advThis: 1
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getApi'])),
	
	  methods: {
	    toProfile: function toProfile(item) {
	      this.$router.push({ path: 'profile', query: { id: item.uid } });
	    },
	    changeBannerAdv: function changeBannerAdv(value) {
	      var total = this.adv.length;
	      if (value) {
	        if (this.advThis === total - 1) {
	          this.advThis = 0;
	        } else {
	          this.advThis = this.advThis + 1;
	        }
	        if (this.adv[this.advThis - 1]) {
	          this.advBefore = this.advThis - 1;
	        } else {
	          this.advBefore = total - 1;
	        }
	        if (this.adv[this.advThis + 1]) {
	          this.advLate = this.advThis + 1;
	        } else {
	          this.advLate = 0;
	        }
	      } else {
	        if (this.advThis === 0) {
	          this.advThis = total - 1;
	        } else {
	          this.advThis = this.advThis - 1;
	        }
	        if (this.adv[this.advThis - 1]) {
	          this.advBefore = this.advThis - 1;
	        } else {
	          this.advBefore = total - 1;
	        }
	        if (this.adv[this.advThis + 1]) {
	          this.advLate = this.advThis + 1;
	        } else {
	          this.advLate = 0;
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'AdvCounter',
	
	  props: {
	    arr: {
	      required: true
	    },
	    titile: {
	      type: String,
	      required: false
	    }
	  },
	
	  computed: {}
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  name: 'bannerMain',
	
	  props: {
	    arr: {
	      default: []
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUser'])),
	  data: function data() {
	    return {
	      bannerThis: 0,
	      subTitleList: []
	    };
	  },
	  mounted: function mounted() {
	    this.getSubTitle();
	    setInterval(this.changeBanner(1), 180000);
	  },
	
	  methods: {
	    getSubTitle: function getSubTitle() {
	      for (var index in this.arr) {
	        this.subTitleList.push({
	          title: this.arr[index].chooserDescription,
	          index: index
	        });
	      }
	    },
	    bannerFunc: function bannerFunc(href) {
	      if (href) {
	        this.$router.push(href);
	      } else {
	        this.$root.$emit('modal.reg');
	      }
	    },
	    changeBanner: function changeBanner(value) {
	      var count = this.arr.length;
	      if (value == 1) {
	        if (count == this.bannerThis + 1) {
	          this.bannerThis = 0;
	        } else {
	          this.bannerThis = this.bannerThis + 1;
	        }
	      } else {
	        if (0 > this.bannerThis - 1) {
	          this.bannerThis = count - 1;
	        } else {
	          this.bannerThis = this.bannerThis - 1;
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuelidate = __webpack_require__(16);
	
	var _validators = __webpack_require__(17);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vuelidate.validationMixin],
	  validations: {
	    card: {
	      Phone: { required: _validators.required, integer: _validators.integer, maxLength: (0, _validators.maxLength)(12) },
	      Email: { required: _validators.required, email: _validators.email },
	      PayeePurse: { required: _validators.required, integer: _validators.integer, maxLength: (0, _validators.maxLength)(16) },
	      CardHolder: { required: _validators.required },
	      CardMonth: { required: _validators.required, integer: _validators.integer, maxLength: (0, _validators.maxLength)(2) },
	      CardYear: { required: _validators.required, integer: _validators.integer, maxLength: (0, _validators.maxLength)(4) },
	      CardCode: { required: _validators.required, integer: _validators.integer, maxLength: (0, _validators.maxLength)(3) }
	    }
	  },
	  data: function data() {
	    return {
	      card: {
	        guid: null,
	
	        description: null,
	
	        PayeePurse: null,
	
	        CardHolder: null,
	
	        CardMonth: null,
	
	        CardYear: null,
	
	        CardCode: null,
	
	        Phone: null,
	
	        Email: null
	      },
	      cards: [],
	      id: null,
	      isLoad: false,
	      isTrue: false
	    };
	  },
	
	  mounted: function mounted() {
	    if (this.$route.query.id) {
	      this.id = this.$route.query.id;
	    }
	    this.loadData();
	    this.loadCard();
	  },
	
	  methods: {
	    loadData: function loadData() {
	      var _this = this;
	
	      this.isLoad = true;
	      this.$axios.get('auth/me/', {}).then(function (response) {
	        if (response.data.result.user) {
	          _this.card.Email = response.data.result.user[0].email;
	          _this.card.Phone = response.data.result.user[0].phone;
	        }
	      }).finally(function () {
	        _this.isLoad = false;
	      });
	    },
	    loadCard: function loadCard() {
	      var _this2 = this;
	
	      this.isLoad = true;
	      this.$axios.get('auth/me/card').then(function (res) {
	        if (!res.data.result.IsSuccess) {
	          notify.warning(res.data.result.Description);
	        }
	        _this2.cards = res.data.result.Data;
	      }).finally(function () {
	        _this2.isLoad = false;
	      });
	    },
	    send: function send() {
	      var _this3 = this;
	
	      if (this.card.guid) {
	        if (this.$v.card.Email.$invalid || this.$v.card.Phone.$invalid) {
	          return;
	        }
	      } else {
	        this.$v.card.$touch();
	        if (this.$v.card.$invalid) {
	          return;
	        }
	      }
	      this.isLoad = true;
	      this.$axios.post('ticket/' + this.id + '/pay', this.card).then(function (res) {
	        if (!res.data.result.IsSuccess) {
	          notify.warning(res.data.result.Description);
	        } else {
	          _this3.isTrue = true;
	        }
	      }).finally(function () {
	        _this3.isLoad = false;
	      });
	    }
	  },
	  watch: {
	    getUser: function getUser(to, from) {
	      this.card.Email = to.email;
	      this.card.Phone = to.phone;
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUser']), {
	    phoneErrors: function phoneErrors() {
	      var errors = [];
	      if (!this.$v.card.Phone.$dirty) return errors;
	      !this.$v.card.Phone.integer && errors.push('Только числа');
	      !this.$v.card.Phone.maxLength && errors.push('Максимальное количество символов 12');
	      !this.$v.card.Phone.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    emailErrors: function emailErrors() {
	      var errors = [];
	      if (!this.$v.card.Email.$dirty) return errors;
	      !this.$v.card.Email.email && errors.push('Неккоректный e-mail');
	      !this.$v.card.Email.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    payeePurseErrors: function payeePurseErrors() {
	      var errors = [];
	      if (!this.$v.card.PayeePurse.$dirty) return errors;
	      !this.$v.card.PayeePurse.integer && errors.push('Только числа');
	      !this.$v.card.PayeePurse.maxLength && errors.push('Максимальное количество символов 16');
	      !this.$v.card.PayeePurse.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    cardMonthErrors: function cardMonthErrors() {
	      var errors = [];
	      if (!this.$v.card.CardMonth.$dirty) return errors;
	      !this.$v.card.CardMonth.integer && errors.push('Только числа');
	      !this.$v.card.CardMonth.maxLength && errors.push('Максимальное количество символов 2');
	      !this.$v.card.CardMonth.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    cardCodeErrors: function cardCodeErrors() {
	      var errors = [];
	      if (!this.$v.card.CardCode.$dirty) return errors;
	      !this.$v.card.CardCode.integer && errors.push('Только числа');
	      !this.$v.card.CardCode.maxLength && errors.push('Максимальное количество символов 3');
	      !this.$v.card.CardCode.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    cardYearErrors: function cardYearErrors() {
	      var errors = [];
	      if (!this.$v.card.CardYear.$dirty) return errors;
	      !this.$v.card.CardYear.integer && errors.push('Только числа');
	      !this.$v.card.CardYear.maxLength && errors.push('Максимальное количество символов 2');
	      !this.$v.card.CardYear.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    cardHolderErrors: function cardHolderErrors() {
	      var errors = [];
	      if (!this.$v.card.CardHolder.$dirty) return errors;
	      !this.$v.card.CardHolder.required && errors.push('Обязательное поле');
	      return errors;
	    }
	  })
	};

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'UITextHref',
	
	  props: {
	    color: {
	      type: String,
	      default: '#9D9D9D'
	    },
	    href: {
	      type: String,
	      required: true
	    },
	    arrow: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  computed: {
	    style: function style() {
	      return {
	        '--color': this.color
	      };
	    }
	  }
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(170);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _props;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'UiSelect',
	    data: function data() {
	        return {};
	    },
	    props: (_props = {
	        height: {
	            type: String,
	            required: false
	        },
	        solo: {
	            type: Boolean,
	            required: false
	        },
	        dense: {
	            type: Boolean,
	            required: false
	        },
	        filled: {
	            type: Boolean,
	            required: false
	        },
	        rounded: {
	            type: Boolean,
	            required: false
	        },
	        rules: {
	            required: false
	        },
	        chips: {
	            type: Boolean,
	            default: false
	        },
	        deletable_chips: {
	            type: Boolean,
	            default: false
	        },
	        multiple: {
	            type: Boolean,
	            default: false
	        },
	        small_chips: {
	            type: Boolean,
	            default: false
	        },
	        color: {
	            type: String,
	            default: 'gray'
	        },
	        hide_details: {
	            type: Boolean,
	            default: true
	        },
	        clearable: {
	            type: Boolean,
	            default: true
	        },
	        type: {
	            default: 'main'
	        },
	        item_value: {
	            default: 'id'
	        },
	        item_text: {
	            default: 'name'
	        },
	        label: {
	            type: String,
	            default: false
	        }
	    }, (0, _defineProperty3.default)(_props, 'hide_details', {
	        type: Boolean,
	        default: true
	    }), (0, _defineProperty3.default)(_props, 'placeholder', {
	        type: String,
	        default: ''
	    }), (0, _defineProperty3.default)(_props, 'items', {
	        default: []
	    }), (0, _defineProperty3.default)(_props, 'required', {
	        default: false
	    }), (0, _defineProperty3.default)(_props, 'value', {
	        required: true
	    }), _props)
	};

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	
	    name: 'UiButton',
	
	    props: {
	        submit: {
	            type: Boolean,
	            default: false
	        },
	
	        icon: {
	            type: String,
	            required: false
	        },
	
	        disabled: {
	            type: Boolean,
	            default: false
	        },
	
	        type: {
	            type: String,
	            default: 'main-btn'
	        }
	    }
	
	};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	
	    name: 'UiCheckbox',
	
	    props: {
	        details: {
	            default: false
	        },
	
	        falseVal: {
	            default: false
	        },
	
	        trueVal: {
	            default: true
	        },
	
	        error: {
	            type: Boolean,
	            default: false
	        },
	
	        value: {
	            required: true
	        },
	
	        rules: {
	            default: function _default() {
	                return [];
	            },
	            required: false
	        },
	
	        placeholder: {
	            type: String,
	            required: false
	        },
	
	        disabled: {
	            type: Boolean,
	            default: false
	        }
	    },
	
	    methods: {
	        change: function change(event) {
	            this.$emit('change', event);
	            this.$emit('input', event);
	        }
	    }
	
	};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'UiInput',
	    data: function data() {
	        return {
	            show: true
	        };
	    },
	    props: {
	        value: {
	            required: true
	        },
	        placeholder: {
	            type: String,
	            default: ''
	        },
	        clearable: {
	            type: Boolean,
	            default: false
	        },
	        hint: {
	            type: String,
	            default: ''
	        },
	        mask: {
	            type: String,
	            default: ''
	        },
	        required: {
	            type: Boolean,
	            default: false
	        },
	        type: {
	            default: 'text'
	        },
	        label: {
	            type: String,
	            default: ''
	        },
	        disabled: {
	            type: Boolean,
	            default: false
	        },
	        rules: {
	            required: false
	        },
	        color: {
	            type: String,
	            default: 'grey'
	        },
	        show_password: {
	            type: Boolean,
	            default: false
	        }
	    }
	};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'UiText',
	
	  props: {
	    align: {
	      type: String,
	      default: 'left'
	    }
	  },
	
	  computed: {
	    style: function style() {
	      return {
	        '--align': this.align
	      };
	    }
	  }
	};

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'UITitle',
	
	  props: {
	    align: {
	      type: String,
	      default: 'left'
	    }
	  },
	
	  computed: {
	    style: function style() {
	      return {
	        '--align': this.align
	      };
	    }
	  }
	};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'UiText',
	
	  props: {
	    size: {
	      type: String,
	      default: null
	    },
	    color: {
	      type: String,
	      default: '#000000'
	    }
	  },
	
	  computed: {
	    style: function style() {
	      return {
	        '--color': this.color,
	        '--size': this.size
	      };
	    }
	  }
	};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'UITitle',
	
	  props: {
	    align: {
	      type: String,
	      default: 'left'
	    }
	  },
	
	  computed: {
	    style: function style() {
	      return {
	        '--align': this.align
	      };
	    }
	  }
	};

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'UITitleLine',
	
	  props: {
	    no_left: {
	      type: Boolean,
	      default: false
	    },
	    text_decoration: {
	      type: String,
	      default: 'none'
	    },
	    margin_top: {
	      type: String,
	      default: '50px'
	    },
	    margin_bottom: {
	      type: String,
	      default: '50px'
	    }
	  },
	
	  computed: {
	    style: function style() {
	      return {
	        '--margin-top': this.margin_top,
	        '--margin-bottom': this.margin_bottom,
	        '--decoration': this.text_decoration
	      };
	    }
	  }
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _footer = __webpack_require__(305);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _header = __webpack_require__(306);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _menu = __webpack_require__(308);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _modal = __webpack_require__(309);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isButton: true,
	      ssr: false,
	      size: "col-3",
	      bar: 0,
	      jq: '$',
	      fab: false
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUser'])),
	  methods: {
	    toHelp: function toHelp() {
	      this.$root.$emit('modal.applying');
	    }
	  },
	  mounted: function mounted() {},
	
	  components: { Modal: _modal2.default, Menu: _menu2.default, Footer: _footer2.default, Header: _header2.default }
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(2);
	
	exports.default = {
	  data: function data() {
	    return {
	      isService: false,
	      isClient: false,
	      isAdvocat: false,
	      itemsList: [],
	      setFooter: ''
	    };
	  },
	  methods: {
	    setList: function setList(name) {
	      if (this.setFooter === name) {
	        this.setFooter = null;
	        this.itemsList = [];
	        return;
	      }
	      this.setFooter = name;
	      switch (name) {
	        case 'client':
	          this.itemsList = [{
	            name: 'Безопасная сделка',
	            href: '/safety'
	          }, {
	            name: 'Найти адвоката',
	            href: '/search'
	          }, {
	            name: 'Политика конфиденциальности',
	            href: '/privacy'
	          }];
	          this.scrollToBottom();
	          return '';
	        case 'advocate':
	          this.itemsList = [{
	            name: 'Страхование',
	            href: '/insurance'
	          }];
	          this.scrollToBottom();
	          return '';
	        case 'service':
	          this.itemsList = [{
	            name: 'Как это работает?',
	            href: '/work'
	          }, {
	            name: 'Политика конфиденциальности',
	            href: '/privacy'
	          }, {
	            name: 'Условия использования',
	            href: '/static/doc/offerta.pdf'
	          }];
	          this.scrollToBottom();
	          return '';
	      }
	    },
	    reg: function reg() {
	      this.$root.$emit('modal.reg');
	    },
	    login: function login() {
	      this.$root.$emit('modal.auth');
	    },
	    toHelp: function toHelp() {
	      this.$root.$emit('modal.help');
	    },
	    toApplying: function toApplying() {
	      this.$root.$emit('modal.applying');
	    },
	    scrollToBottom: function scrollToBottom() {
	      this.$root.$emit('all.scroll.bottom');
	      this.$nextTick(function () {
	        $('html')[0].scrollTo(0, document.body.scrollHeight);
	      });
	      try {
	        $('html')[0].scrollTo(0, document.body.scrollHeight);
	      } catch (err) {}
	    }
	  },
	  computed: (0, _vuex.mapGetters)([])
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isAuth: false,
	      customer1: "/static/img/customer1.png",
	      user: null,
	      rerender: false,
	      isNew: false,
	      menuitems: []
	    };
	  },
	  components: {},
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setToken', 'setUser']), {
	    isMenu: function isMenu() {
	      this.$root.$refs.menu.isMenu();
	    },
	    letter: function letter() {
	      this.$router.push("/chat");
	    },
	    bellClick: function bellClick() {},
	    isAuthModal: function isAuthModal() {
	      this.$root.$emit("modal.auth");
	    },
	    isRegModal: function isRegModal() {
	      this.$root.$emit("modal.reg");
	    },
	    logout: function logout() {
	      localStorage.removeItem('token');
	      this.setToken({ token: null, isRemember: true });
	      this.setUser = {};
	      location.reload();
	    }
	  }),
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$root.$on('all.scroll', function () {
	      $('html').scrollTop(0);
	    });
	    this.$root.$on('open.new.message', function () {
	      _this.isNew = false;
	    });
	    this.$root.$on('dot.action', function () {
	      _this.isNew = true;
	      _this.rerender = !_this.rerender;
	    });
	  },
	
	  watch: {
	    getUser: function getUser(to, from) {
	      this.user = this.getUser;
	      if (this.user.role_id == 2) {
	        this.menuitems = [{ title: "Профиль", href: '/profile' }, { title: "Сделки", href: "/deals" }, { title: "Поддержка", href: "/support" }, { title: "Настройка", href: "/preferences" }, { title: "О безопасной сделке", href: "/safety" }, { title: "Выйти", href: "/Logout", met: "logout" }];
	      } else {
	        this.menuitems = [{ title: "Профиль", href: '/profile' }, { title: "Сделки", href: "/deals" }, {
	          title: "Создать обращение",
	          href: "/create_ticket"
	        }, { title: "Поддержка", href: "/support" }, { title: "Настройка", href: "/preferences" }, { title: "О безопасной сделке", href: "/safety" }, { title: "Выйти", href: "/Logout", met: "logout" }];
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["getUser", "getLk", "getApi"]))
	};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setToken', 'setUser']), {
	    logout: function logout() {
	      localStorage.removeItem('token');
	      this.setToken({ token: null, isRemember: true });
	      this.setUser = {};
	      this.$router.push("/");
	      location.reload();
	    }
	  }),
	  mounted: function mounted() {
	    this.logout();
	  }
	};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(171);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(169);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isPanel: true,
	      size: "menu-hide menu-all is-width-zero",
	      menuList: [{
	        name: 'Клиенту',
	        opened: false,
	        routs: [{
	          name: 'Безопасная сделка',
	          href: '/safety'
	        }, {
	          name: 'Поиск адвоката',
	          href: '/search'
	        }, {
	          name: 'Отмена судебного приказа',
	          href: '/cancel'
	        }]
	      }, {
	        name: 'Адвокату',
	        opened: false,
	        routs: [{
	          name: 'Страхование',
	          href: '/insurance'
	        }, {
	          name: 'Презентация сервиса',
	          href: '/service'
	        }]
	      }, {
	        name: 'О сервисе',
	        opened: false,
	        routs: [{
	          name: 'О сервисе',
	          href: '/service'
	        }, {
	          name: 'Как это работает?',
	          href: '/work'
	        }, {
	          name: 'Политика конфиденциальности',
	          href: '/privacy'
	        }]
	      }]
	    };
	  },
	  watch: {
	    getUser: function getUser(to, from) {
	      if (this.getUser && this.getUser.role_id === 3) {
	        this.menuList.push({
	          name: 'Админу',
	          opened: false,
	          routs: [{
	            name: 'Финансовая статистика',
	            href: '/admin/finance_statistic'
	          }, {
	            name: 'Оставленные заявки',
	            href: '/admin/support'
	          }, {
	            name: 'Список Адвокатов Министерства Юстиции',
	            href: '/admin/ministry_of_justice'
	          }, {
	            name: 'Список Судей',
	            href: '/admin/judges'
	          }, {
	            name: 'Управление пользователями',
	            href: '/admin/user'
	          }, {
	            name: 'Модерация адвокатов',
	            href: '/admin/lawyers'
	          }, {
	            name: 'Споры',
	            href: '/admin/list_disputes'
	          }, {
	            name: 'Настройки',
	            href: '/admin/settings'
	          }]
	        });
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.getUser && this.getUser.role_id == 3) {
	      this.menuList.push({
	        name: 'Админу',
	        opened: false,
	        routs: [{
	          name: 'Финансовая статистика',
	          href: '/admin/finance_statistic'
	        }, {
	          name: 'Оставленные заявки',
	          href: '/admin/support'
	        }, {
	          name: 'Список Адвокатов Министерства Юстиции',
	          href: '/admin/ministry_of_justice'
	        }, {
	          name: 'Список Судей',
	          href: '/admin/judges'
	        }, {
	          name: 'Управление пользователями',
	          href: '/admin/user'
	        }, {
	          name: 'Модерация адвокатов',
	          href: '/admin/lawyers'
	        }, {
	          name: 'Споры',
	          href: '/admin/list_disputes'
	        }, {
	          name: 'Настройки',
	          href: '/admin/settings'
	        }]
	      });
	    }
	  },
	
	  methods: {
	    onClickToItem: function onClickToItem(href) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _this.isMenu();
	
	              case 2:
	                _this.$router.push(href);
	
	              case 3:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    isMenu: function isMenu() {
	      this.isPanel = !this.isPanel;
	      if (this.isPanel) {
	        this.size = " menu-all menu-hide is-width-zero";
	      } else {
	        this.size = "menu-open menu-all ";
	      }
	    },
	    toHelp: function toHelp() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _this2.isMenu();
	
	              case 2:
	                _this2.$root.$emit('modal.applying');
	
	              case 3:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    }
	  },
	  computed: (0, _vuex.mapGetters)(['getUser'])
	};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(311);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _reg = __webpack_require__(314);
	
	var _reg2 = _interopRequireDefault(_reg);
	
	var _applying = __webpack_require__(310);
	
	var _applying2 = _interopRequireDefault(_applying);
	
	var _create = __webpack_require__(315);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _help = __webpack_require__(312);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _pay = __webpack_require__(313);
	
	var _pay2 = _interopRequireDefault(_pay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Help: _help2.default, Auth: _auth2.default, Reg: _reg2.default, Applying: _applying2.default, Create: _create2.default, Pay: _pay2.default }
	};

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      pay: 'false'
	    };
	  },
	  methods: {},
	  mounted: function mounted() {
	    console.log(this.$route.query.pay);
	    if (this.$route.query.pay) {
	      this.pay = this.$route.query.pay;
	    }
	  }
	};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {};
	  },
	  methods: {},
	  created: function created() {}
	};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vuelidate = __webpack_require__(16);
	
	var _validators = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vuelidate.validationMixin],
	  validations: {
	    select: {
	      text: { required: _validators.required },
	      region: { required: _validators.required },
	      phone: { required: _validators.required, maxLength: (0, _validators.maxLength)(17) }
	    }
	  },
	  data: function data() {
	    return {
	      dialog: false,
	      isComplite: false,
	      isAuth: false,
	      regions: [],
	      select: {
	        name: null,
	        email: null,
	        phone: null,
	        text: null,
	        file: null,
	        region: []
	      }
	    };
	  },
	
	  methods: {
	    modal: function modal() {
	      var _this = this;
	
	      this.select.text = null;
	      this.select.file = null;
	      this.isComplite = false;
	      this.select.name = null;
	      this.select.email = null;
	      this.select.region = [];
	      this.dialog = !this.dialog;
	      this.$axios.get("auth/registration/atribute").then(function (res) {
	        if (res.data.cod == 200) {
	          _this.regions = res.data.result.region;
	        }
	      });
	    },
	    closse: function closse() {
	      this.dialog = false;
	    },
	    fileChange: function fileChange(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      if (!files.length) return;
	      this.select.file = files[0];
	    },
	    send: function send() {
	      var _this2 = this;
	
	      this.$v.select.$touch();
	      if (this.$v.select.$invalid) {
	        return;
	      }
	
	      var formData = new FormData();
	      for (var key in this.select) {
	        formData.append(key, this.select[key]);
	      }
	      this.$axios.post('chat/new/feeze', formData, {
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      }).then(function (res) {
	        if (res.data.cod == 200) {
	          _this2.select = {
	            name: null,
	            email: null,
	            phone: null,
	            id: null,
	            text: null,
	            file: null,
	            region: []
	          };
	          _this2.isComplite = true;
	          if (!_this2.isAuth) {
	            _this2.setToken({ token: res.data.result.access_token, isRemember: true });
	            _this2.setUser = res.data.result.user;
	            _this2.closse();
	            location.reload();
	          }
	        }
	      }).finally(function () {});
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.$root.$on('modal.applying', function () {
	      _this3.modal();
	    });
	  },
	
	  computed: (0, _extends3.default)({
	    phoneErrors: function phoneErrors() {
	      var errors = [];
	      if (!this.$v.select.phone.$dirty) return errors;
	      !this.$v.select.phone.maxLength && errors.push('Неккоректный номер');
	      !this.$v.select.phone.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    emailErrors: function emailErrors() {
	      var errors = [];
	      if (!this.$v.select.email.$dirty) return errors;
	      !this.$v.select.email.email && errors.push('Неккоректный e-mail');
	      !this.$v.select.email.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    nameErrors: function nameErrors() {
	      var errors = [];
	      if (!this.$v.select.name.$dirty) return errors;
	      !this.$v.select.name.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    regionErrors: function regionErrors() {
	      var errors = [];
	      if (!this.$v.select.region.$dirty) return errors;
	      !this.$v.select.region.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    textErrors: function textErrors() {
	      var errors = [];
	      if (!this.$v.select.text.$dirty) return errors;
	      !this.$v.select.text.required && errors.push('Обязательное поле');
	      return errors;
	    }
	  }, (0, _vuex.mapGetters)(['getUser'])),
	  watch: {
	    isComplite: function isComplite(to, from) {
	      var _this4 = this;
	
	      if (to) {
	        setTimeout(function () {
	          _this4.select.text = null;
	          _this4.select.file = null;
	          _this4.isComplite = false;
	          _this4.select.name = null;
	          _this4.select.email = null;
	          _this4.select.region = [];
	          _this4.dialog = !_this4.dialog;
	        }, 3000);
	      }
	    },
	    getUser: function getUser(to, from) {
	      this.select.email = this.getUser.email;
	      this.select.name = this.getUser.name;
	      this.select.phone = this.getUser.phone;
	      this.isAuth = true;
	    }
	  }
	};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuelidate = __webpack_require__(16);
	
	var _validators = __webpack_require__(17);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vuelidate.validationMixin],
	  validations: {
	    phone: { required: _validators.required, maxLength: (0, _validators.maxLength)(17) },
	    code: { required: _validators.required, maxLength: (0, _validators.maxLength)(12), integer: _validators.integer }
	  },
	  data: function data() {
	    return {
	      currentTime: 0,
	      isLoad: false,
	      isSenden: true,
	      timer: null,
	      phone: null,
	      code: null,
	      dialog: false,
	      checkbox: false,
	      isLoading: false
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setToken', 'setUser']), {
	    modal: function modal() {
	      this.currentTime = 0;
	      this.dialog = !this.dialog;
	    },
	    closse: function closse() {
	      this.phone = null;
	      this.code = null;
	      this.dialog = false;
	    },
	    sendCode: function sendCode() {
	      if (this.isLoad) {
	        return;
	      }
	      this.$v.phone.$touch();
	      if (this.$v.phone.$invalid) {
	        return;
	      }
	
	      var phone = this.phone.replace(/[^\w\s]/gi, '');
	      this.$axios.post('auth/code', {
	        phone: phone
	      }).then(function (res) {}).finally(function () {});
	
	      this.isSenden = true;
	      this.isLoad = true;
	      this.currentTime = 60;
	      this.startTimer();
	    },
	    startTimer: function startTimer() {
	      var _this = this;
	
	      this.timer = setInterval(function () {
	        _this.currentTime--;
	      }, 1000);
	    },
	    stopTimer: function stopTimer() {
	      clearTimeout(this.timer);
	      this.isLoad = false;
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      this.$v.$touch();
	      if (this.$v.$invalid) {
	        return;
	      }
	      this.isLoading = true;
	      var phone = this.phone.replace(/[^\w\s]/gi, '');
	      this.$axios.post('auth/login', {
	        phone: phone,
	        code: this.code
	      }).then(function (res) {
	        if (res.data.result.access_token) {
	          _this2.setToken({ token: res.data.result.access_token, isRemember: true });
	          _this2.setUser(res.data.result.user);
	          location.reload();
	        }
	      }).finally(function () {
	        _this2.isLoading = false;
	      });
	    }
	  }),
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.$root.$on('modal.auth', function (res) {
	      if (res) {
	        _this3.phone = res.phone;
	      }
	      _this3.modal();
	    });
	  },
	
	  watch: {
	    currentTime: function currentTime(time) {
	      if (time === 0) {
	        this.stopTimer();
	      }
	    }
	  },
	  computed: {
	    phoneErrors: function phoneErrors() {
	      var errors = [];
	      if (!this.$v.phone.$dirty) return errors;
	      !this.$v.phone.maxLength && errors.push('Неккоректный номер');
	      !this.$v.phone.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    codeErrors: function codeErrors() {
	      var errors = [];
	      if (!this.$v.code.$dirty) return errors;
	      !this.$v.code.integer && errors.push('Только числа');
	      !this.$v.code.maxLength && errors.push('Неккоректный код');
	      !this.$v.code.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    checkboxErrors: function checkboxErrors() {
	      var errors = [];
	      if (!this.$v.checkbox.$dirty) return errors;
	      !this.$v.checkbox.checked && errors.push('Обязательное поле!');
	      return errors;
	    }
	  }
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isComplite: false,
	      dialog: false,
	      isAuth: false,
	      select: {
	        name: null,
	        email: null,
	        phone: null,
	        id: null,
	        title: null,
	        type: null,
	        text: null,
	        file: null
	      },
	      items: [{ name: 'Бухгалтерия и платежи', value: 'payments' }, { name: 'Ошибка в работе сайта', value: 'bug' }, { name: 'Вопрос по работе системы', value: 'help' }, { name: 'Модерация', value: 'moderation' }, { name: 'Другое', value: 'other' }]
	    };
	  },
	
	  methods: {
	    reset: function reset(isAuth) {
	      this.dialog = !this.dialog;
	      this.isComplite = false;
	      this.isAuth = isAuth;
	      this.select.name = null;
	      this.select.email = null;
	      this.select.phone = null;
	      this.select.id = null;
	      this.select.text = null;
	      this.select.title = null;
	      this.select.type = null;
	      this.select.file = null;
	    },
	    modal: function modal(isAuth) {
	      var _this = this;
	
	      this.reset(isAuth);
	      this.$nextTick(function () {
	        _this.$refs.form.reset();
	      });
	    },
	    closse: function closse() {
	      this.dialog = false;
	    },
	    fileChange: function fileChange(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      if (!files.length) return;
	      this.select.file = files[0];
	    },
	    send: function send() {
	      var _this2 = this;
	
	      if (!this.$refs.form.validate()) {
	        return;
	      }
	
	      var formData = new FormData();
	      for (var key in this.select) {
	        formData.append(key, this.select[key]);
	      }
	
	      this.$axios.post('support', formData, {
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      }).finally(function () {
	        _this2.isComplite = true;
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.$root.$on('modal.help', function () {
	      var isAuth = false;
	      if (_this3.getUser) {
	        isAuth = true;
	      }
	      _this3.modal(isAuth);
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUser', 'rules'])),
	  watch: {
	    isComplite: function isComplite(to, from) {
	      var _this4 = this;
	
	      if (to) {
	        setTimeout(function () {
	          _this4.reset(false);
	        }, 3000);
	      }
	    }
	  }
	};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isLoad: false,
	      isLoading: false,
	      dialog: false
	    };
	  },
	
	  methods: {
	    modal: function modal() {
	      this.dialog = !this.dialog;
	    },
	    closse: function closse() {
	      this.dialog = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$root.$on('modal.pay', function (res) {
	      _this.modal();
	
	      _this.$nextTick(function () {
	        _this.$axios.get('yookassa/order/' + res.uuid + '/payment').then(function (_ref) {
	          var data = _ref.data;
	
	          var checkout = new window.YooMoneyCheckoutWidget({
	            confirmation_token: data.result.token,
	            return_url: _this.getApi + 'yookassa/order/' + res.uuid + '/checkout',
	            error_callback: function error_callback(error) {
	              console.log(error);
	            }
	          });
	
	          checkout.render('payment-form');
	          _this.isLoad = false;
	        });
	      });
	    });
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getApi']))
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  data: function data() {
	    return {
	      isClient: false,
	      isDisabled: false,
	      isLoading: false,
	      client: {
	        phone: null,
	        name: null,
	        surname: null,
	        patronymic: null,
	        email: null,
	        checkbox: false,
	        checkbox2: false
	      },
	      advocate: {
	        phone: null,
	        name: null,
	        surname: null,
	        patronymic: null,
	        email: null,
	        isFith: false,
	        isUr: false,
	        experience: null,
	        certificate: null,
	        region_id: [],
	        specialization: [],
	        information: null,
	        filePasport: null,
	        fileCertificate: null,
	        is24h: false,
	        isOfert: false
	      },
	      currentTime: 0,
	      timer: null,
	      dialog: false,
	      isFileError: false,
	      step: 1,
	      specializations: [],
	      regions: []
	    };
	  },
	
	  methods: {
	    modal: function modal() {
	      this.step = 1;
	      this.dialog = !this.dialog;
	    },
	    closse: function closse() {
	      this.client = {
	        phone: null,
	        name: null,
	        surname: null,
	        patronymic: null,
	        email: null,
	        checkbox: false,
	        checkbox2: false
	      }, this.advocate = {
	        phone: null,
	        name: null,
	        surname: null,
	        patronymic: null,
	        email: null,
	        isFith: false,
	        isUr: false,
	        experience: null,
	        certificate: null,
	        region_id: null,
	        specialization: null,
	        information: null,
	        filePasport: null,
	        fileCertificate: null,
	        is24h: false,
	        isOfert: false
	      }, this.dialog = !this.dialog;
	    },
	    setAll: function setAll(event) {
	      var _this = this;
	
	      if (event) {
	        this.advocate.region_id = [];
	        this.regions.forEach(function (item) {
	          _this.advocate.region_id.push(item.id);
	        });
	      } else {
	        this.advocate.region_id = [];
	      };
	    },
	    setAllSpec: function setAllSpec(event) {
	      var _this2 = this;
	
	      if (event) {
	        this.advocate.specialization = [];
	        this.specializations.forEach(function (item) {
	          _this2.advocate.specialization.push(item.id);
	        });
	      } else {
	        this.advocate.specialization = [];
	      };
	    },
	    changeStep: function changeStep(number) {
	      if (number == 1) {
	        if (this.step == 5) {
	          return;
	        } else {
	          if (!this.isClient && this.step === 4 && (!this.advocate.filePasport || !this.advocate.fileCertificate)) {
	            this.isFileError = true;
	            return;
	          }
	          if (!this.$refs.form.validate()) return;
	          this.step = this.step + 1;
	        }
	      }
	      if (number == 0) {
	        if (this.step == 1) {
	          return;
	        } else {
	          this.step = this.step - 1;
	        }
	      }
	    },
	    setClient: function setClient() {
	      var _this3 = this;
	
	      this.isDisabled = true;
	      this.$axios.post('auth/registration/client', {
	        phone: this.client.phone.replace(/[^\w\s]/gi, ''),
	        name: this.client.name,
	        surname: this.client.surname,
	        patronymic: this.client.patronymic,
	        email: this.client.email,
	        checkbox: this.client.checkbox,
	        checkbox2: this.client.checkbox2
	      }).then(function (res) {
	        if (res.data.cod == 200) {
	          _this3.closse();
	          _this3.$root.$emit('modal.auth', {
	            phone: _this3.client.phone
	          });
	        }
	      }).finally(function () {
	        _this3.isDisabled = false;
	      });
	    },
	    onFileChangePasport: function onFileChangePasport(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      if (!files.length) return;
	      this.advocate.filePasport = files[0];
	    },
	    onFileChangeCertificate: function onFileChangeCertificate(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      if (!files.length) return;
	      this.advocate.fileCertificate = files[0];
	    },
	    toHelp: function toHelp() {
	      this.$root.$emit('modal.help');
	      this.closse();
	    },
	    nextStep: function nextStep() {
	      if (!this.$refs.form.validate()) return;
	      if (this.isClient && this.step === 2) {
	        this.setClient();
	        return;
	      }
	      if (!this.isClient && this.step === 2 && !this.advocate.isFith && !this.advocate.isUr) {
	        return;
	      }
	      if (!this.isClient && this.step === 4 && (!this.advocate.filePasport || !this.advocate.fileCertificate)) {
	        this.isFileError = true;
	        return;
	      }
	      if (!this.isClient && this.step === 5) {
	        this.setAdvocate();
	        return;
	      }
	      this.step = this.step + 1;
	    },
	    setAdvocate: function setAdvocate() {
	      var _this4 = this;
	
	      this.isDisabled = true;
	      var formData = new FormData();
	      for (var key in this.advocate) {
	        formData.append(key, this.advocate[key]);
	      }
	      formData.append('phone', this.advocate.phone.replace(/[^\w\s]/gi, ''));
	
	      this.$axios.post('auth/registration/adv', formData, {
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      }).then(function (res) {
	        if (res.data.cod == 200) {
	          _this4.step = 6;
	        }
	      }).finally(function () {
	        _this4.isDisabled = false;
	      });
	    },
	    getDate: function getDate() {
	      var _this5 = this;
	
	      this.isLoading = true;
	      this.$axios.get('auth/registration/atribute').then(function (res) {
	        if (res.data.cod == 200) {
	          _this5.regions = res.data.result.region;
	          _this5.specializations = res.data.result.specialization;
	        }
	      }).finally(function () {
	        _this5.isLoading = false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    this.getDate();
	    this.$root.$on('modal.reg', function (res) {
	      if (res) {
	        _this6.isClient = false;
	        _this6.advocate.name = res.name;
	        _this6.advocate.email = res.email;
	        _this6.advocate.phone = res.phone;
	      }
	      _this6.modal();
	    });
	  },
	
	  watch: {
	    currentTime: function currentTime(time) {
	      if (time === 0) {
	        this.stopTimer();
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getApi', 'rules']))
	};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vuelidate = __webpack_require__(16);
	
	var _validators = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vuelidate.validationMixin],
	  validations: {
	    select: {
	      name: { required: _validators.required },
	      email: { required: _validators.required, email: _validators.email },
	      phone: { required: _validators.required, maxLength: (0, _validators.maxLength)(17) },
	
	      text: { required: _validators.required }
	    }
	  },
	  data: function data() {
	    return {
	      dialog: false,
	      isComplite: false,
	      select: {
	        name: null,
	        email: null,
	        phone: null,
	        id: null,
	        text: null,
	        file: null
	      }
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setToken', 'setUser']), {
	    modal: function modal(item) {
	      this.select = {
	        name: null,
	
	        phone: null,
	        id: null,
	        text: null,
	        file: null
	      };
	      if (item.id) {
	        this.select.id = item.id;
	      }
	      this.isComplite = false;
	      this.dialog = !this.dialog;
	    },
	    closse: function closse() {
	      this.dialog = false;
	    },
	    fileChange: function fileChange(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      if (!files.length) return;
	      this.select.file = files[0];
	    },
	    send: function send() {
	      var _this = this;
	
	      if (this.getUser) {
	        this.select.email = this.getUser.email;
	        this.select.name = this.getUser.name;
	        this.select.phone = this.getUser.phone;
	      }
	      this.$v.select.$touch();
	      if (this.$v.select.$invalid) {
	        return;
	      }
	      var formData = new FormData();
	      for (var key in this.select) {
	        formData.append(key, this.select[key]);
	      }
	      this.$axios.post('chat/new', formData, {
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      }).then(function (res) {
	        if (res.data.cod == 200) {
	          _this.select = {
	            name: null,
	            email: null,
	            phone: null,
	            id: null,
	            text: null,
	            file: null
	          };
	          _this.isComplite = true;
	          if (!_this.getUser) {
	            _this.setToken({ token: res.data.result.access_token, isRemember: true });
	            _this.setUser = res.data.result.user;
	            _this.closse();
	            location.reload();
	          }
	        }
	      }).finally(function () {});
	    }
	  }),
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.$root.$on('modal.create', function (id) {
	      _this2.modal(id);
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUser']), {
	    nameErrors: function nameErrors() {
	      var errors = [];
	      if (!this.$v.select.name.$dirty) return errors;
	      !this.$v.select.name.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    emailErrors: function emailErrors() {
	      var errors = [];
	      if (!this.$v.select.email.$dirty) return errors;
	      !this.$v.select.email.email && errors.push('Неккоректный e-mail');
	      !this.$v.select.email.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    phoneErrors: function phoneErrors() {
	      var errors = [];
	      if (!this.$v.select.phone.$dirty) return errors;
	      !this.$v.select.phone.maxLength && errors.push('Неккоректный номер');
	      !this.$v.select.phone.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    textErrors: function textErrors() {
	      var errors = [];
	      if (!this.$v.select.text.$dirty) return errors;
	      !this.$v.select.text.required && errors.push('Обязательное поле');
	      return errors;
	    }
	  }),
	  watch: {
	    isComplite: function isComplite(to, from) {
	      var _this3 = this;
	
	      if (to) {
	        setTimeout(function () {
	          _this3.isComplite = false;
	          _this3.select.name = null;
	          _this3.select.email = null;
	          _this3.select.phone = null;
	          _this3.select.id = null;
	          _this3.select.text = null;
	          _this3.select.file = null;
	          _this3.dialog = !_this3.dialog;
	        }, 3000);
	      }
	    },
	    getUser: function getUser(to, from) {
	      this.select.email = to.email;
	      this.select.name = to.name;
	      this.select.phone = to.phone;
	    }
	  }
	};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      article: [{
	        id: 1,
	        title: 'Как выбрать надежного адвоката?',
	        text: 'Каждый адвокат - юрист, но не каждый юрист - адвокат.     Нет специальных законов, регулирующих деятельность юристов. Юристы могут давать консультации, имея даже среднее юридическое образование. Их услуги не требуют особого статуса, в Российской Федерации отсутствуют организации....',
	        href: '/article/how-to-choose-a-reliable-lawyer',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }, {
	        id: 2,
	        title: 'Что такое безопасная сделка? ',
	        text: 'Безопасная сделка - опция, доступная на нашем портале. Она обеспечивает защиту интересов и адвоката, и его доверителя. В процессе оказания юридических услуг у клиента может возникнуть недовольство некачественной помощью адвоката. В свою очередь, адвокат заинтересован в том, чтобы.... ',
	        href: '/article/what-is-a-secure-transaction',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }, {
	        id: 3,
	        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
	        text: 'В жизни бывают ситуации, когда без адвоката сложно решить проблему. Люди живут своей жизнью, ходят на работу, воспитывают детей и тут .... ',
	        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }, {
	        id: 4,
	        title: 'Лжеюристы в России.',
	        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
	        href: '/article/lzheyuristi-v-rossii',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }, {
	        id: 5,
	        title: 'Что важно знать, если вас вызвали на допрос к следователю.',
	        text: 'По закону вызвать любого человека для дачи показаний может суд, следователь, дознаватель. Вызов сопровождается вручением повестки. Однако на практике следователь может ....',
	        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }]
	    };
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      article: [{
	        id: 1,
	        title: 'Как выбрать надежного адвоката?',
	        text: 'Каждый адвокат - юрист, но не каждый юрист - адвокат.     Нет специальных законов, регулирующих деятельность юристов. Юристы могут давать консультации, имея даже среднее юридическое образование. Их услуги не требуют особого статуса, в Российской Федерации отсутствуют организации....',
	        href: '/article/how-to-choose-a-reliable-lawyer',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 2,
	        title: 'Что такое безопасная сделка? ',
	        text: 'Безопасная сделка - опция, доступная на нашем портале. Она обеспечивает защиту интересов и адвоката, и его доверителя. В процессе оказания юридических услуг у клиента может возникнуть недовольство некачественной помощью адвоката. В свою очередь, адвокат заинтересован в том, чтобы.... ',
	        href: '/article/what-is-a-secure-transaction',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 3,
	        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
	        text: 'В жизни бывают ситуации, когда без адвоката сложно решить проблему. Люди живут своей жизнью, ходят на работу, воспитывают детей и тут .... ',
	        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 4,
	        title: 'Лжеюристы в России.',
	        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
	        href: '/article/lzheyuristi-v-rossii',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }]
	    };
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      article: [{
	        id: 1,
	        title: 'Как выбрать надежного адвоката?',
	        text: 'Каждый адвокат - юрист, но не каждый юрист - адвокат.     Нет специальных законов, регулирующих деятельность юристов. Юристы могут давать консультации, имея даже среднее юридическое образование. Их услуги не требуют особого статуса, в Российской Федерации отсутствуют организации....',
	        href: '/article/how-to-choose-a-reliable-lawyer',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 2,
	        title: 'Что такое безопасная сделка? ',
	        text: 'Безопасная сделка - опция, доступная на нашем портале. Она обеспечивает защиту интересов и адвоката, и его доверителя. В процессе оказания юридических услуг у клиента может возникнуть недовольство некачественной помощью адвоката. В свою очередь, адвокат заинтересован в том, чтобы.... ',
	        href: '/article/what-is-a-secure-transaction',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 3,
	        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
	        text: 'В жизни бывают ситуации, когда без адвоката сложно решить проблему. Люди живут своей жизнью, ходят на работу, воспитывают детей и тут .... ',
	        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 5,
	        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
	        text: 'По закону вызвать любого человека для дачи показаний может суд, следователь, дознаватель. Вызов сопровождается вручением повестки. Однако на практике следователь может ....',
	        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }]
	    };
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      article: [{
	        id: 2,
	        title: 'Что такое безопасная сделка? ',
	        text: 'Безопасная сделка - опция, доступная на нашем портале. Она обеспечивает защиту интересов и адвоката, и его доверителя. В процессе оказания юридических услуг у клиента может возникнуть недовольство некачественной помощью адвоката. В свою очередь, адвокат заинтересован в том, чтобы.... ',
	        href: '/article/what-is-a-secure-transaction',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 3,
	        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
	        text: 'В жизни бывают ситуации, когда без адвоката сложно решить проблему. Люди живут своей жизнью, ходят на работу, воспитывают детей и тут .... ',
	        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 4,
	        title: 'Лжеюристы в России.',
	        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
	        href: '/article/lzheyuristi-v-rossii',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 5,
	        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
	        text: 'По закону вызвать любого человека для дачи показаний может суд, следователь, дознаватель. Вызов сопровождается вручением повестки. Однако на практике следователь может ....',
	        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }]
	    };
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      article: [{
	        id: 1,
	        title: 'Как выбрать надежного адвоката?',
	        text: 'Каждый адвокат - юрист, но не каждый юрист - адвокат.     Нет специальных законов, регулирующих деятельность юристов. Юристы могут давать консультации, имея даже среднее юридическое образование. Их услуги не требуют особого статуса, в Российской Федерации отсутствуют организации....',
	        href: '/article/how-to-choose-a-reliable-lawyer',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 2,
	        title: 'Что такое безопасная сделка? ',
	        text: 'Безопасная сделка - опция, доступная на нашем портале. Она обеспечивает защиту интересов и адвоката, и его доверителя. В процессе оказания юридических услуг у клиента может возникнуть недовольство некачественной помощью адвоката. В свою очередь, адвокат заинтересован в том, чтобы.... ',
	        href: '/article/what-is-a-secure-transaction',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 4,
	        title: 'Лжеюристы в России.',
	        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
	        href: '/article/lzheyuristi-v-rossii',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 5,
	        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
	        text: 'По закону вызвать любого человека для дачи показаний может суд, следователь, дознаватель. Вызов сопровождается вручением повестки. Однако на практике следователь может ....',
	        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }]
	    };
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      article: [{
	        id: 1,
	        title: 'Как выбрать надежного адвоката?',
	        text: 'Каждый адвокат - юрист, но не каждый юрист - адвокат.     Нет специальных законов, регулирующих деятельность юристов. Юристы могут давать консультации, имея даже среднее юридическое образование. Их услуги не требуют особого статуса, в Российской Федерации отсутствуют организации....',
	        href: '/article/how-to-choose-a-reliable-lawyer',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 3,
	        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
	        text: 'В жизни бывают ситуации, когда без адвоката сложно решить проблему. Люди живут своей жизнью, ходят на работу, воспитывают детей и тут .... ',
	        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 4,
	        title: 'Лжеюристы в России.',
	        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
	        href: '/article/lzheyuristi-v-rossii',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        id: 5,
	        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
	        text: 'По закону вызвать любого человека для дачи показаний может суд, следователь, дознаватель. Вызов сопровождается вручением повестки. Однако на практике следователь может ....',
	        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }]
	    };
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vuelidate = __webpack_require__(16);
	
	var _validators = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vuelidate.validationMixin],
	  validations: {
	    select: {
	      delo: { required: _validators.required },
	      adress: { required: _validators.required },
	      uchastok: { required: _validators.required },
	      sudia: { required: _validators.required },
	      isTrue2: {
	        checked: function checked(val) {
	          return val;
	        }
	      },
	      phone: { required: _validators.required },
	      dt: { required: _validators.required },
	      fio: { required: _validators.required },
	      email: { required: _validators.required, email: _validators.email },
	      emailSud: { required: _validators.required, email: _validators.email }
	    } },
	  data: function data() {
	    return {
	      file: null,
	      isLoadDoc: false,
	      amount: 1500,
	      job_id: null,
	      menu2: false,
	      isLoad: false,
	      pay_form: null,
	      step: 1,
	      pdfBlobURL: null,
	      settings: {
	        priceСancellation: null
	      },
	      loading: {
	        uchastok: false,
	        emailSud: false
	      },
	      judges: [],
	      typeSud: [{
	        name: 'Мировой Судья',
	        id: 1
	      }, {
	        name: 'Арбитражный Судья',
	        id: 2
	      }],
	      select: {
	        adress: null,
	        uchastok: null,
	        sudia: null,
	        delo: null,
	        dt: null,
	        phone: null,
	        fio: null,
	        email: null,
	        emailSud: null,
	        isTrue: false,
	        isTrue2: false,
	        isTrue3: true,
	        uuid: null
	      },
	      photo: '/static/img/photoDoc1.svg',
	      photo2: '/static/img/photoDoc2.svg'
	    };
	  },
	  watch: {
	    uchastok: function uchastok(val) {
	      this.findJudges(val, 'adress');
	    },
	    emailSud: function emailSud(val) {
	      this.findJudges(val, 'email');
	    },
	    step: function step(to, from) {
	      var _this = this;
	
	      if (to == 5) {
	        setTimeout(function () {
	          _this.step = 1;
	        }, 7000);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.step = 1;
	
	    this.$axios.get('order/tariff').then(function (_ref) {
	      var data = _ref.data;
	
	      _this2.settings.priceСancellation = data.result.find(function (item) {
	        return item.key == 'cancellation';
	      }).meta.cost;
	    });
	
	    this.$root.$on('socket.ocr.text', function (item) {
	      if (item) {
	        var text = JSON.parse(item);
	        if (text.id[0] != _this2.job_id) {
	          return;
	        }
	        if (text.error) {
	          notify.error('Документ не распознан или неверный. Пожалуйста, введите данные вручную или загрузите другое изображение.');
	          _this2.isLoad = false;
	          _this2.step = 2;
	          return;
	        }
	        _this2.select = text;
	        _this2.isLoad = false;
	        _this2.step = 2;
	      }
	    });
	  },
	
	  methods: {
	    dowloadPdf: function dowloadPdf() {
	      this.$fileSeaver.saveAs(this.pdfBlobURL);
	
	      window.open(this.pdfBlobURL);
	    },
	    toTop: function toTop() {
	      this.$root.$emit('all.scroll');
	      $('#app-content').scrollTop(0);
	      $('#app-content_mobile').scrollTop(0);
	    },
	    findJudges: function findJudges(v, trigger) {
	      var _this3 = this;
	
	      if (v.length > 3) {
	        if (trigger == 'adress') this.loading.uchastok = true;
	        if (trigger == 'email') this.loading.emailSud = true;
	
	        this.$axios.post('ocr/judges', {
	          find: v
	        }).then(function (_ref2) {
	          var data = _ref2.data;
	
	          _this3.judges = data.result;
	        }).finally(function () {
	          _this3.$nextTick(function () {
	            if (trigger == 'adress') _this3.loading.uchastok = false;
	            if (trigger == 'email') _this3.loading.emailSud = false;
	            _this3.$nextTick(function () {
	              _this3.$nextTick(function () {
	                _this3.$refs.adresslist.maxWidth = _this3.$refs.rowuchastok.clientWidth;
	              });
	            });
	          });
	        });
	      } else {
	        this.judges = [];
	      }
	    },
	    selectJudges: function selectJudges(val) {
	      this.select.uchastok = val.adress;
	      this.select.emailSud = val.email;
	      if (val.type == 'world') {
	        this.select.sudia = 1;
	      } else {
	        this.select.sudia = 2;
	      }
	    },
	    emailSudErrors: function emailSudErrors() {
	      var errors = [];
	      if (!this.$v.select.emailSud.$dirty) return errors;
	      !this.$v.select.emailSud.email && errors.push('Неккоректный e-mail');
	      !this.$v.select.emailSud.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    emailErrors: function emailErrors() {
	      var errors = [];
	      if (!this.$v.select.email.$dirty) return errors;
	      !this.$v.select.email.email && errors.push('Неккоректный e-mail');
	      !this.$v.select.email.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    fioErrors: function fioErrors() {
	      var errors = [];
	      if (!this.$v.select.fio.$dirty) return errors;
	
	      var redex = /[А-Яа-я]{3,}.[А-Яа-я]{3,}.[А-Яа-я]{3,}/;
	      var con = redex.exec(this.select.fio);
	      if (!con) {
	        errors.push('Формат ФИО - Иванов Иван Иванович');
	      }
	      !this.$v.select.fio.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    deloErrors: function deloErrors() {
	      var errors = [];
	      if (!this.$v.select.delo.$dirty) return errors;
	      !this.$v.select.delo.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    phoneErrors: function phoneErrors() {
	      var errors = [];
	      if (!this.$v.select.phone.$dirty) return errors;
	      !this.$v.select.phone.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    dtErrors: function dtErrors() {
	      var errors = [];
	      if (!this.$v.select.dt.$dirty) return errors;
	      !this.$v.select.dt.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    adressErrors: function adressErrors() {
	      var errors = [];
	      if (!this.$v.select.adress.$dirty) return errors;
	      !this.$v.select.adress.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    uchastokErrors: function uchastokErrors() {
	      var errors = [];
	      if (!this.$v.select.uchastok.$dirty) return errors;
	      !this.$v.select.uchastok.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    sudiaErrors: function sudiaErrors() {
	      var errors = [];
	      if (!this.$v.select.sudia.$dirty) return errors;
	      !this.$v.select.sudia.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    isTrue2Errors: function isTrue2Errors() {
	      var errors = [];
	      if (!this.$v.select.isTrue2.$dirty) return errors;
	      !this.$v.select.isTrue2.checked && errors.push('Обязательное поле');
	      return errors;
	    },
	    reg: function reg() {
	      this.$root.$emit('modal.reg');
	    },
	    send: function send() {
	      var _this4 = this;
	
	      this.$v.select.$touch();
	      if (this.$v.select.$invalid) {
	        return;
	      }
	      var redex = /[А-Яа-я]{3,}.[А-Яа-я]{3,}.[А-Яа-я]{3,}/;
	      var con = redex.exec(this.select.fio);
	      if (!con) {
	        return;
	      }
	      this.select.phone = this.select.phone.replace(/[^\w\s]/gi, '');
	      var dt = new Date().getTime();
	      this.select.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = (dt + Math.random() * 16) % 16 | 0;
	        dt = Math.floor(dt / 16);
	        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	      });
	
	      this.isLoadDoc = true;
	      this.$axios.post('ocr/pdfexport', (0, _extends3.default)({}, this.select), { responseType: 'blob' }).then(function (response) {
	        _this4.pdfBlobURL = window.URL.createObjectURL(response.data);
	      }).catch(function () {}).finally(function () {
	        _this4.step = 3;
	        _this4.isLoadDoc = false;
	      });
	    },
	    toPay: function toPay() {
	      var _this5 = this;
	
	      this.step = 4;
	      this.$nextTick(function () {
	        _this5.$nextTick(function () {
	          _this5.$axios.get('yookassa/order/' + _this5.select.uuid + '/payment').then(function (_ref3) {
	            var data = _ref3.data;
	
	            var checkout = new window.YooMoneyCheckoutWidget({
	              confirmation_token: data.result.token,
	              return_url: _this5.getApi + 'yookassa/order/' + _this5.select.uuid + '/checkout',
	              error_callback: function error_callback(error) {
	                console.log(error);
	              }
	            });
	
	            checkout.render('payment-form');
	            _this5.isLoad = false;
	          });
	        });
	      });
	    },
	    sendTest: function sendTest() {
	      this.$axios.post('ocr/send', this.select).then(function (res) {}).catch(function () {}).finally(function () {});
	    },
	    nextStep: function nextStep(step) {
	      this.step = step;
	      this.toTop();
	    },
	    lastStep: function lastStep(step) {
	      this.job_id = null;
	
	      this.step = 1;
	      this.file = null;
	      this.select = {
	        adress: null,
	        uchastok: null,
	        sudia: null,
	        delo: null,
	        phone: null,
	
	        dt: null,
	        fio: null,
	        email: null,
	        emailSud: null,
	        isTrue: false
	      };
	      this.$v.$reset();
	    },
	    toCancel: function toCancel() {
	      if (this.$route.hash) this.$router.push('/cancel');
	      this.$router.push('/cancel/#info');
	    },
	    fileChange: function fileChange(e) {
	      var _this6 = this;
	
	      this.isLoad = true;
	      setTimeout(function () {
	        notify.error('Документ не распознан или неверный. Пожалуйста, введите данные вручную или загрузите другое изображение.');
	        _this6.isLoad = false;
	        _this6.step = 2;
	      }, 60000);
	      this.$root.$emit('all.scroll');
	      $('#app-content').scrollTop(0);
	      $('#app-content_mobile').scrollTop(0);
	
	      var files = e.target.files || e.dataTransfer.files;
	      if (!files.length) return;
	      this.file = files[0];
	
	      var formData = new FormData();
	      formData.append('file', files[0]);
	
	      this.$axios.post('ocr/transform', formData, {
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      }).then(function (res) {
	        if (res) {
	          _this6.job_id = res.data.result.job_id[0];
	        }
	      }).finally(function () {
	        _this6.$nextTick(function () {
	          _this6.$root.$emit('all.scroll');
	          $('#app-content').scrollTop(0);
	          $('#app-content_mobile').scrollTop(0);
	        });
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getApi']), {
	    uchastok: function uchastok() {
	      return this.select.uchastok;
	    },
	    emailSud: function emailSud() {
	      return this.select.emailSud;
	    }
	  })
	};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _advCounter = __webpack_require__(292);
	
	var _advCounter2 = _interopRequireDefault(_advCounter);
	
	var _bannerMain = __webpack_require__(293);
	
	var _bannerMain2 = _interopRequireDefault(_bannerMain);
	
	var _advCarusiel = __webpack_require__(291);
	
	var _advCarusiel2 = _interopRequireDefault(_advCarusiel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    advCarusiel: _advCarusiel2.default,
	    advCounter: _advCounter2.default,
	    bannerMain: _bannerMain2.default
	  },
	  data: function data() {
	    return {
	      isDisabled: false,
	      countOne: [2, 5, 5],
	      countTwo: [5, 6, 1],
	
	      bannerHome: [{
	        title: 'УНИКАЛЬНЫЙ СЕРВИС ПО ПОИСКУ <span style="color:#981010">АДВОКАТСКИХ УСЛУГ</span>',
	        title2: "Ваши деньги в безопасности<br/>пока адвокат не окажет услугу",
	        buttonDescription: 'Подробнее',
	        chooserDescription: 'Клиенту',
	        forUser: 'Для клиента',
	        href: '/work'
	      }, {
	        title: 'ТЫСЯЧИ КЛИЕНТОВ ИЩУТ <span style="color:#981010">АДВОКАТСКИЕ УСЛУГИ</span> У НАС НА ПОРТАЛЕ',
	        title2: 'Зарегистрируйтесь за 5 минут и начните получать новых клиентов уже сегодня',
	        buttonDescription: 'Зарегистрироваться',
	        chooserDescription: 'Адвокату',
	        forUser: 'Для адвоката',
	        href: false
	      }, {
	        title: 'ЧЕСТНОЕ И ЭФФЕКТИВНОЕ СОТРУДНИЧЕСТВО МЕЖДУ <span style="color:#981010">КЛИЕНТАМИ И АДВОКАТАМИ</span>',
	        title2: 'Узнайте подробнее как это работает',
	        buttonDescription: 'О сервисе',
	        chooserDescription: 'О сервисе',
	        forUser: 'Для всех',
	        href: '/service'
	      }],
	      adv: [{
	        img: '',
	        surname: null,
	        name: null,
	        patronimic: null
	
	      }, {
	        img: '',
	        surname: null,
	        name: null,
	        patronimic: null
	
	      }, {
	        img: '',
	        surname: '',
	        name: '',
	        patronimic: ''
	
	      }],
	      article: [{
	        title: 'Как выбрать надежного адвоката?',
	        text: 'Деятельность всех адвокатов строго регламентируется Федеральным законом «Об адвокатской деятельности и адвокатуре в Российской Федерации» (N 63-ФЗ от 31.05.2002) и Кодексом профессиональной этики адвоката....',
	        href: '/article/how-to-choose-a-reliable-lawyer',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        title: 'Что такое безопасная сделка? Разбираем на примере.',
	        text: 'В последнее время, в сферах торговли и оказания услуг популярность приобретает так называемая “безопасная сделка”. Что это такое  и чем она хороша?...',
	        href: '/article/what-is-a-secure-transaction',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
	        text: 'В этой статье мы расскажем как эффективно взаимодействовать с адвокатом, если у Вас возникла такая необходимость. О том, как выбрать подходящего адвоката и на что обратить внимание.... ',
	        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        title: 'Лжеюристы в России.',
	        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
	        href: '/article/lzheyuristi-v-rossii',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }, {
	        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
	        text: 'Если вас приглашают для проведения допроса, не надо паниковать. Это процедура может коснуться каждого. Вот что нужно знать:...',
	        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
	        img: '/static/img/show_art_all.png',
	        isHide: false
	      }],
	      nowArticle: 0,
	      news: [{
	        title: 'Как выбрать надежного адвоката?',
	        text: 'Деятельность всех адвокатов строго регламентируется Федеральным законом «Об адвокатской деятельности и адвокатуре в Российской Федерации» (N 63-ФЗ от 31.05.2002) и Кодексом профессиональной этики адвоката....',
	        href: '/article/how-to-choose-a-reliable-lawyer',
	        img: '/static/img/uristimg2.jpg',
	        isHide: false
	      }, {
	        title: 'Что такое безопасная сделка? Разбираем на примере.',
	        text: 'В последнее время, в сферах торговли и оказания услуг популярность приобретает так называемая “безопасная сделка”. Что это такое  и чем она хороша?...',
	        href: '/article/what-is-a-secure-transaction',
	        img: '/static/img/imgleft2.svg',
	        isHide: false
	      }, {
	        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
	        text: 'В этой статье мы расскажем как эффективно взаимодействовать с адвокатом, если у Вас возникла такая необходимость. О том, как выбрать подходящего адвоката и на что обратить внимание.... ',
	        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
	        img: '/static/img/imgleft3.svg',
	        isHide: false
	      }, {
	        title: 'Лжеюристы в России.',
	        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
	        href: '/article/lzheyuristi-v-rossii',
	        img: '/static/img/imgleft4.svg',
	        isHide: false
	      }, {
	        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
	        text: 'Если вас приглашают для проведения допроса, не надо паниковать. Это процедура может коснуться каждого. Вот что нужно знать:...',
	        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }],
	      nowNews: 0,
	      problem: null,
	      special: null,
	      regions: null,
	      users: [],
	      region: [],
	      specializations: [],
	      support: {
	        name: null,
	        email: null,
	        text: null
	      },
	      questions: [{
	        title: '"Мобильный адвокат" - это коллегия адвокатов?',
	        id: 1,
	        text: 'Нет, мы - сервис предоставляющий возможности клиенту быстро найти надежного адвоката, а адвокатам получать новых клиентов. На нашем портале зарегистрированы специалисты всех специализаций из разных городов и адвокатских палат'
	      }, {
	        title: 'Сервис платный?',
	        id: 2,
	        text: 'Для клиентов сервис абсолютно бесплатен. Адвокаты платят небольшую комиссию с завершенной сделки'
	      }, {
	        title: 'Как найти адвоката?',
	        id: 3,
	        text: 'Очень просто: на странице поиска укажите регион оказания услуг и специализацию. Сервис предложит Вам список адвокатов, подходящих под критерии поиска. Сначала идут адвокаты с наивысшим рейтингом. Выбирайте понравившегося адвоката и пишите ему. Кроме того, Вы также можете создать заявку в личном кабинете. В этом случае ее получат все адвокаты, подходящие под выбранные Вами критерии'
	      }, {
	        title: 'Как я могу быть уверен в надежности выбранного исполнителя?',
	        id: 4,
	        text: 'Все адвокаты перед публикацией анкеты на портале проходят модерацию и предоставляют необходимые документы (паспорт и удостоверение адвоката). Наш сайт синхронизирован с порталом Министерства Юстиции РФ, где размещен реестр действующих адвокатов. Мы тщательно проверяем данные перед тем как одобрить анкету нового адвоката. Кроме того, всем нашим клиентам мы предоставляем услугу “Безопасная сделка” - гарант того, что адвокат получит деньги только после того как будут выполнены все договоренности'
	      }, {
	        title: 'Что такое страхование адвоката?',
	        id: 5,
	        text: 'Адвокаты имеют возможность застраховать риск своей профессиональной ответственности через наш портал в аккредитованных страховых компаниях'
	      }, {
	        title: 'Как работает "Безопасная сделка"?',
	        id: 6,
	        text: 'Когда Вы оплачиваете сделку, деньги поступают не на счет адвоката, а на специальный эскроу-счет, где хранятся до завершения сделки. Адвокат получит деньги лишь тогда, когда Вы подтвердите в личном кабинете, что специалист выполнил работу.'
	      }, {
	        title: 'А что, если адвокат не выполнил работу?',
	        id: 7,
	        text: 'В этом случае Вы открываете спор в сделке. Она переходит к нашему модератору, который разбирается в подробностях. После модерации, средства возвращаются Вам обратно в полном объеме'
	      }, {
	        title: 'Я не хочу, чтобы о моем деле знали еще кто-то кроме меня и адвоката. Как Вы обеспечиваете конфиденциальность?',
	        id: 9,
	        text: 'Не переживайте, мы позаботились о защите Ваших данных. Мы не передаем данные наших пользователей третьим лицам. Все сообщения и файлы хранятся на наших серверах в зашифрованном виде. Система построена таким образом, что подробности Вашего дела доступны лишь Вам и Вашему адвокату'
	      }, {
	        title: 'Мне некогда выбирать адвоката. Мне он нужен прямо сейчас! Что я могу сделать?',
	        id: 10,
	        text: 'В этом случае воспользуйтесь услугой "Срочная помощь адвоката". В этом случае Вашу заявку получат специалисты, работающие в режиме 24/7 и оперативно на нее отреагируют'
	      }]
	    };
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.isDisabled = true;
	    this.$axios.get("auth/registration/atribute").then(function (res) {
	      _this.specializations = res.data.result.specialization;
	      _this.region = res.data.result.region;
	    }).finally(function () {
	      _this.isDisabled = false;
	    });
	    this.getAdv();
	  },
	
	  methods: {
	    getAdv: function getAdv() {
	      var _this2 = this;
	
	      this.$axios.get("adv/top").then(function (res) {
	        console.log(res);
	        _this2.adv = res.data.result.advList;
	      }).finally(function () {});
	    },
	    toSearch: function toSearch() {
	      this.$router.push({ path: 'search', force: true, query: { id: this.problem } });
	    },
	    toSearchTwoParametrs: function toSearchTwoParametrs() {
	      this.$router.push({ path: 'search', force: true, query: { id_spec: this.special, id_reg: this.regions } });
	    },
	    reg: function reg() {
	      this.$root.$emit('modal.reg');
	    },
	    changeArticle: function changeArticle(value) {
	      var index = this.article.findIndex(function (x) {
	        return x.isHide;
	      });
	
	      this.nowArticle = value;
	    },
	    changeNews: function changeNews(value) {
	      var index = this.news.findIndex(function (x) {
	        return x.isHide;
	      });
	
	      this.nowNews = value;
	    },
	    changeArticleMobile: function changeArticleMobile(value) {
	      var count = this.article.length;
	      if (value == 1) {
	        if (count == this.nowArticle + 1) {
	          this.nowArticle = 0;
	        } else {
	          this.nowArticle = this.nowArticle + 1;
	        }
	      } else {
	        if (0 > this.nowArticle - 1) {
	          this.nowArticle = count - 1;
	        } else {
	          this.nowArticle = this.nowArticle - 1;
	        }
	      }
	    },
	    sendSupport: function sendSupport() {
	      this.$axios.post('support', {
	        name: this.support.name,
	        email: this.support.email,
	        text: this.support.text,
	        phone: null,
	        title: 'Запрос обратной связи',
	        type: 'help'
	      }).then(function (_ref) {
	        var data = _ref.data;
	      });
	    },
	    changeNewsMobile: function changeNewsMobile(value) {
	      var count = this.news.length;
	      if (value == 1) {
	        if (count == this.nowNews + 1) {
	          this.nowNews = 0;
	        } else {
	          this.nowNews = this.nowNews + 1;
	        }
	      } else {
	        if (0 > this.nowNews - 1) {
	          this.nowNews = count - 1;
	        } else {
	          this.nowNews = this.nowNews - 1;
	        }
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getApi', 'getUser']))
	};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isDisabled: false,
	      adv: {
	        phone: null,
	        name: null,
	        email: null
	      }
	    };
	  },
	
	  mounted: function mounted() {},
	
	  methods: {
	    send: function send() {
	      var _this = this;
	
	      this.$axios.post('support', {
	        name: this.adv.name,
	        email: this.adv.email,
	        phone: this.adv.phone,
	        text: 'Добрый день! Прошу предоставить консультирование по услуге страхование',
	        title: 'Страхование',
	        type: 'other',
	        file: null
	      }).then(function () {
	        _this.adv = {
	          phone: null,
	          name: null,
	          email: null
	        };
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      news: [{
	        id: 1,
	        title: 'Как выбрать надежного адвоката?',
	        text: 'Когда человек сознательно или интуитивно выбирает себе в жизни какую-то цель, жизненную задачу, он невольно дает себе оценку. По тому, ради чего человек живет, можно судить и о его самооценке - низкой или высокой. Только такая цель позволяет человеку прожить свою жизнь....',
	        href: '/article/how-to-choose-a-reliable-lawyer',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }, {
	        id: 2,
	        title: 'Что такое безопасная сделка? Разбираем на примере.',
	        text: 'Когда человек сознательно или интуитивно выбирает себе в жизни какую-то цель, жизненную задачу, он невольно дает себе оценку. По тому, ради чего человек живет, можно судить и о его самооценке - низкой или высокой. Только такая цель позволяет человеку прожить свою жизнь....',
	        href: '/article/what-is-a-secure-transaction',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }, {
	        id: 3,
	        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
	        text: 'Когда человек сознательно или интуитивно выбирает себе в жизни какую-то цель, жизненную задачу, он невольно дает себе оценку. По тому, ради чего человек живет, можно судить и о его самооценке - низкой или высокой. Только такая цель позволяет человеку прожить свою жизнь....',
	        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }, {
	        id: 4,
	        title: 'Лжеюристы в России.',
	        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
	        href: '/article/lzheyuristi-v-rossii',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }, {
	        id: 6,
	        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
	        text: 'Когда человек сознательно или интуитивно выбирает себе в жизни какую-то цель, жизненную задачу, он невольно дает себе оценку. По тому, ради чего человек живет, можно судить и о его самооценке - низкой или высокой. Только такая цель позволяет человеку прожить свою жизнь....',
	        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
	        img: '/static/img/imgleft.svg',
	        isHide: false
	      }],
	      newt: {}
	    };
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _pay = __webpack_require__(294);
	
	var _pay2 = _interopRequireDefault(_pay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  mounted: function mounted() {},
	
	  methods: {},
	  components: { Pay: _pay2.default },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      pay_form: null,
	      amount: 9000,
	      payment: 123213,
	      user: {
	        phone: null,
	        email: null
	      },
	      settings: {
	        priceMonth1: null,
	        priceMonth3: null,
	        priceMonth6: null,
	        priceYear: null
	      }
	
	    };
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$axios.get('order/tariff').then(function (_ref) {
	      var data = _ref.data;
	
	      _this.settings.priceMonth1 = data.result.find(function (item) {
	        return item.key == '1M';
	      }).meta.cost;
	      _this.settings.priceMonth3 = data.result.find(function (item) {
	        return item.key == '3M';
	      }).meta.cost;
	      _this.settings.priceMonth6 = data.result.find(function (item) {
	        return item.key == '6M';
	      }).meta.cost;
	      _this.settings.priceYear = data.result.find(function (item) {
	        return item.key == '12M';
	      }).meta.cost;
	    });
	  },
	
	  watch: {
	    getUser: function getUser(to, from) {
	      this.user.email = to.email;
	      this.user.phone = to.phone;
	    }
	  },
	  methods: {
	    pay: function pay(amount) {
	      var _this2 = this;
	
	      if (this.user.phone) {
	        this.$axios.post('order/tariff', {
	          amount: amount
	        }).then(function (res) {
	          _this2.$root.$emit('modal.pay', { uuid: res.data.result.uuid });
	        });
	      } else {
	        this.$root.$emit('modal.auth');
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUser']))
	};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  mounted: function mounted() {},
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vuelidate = __webpack_require__(16);
	
	var _validators = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_vuelidate.validationMixin],
	  validations: {
	    select: {
	      region: { required: _validators.required },
	      specialization: { required: _validators.required }
	    }
	  },
	  data: function data() {
	    return {
	      isLoading: false,
	      select: {
	        region: null,
	        specialization: null
	      },
	      page: 1,
	      total: null,
	      customer1: '/static/img/customer1.png',
	      spec: [],
	      region: [],
	      advocats: []
	    };
	  },
	
	  mounted: function mounted() {
	    if (this.$route.query.id_spec) {
	      this.select.specialization = parseInt(this.$route.query.id_spec);
	    }
	    if (this.$route.query.id_reg) {
	      this.select.region = [parseInt(this.$route.query.id_reg)];
	    }
	    if (this.$route.query.id_spec && this.$route.query.id_reg) {
	      this.getAdocate();
	    }
	    if (this.$route.query.id) {
	      this.select.specialization = this.$route.query.id;
	    }
	    if (!this.$route.query.id && !this.$route.query.id_reg && !this.$route.query.id_spec) {
	      this.select = {
	        region: null,
	        specialization: null
	      };
	    }
	    this.loadDate();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getApi']), {
	    regionErrors: function regionErrors() {
	      var errors = [];
	      if (!this.$v.select.region.$dirty) return errors;
	      !this.$v.select.region.required && errors.push('Обязательное поле');
	      return errors;
	    },
	    specializationErrors: function specializationErrors() {
	      var errors = [];
	      if (!this.$v.select.specialization.$dirty) return errors;
	      !this.$v.select.specialization.required && errors.push('Обязательное поле');
	      return errors;
	    }
	  }),
	  methods: {
	    setAll: function setAll(event) {
	      var _this = this;
	
	      if (event) {
	        this.select.region = [];
	        this.region.forEach(function (item) {
	          _this.select.region.push(item.id);
	        });
	      } else {
	        this.select.region = [];
	      };
	    },
	    loadDate: function loadDate() {
	      var _this2 = this;
	
	      this.isLoading = true;
	      this.$axios.get('auth/registration/atribute').then(function (res) {
	        if (res.data.cod == 200) {
	          _this2.region = res.data.result.region;
	          _this2.spec = res.data.result.specialization;
	        }
	      }).finally(function () {
	        _this2.isLoading = false;
	      });
	    },
	    toProfile: function toProfile(item) {
	      this.$router.push({ path: 'profile', query: { id: item.uid } });
	    },
	    toCreate: function toCreate(item) {
	      this.$root.$emit('modal.create', { id: item.uid });
	    },
	    loadAdvocate: function loadAdvocate() {
	      this.page = 1;
	      this.getAdocate();
	    },
	    getAdocate: function getAdocate() {
	      var _this3 = this;
	
	      this.isLoading = true;
	      console.log(this.select);
	      this.$axios.post('adv/list?page=' + this.page, this.select).then(function (res) {
	        if (res.data.cod == 200) {
	          _this3.advocats = res.data.result.data;
	          _this3.current_page = res.data.result.current_page;
	          _this3.total = res.data.result.last_page;
	        }
	      }).finally(function () {
	        _this3.isLoading = false;
	        _this3.$nextTick(function () {
	          $('#app-content').scrollTop(0);
	          $('#app-content_mobile').scrollTop(0);
	        });
	      });
	    }
	  },
	  send: function send() {
	    if (this.getApi) {
	      this.select.region = this.getApi.region;
	      this.select.specialization = this.getApi.specialization;
	    }
	    this.$v.select.$touch();
	    if (this.$v.select.$invalid) {
	      return;
	    }
	  },
	
	  watch: {
	    page: function page(to, from) {
	      this.getAdocate();
	    }
	  }
	};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  mounted: function mounted() {},
	
	  methods: {
	    reg: function reg() {
	      this.$root.$emit('modal.reg');
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  mounted: function mounted() {},
	
	  methods: {
	    reg: function reg() {
	      this.$root.$emit('modal.reg');
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([]))
	};

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports) {

	module.exports = {"_from":"axios@^0.21.0","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"axios@^0.21.0","name":"axios","escapedName":"axios","rawSpec":"^0.21.0","saveSpec":null,"fetchSpec":"^0.21.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@^0.21.0","_where":"/app","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(239)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(121),
	  /* template */
	  __webpack_require__(349),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(230)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(122),
	  /* template */
	  __webpack_require__(340),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(259)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(123),
	  /* template */
	  __webpack_require__(369),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(226)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(124),
	  /* template */
	  __webpack_require__(336),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(260)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(125),
	  /* template */
	  __webpack_require__(370),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-a05e5914",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(268)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(126),
	  /* template */
	  __webpack_require__(378),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(244)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(127),
	  /* template */
	  __webpack_require__(354),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(264)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(129),
	  /* template */
	  __webpack_require__(374),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(251)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(130),
	  /* template */
	  __webpack_require__(361),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-6928151d",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(261)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(131),
	  /* template */
	  __webpack_require__(371),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(247)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(132),
	  /* template */
	  __webpack_require__(357),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(256)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(133),
	  /* template */
	  __webpack_require__(366),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(227)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(134),
	  /* template */
	  __webpack_require__(337),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(250)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(135),
	  /* template */
	  __webpack_require__(360),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(242)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(136),
	  /* template */
	  __webpack_require__(352),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-42d9e6c4",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(238)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(137),
	  /* template */
	  __webpack_require__(348),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-37958428",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(248)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(138),
	  /* template */
	  __webpack_require__(358),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(252)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(139),
	  /* template */
	  __webpack_require__(362),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-75a156d2",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(262)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(140),
	  /* template */
	  __webpack_require__(372),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(240)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(141),
	  /* template */
	  __webpack_require__(350),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-3926aaa0",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(233)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(144),
	  /* template */
	  __webpack_require__(343),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-1fe3484d",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(255)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(145),
	  /* template */
	  __webpack_require__(365),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-7c5f8766",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(243)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(146),
	  /* template */
	  __webpack_require__(353),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-42ff83ed",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(229)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(147),
	  /* template */
	  __webpack_require__(339),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-10f51ddf",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(228)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(148),
	  /* template */
	  __webpack_require__(338),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-0eb6abb7",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(237)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(149),
	  /* template */
	  __webpack_require__(347),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-2be36ee1",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(265)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(150),
	  /* template */
	  __webpack_require__(375),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-bbe76e0a",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(241)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(151),
	  /* template */
	  __webpack_require__(351),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-42798e86",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(263)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(152),
	  /* template */
	  __webpack_require__(373),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-b6240d24",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(234)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(153),
	  /* template */
	  __webpack_require__(344),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-205a8c34",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(235)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(154),
	  /* template */
	  __webpack_require__(345),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-23c0bcf4",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(258)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(155),
	  /* template */
	  __webpack_require__(368),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-9571bf18",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(245)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(156),
	  /* template */
	  __webpack_require__(355),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-46424766",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(257)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(142),
	  /* template */
	  __webpack_require__(367),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-84519592",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(236)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(143),
	  /* template */
	  __webpack_require__(346),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-24f7edb2",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(231)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(157),
	  /* template */
	  __webpack_require__(341),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-16ead974",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(269)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(158),
	  /* template */
	  __webpack_require__(379),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-da4d49fa",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(246)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(159),
	  /* template */
	  __webpack_require__(356),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-4851b82d",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(267)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(160),
	  /* template */
	  __webpack_require__(377),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-c10a19ca",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(271)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(161),
	  /* template */
	  __webpack_require__(381),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-eb9b9682",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(249)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(162),
	  /* template */
	  __webpack_require__(359),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(270)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(163),
	  /* template */
	  __webpack_require__(380),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-e2262f66",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(254)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(164),
	  /* template */
	  __webpack_require__(364),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-788c6d66",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(272)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(165),
	  /* template */
	  __webpack_require__(382),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-fa3226e6",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(253)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(166),
	  /* template */
	  __webpack_require__(363),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-76559e79",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(232)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(167),
	  /* template */
	  __webpack_require__(342),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-1c0a4eed",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-banner row"
	  }, [_c('div', {
	    staticClass: "col col-md-5",
	    staticStyle: {
	      "align-self": "center"
	    }
	  }, [_c('v-img', {
	    staticClass: "is-desctop",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "lazy-src": "/static/img/bannerImg.jpg",
	      "src": "/static/img/bannerImg.jpg",
	      "alt": ""
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "text-wrapper animate__animated animate__fadeIn col-md-6 col-sm-12"
	  }, [_c('div', {
	    staticClass: "banner-text__title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.arr[_vm.bannerThis].title)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "z-index": "2"
	    }
	  }, [_c('div', [_c('div', {
	    key: _vm.bannerThis,
	    staticClass: "banner-text__list-sub"
	  }, _vm._l((_vm.subTitleList), function(item, index) {
	    return _c('div', {
	      key: 'subTitleList' + item.index,
	      staticClass: "is-desctop banner-text__list-sub__item"
	    }, [_c('span', {
	      class: Number(item.index) == Number(_vm.bannerThis) ? 'selection-text' : '',
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.bannerThis = item.index
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")]), _vm._v(" "), (index + 1 < _vm.subTitleList.length) ? _c('span', {
	      staticStyle: {
	        "padding": "1em"
	      }
	    }, [_vm._v("·")]) : _vm._e()])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "banner-text__sub-title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.arr[_vm.bannerThis].title2)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "button-text"
	  }, [_c('ui_btn', {
	    staticClass: "is-desctop",
	    attrs: {
	      "type": "main-btn"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.arr[_vm.bannerThis].buttonDescription)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.bannerFunc(_vm.arr[_vm.bannerThis].href)
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('img', {
	    staticClass: "is-mobile mobile-img",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/bannerImg.jpg",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "is-mobile btn-mobile-wrapper"
	  }, [_c('ui_btn', {
	    attrs: {
	      "type": "gray-btn"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.arr[_vm.bannerThis].buttonDescription)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.bannerFunc(_vm.arr[_vm.bannerThis].href)
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row is-mobile row-mobile"
	  }, [_c('div', {
	    staticClass: "col mobile-wrapper-role"
	  }, [_c('img', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "src": "/static/img/left-banner.png"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeBanner(0)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-role"
	  }, [_vm._v("\n          " + _vm._s(_vm.arr[_vm.bannerThis].chooserDescription) + "\n        ")]), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "src": "/static/img/right-banner.png"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeBanner(1)
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui-title-text",
	    style: (_vm.style)
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('v-row', [_c('v-dialog', {
	    attrs: {
	      "content-class": "all-dialog-wrapper",
	      "persistent": ""
	    },
	    model: {
	      value: (_vm.dialog),
	      callback: function($$v) {
	        _vm.dialog = $$v
	      },
	      expression: "dialog"
	    }
	  }, [_c('v-card', [(!_vm.isLoading) ? [_c('div', {
	    staticClass: "div-wrap"
	  }, [_c('v-row', {
	    staticClass: "close-button"
	  }, [_c('v-col', [_c('img', {
	    staticClass: "closse-icon-modal",
	    attrs: {
	      "src": "/static/img/closse.svg"
	    },
	    on: {
	      "click": _vm.closse
	    }
	  })])], 1), _vm._v(" "), (_vm.step == 6) ? [_c('div', {
	    staticClass: "last-step"
	  }, [_c('div', [_c('v-row', {
	    staticClass: "img-complite-row"
	  }, [_c('v-col', {
	    staticStyle: {
	      "text-align": "-webkit-center",
	      "display": "flex",
	      "justify-content": "center"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/regComplited.svg"
	    }
	  })])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "title-text"
	  }, [_c('v-col', [_vm._v("\n                      ВАША АНКЕТА ПРОХОДИТ МОДЕРАЦИЮ\n                    ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-complite-reg"
	  }, [_c('v-col', [_vm._v("\n                      Как только анкета будет проверена, Вы получите уведомление на почту и в смс и сможете войти в личный кабинет. "), _c('br'), _vm._v("\n                      Прямо сейчас 1267 человек ищут на сайте услуги адвоката\n                    ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "row-button"
	  }, [_c('v-col', [_c('div', {
	    staticClass: "red-button width-compl",
	    on: {
	      "click": _vm.toHelp
	    }
	  }, [_vm._v(" Обратиться в поддержку")])])], 1)], 1)])] : _c('v-form', {
	    ref: "form",
	    staticClass: "wrapper-modal"
	  }, [(!(!_vm.isClient && _vm.step == 6)) ? _c('v-row', {
	    staticClass: "title-text"
	  }, [_c('v-col', [_vm._v("\n                  РЕГИСТРАЦИЯ\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
	    staticClass: "contoll-button"
	  }, [(_vm.step != 6) ? _c('v-col', [_c('img', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "src": "/static/img/left-modal.svg"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeStep(0)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-control"
	  }, [_vm._v("Шаг " + _vm._s(_vm.step))]), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "src": "/static/img/rignt-modal.svg"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeStep(1)
	      }
	    }
	  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "content-reg"
	  }, [_c('div', {
	    staticStyle: {
	      "height": "100%"
	    }
	  }, [(_vm.step == 1) ? [_c('v-row', [_c('v-col', [_c('ui_sub_title_text', {
	    staticStyle: {
	      "margin-bottom": "1em"
	    }
	  }, [_vm._v("Выберите способ регистрации")]), _vm._v(" "), _c('ui_check', {
	    attrs: {
	      "trueVal": true,
	      "falseVal": false
	    },
	    model: {
	      value: (_vm.isClient),
	      callback: function($$v) {
	        _vm.isClient = $$v
	      },
	      expression: "isClient"
	    }
	  }, [_vm._v("\n                            Я клиент\n                        ")]), _vm._v(" "), _c('ui_check', {
	    attrs: {
	      "trueVal": false,
	      "falseVal": true
	    },
	    model: {
	      value: (_vm.isClient),
	      callback: function($$v) {
	        _vm.isClient = $$v
	      },
	      expression: "isClient"
	    }
	  }, [_vm._v("\n                            Я адвокат\n                        ")])], 1)], 1)] : [(_vm.isClient) ? [_c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('ui_input', {
	    attrs: {
	      "label": "Имя",
	      "rules": _vm.rules.requared,
	      "required": ""
	    },
	    model: {
	      value: (_vm.client.name),
	      callback: function($$v) {
	        _vm.$set(_vm.client, "name", $$v)
	      },
	      expression: "client.name"
	    }
	  })], 1), _vm._v(" "), _c('v-col', [_c('ui_input', {
	    attrs: {
	      "label": "Фамилия",
	      "rules": _vm.rules.requared,
	      "required": ""
	    },
	    model: {
	      value: (_vm.client.surname),
	      callback: function($$v) {
	        _vm.$set(_vm.client, "surname", $$v)
	      },
	      expression: "client.surname"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('ui_input', {
	    attrs: {
	      "label": "Отчество"
	    },
	    model: {
	      value: (_vm.client.patronymic),
	      callback: function($$v) {
	        _vm.$set(_vm.client, "patronymic", $$v)
	      },
	      expression: "client.patronymic"
	    }
	  })], 1), _vm._v(" "), _c('v-col', [_c('ui_input', {
	    attrs: {
	      "label": "E-mail",
	      "rules": _vm.rules.email,
	      "required": ""
	    },
	    model: {
	      value: (_vm.client.email),
	      callback: function($$v) {
	        _vm.$set(_vm.client, "email", $$v)
	      },
	      expression: "client.email"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('ui_input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ('+7(###)-###-##-##'),
	      expression: "'+7(###)-###-##-##'"
	    }],
	    attrs: {
	      "label": "Телефон",
	      "placeholder": "+7(###)-###-##-##",
	      "mask": "'+7(###)-###-##-##'",
	      "rules": _vm.rules.requared,
	      "required": ""
	    },
	    model: {
	      value: (_vm.client.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.client, "phone", $$v)
	      },
	      expression: "client.phone"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-obr"
	  }, [_c('v-col', [_c('ui_check', {
	    attrs: {
	      "rules": _vm.rules.isTrue
	    },
	    model: {
	      value: (_vm.client.checkbox),
	      callback: function($$v) {
	        _vm.$set(_vm.client, "checkbox", $$v)
	      },
	      expression: "client.checkbox"
	    }
	  }, [_vm._v("\n                              Я подтверждаю согласие на обработку моих "), _c('a', {
	    staticStyle: {
	      "color": "rgb(152, 16, 16) !important",
	      "margin-left": "0.5em"
	    },
	    attrs: {
	      "href": "/privacy",
	      "target": "_blank"
	    }
	  }, [_vm._v(" персональных данных")])])], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-obr"
	  }, [_c('v-col', [_c('ui_check', {
	    attrs: {
	      "rules": _vm.rules.isTrue
	    },
	    model: {
	      value: (_vm.client.checkbox2),
	      callback: function($$v) {
	        _vm.$set(_vm.client, "checkbox2", $$v)
	      },
	      expression: "client.checkbox2"
	    }
	  }, [_vm._v("\n                              Я подтверждаю согласие с "), _c('a', {
	    staticStyle: {
	      "color": "rgb(152, 16, 16) !important"
	    },
	    attrs: {
	      "href": "/static/doc/offerta.pdf",
	      "target": "_blank"
	    }
	  }, [_vm._v("публичной офертой")])])], 1)], 1)] : _vm._e(), _vm._v(" "), (!_vm.isClient) ? [(_vm.step == 2) ? [_c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('ui_input', {
	    attrs: {
	      "label": "Имя",
	      "rules": _vm.rules.requared,
	      "required": ""
	    },
	    model: {
	      value: (_vm.advocate.name),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "name", $$v)
	      },
	      expression: "advocate.name"
	    }
	  })], 1), _vm._v(" "), _c('v-col', [_c('ui_input', {
	    attrs: {
	      "label": "Фамилия",
	      "rules": _vm.rules.requared,
	      "required": ""
	    },
	    model: {
	      value: (_vm.advocate.surname),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "surname", $$v)
	      },
	      expression: "advocate.surname"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('ui_input', {
	    attrs: {
	      "label": "Отчество"
	    },
	    model: {
	      value: (_vm.advocate.patronymic),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "patronymic", $$v)
	      },
	      expression: "advocate.patronymic"
	    }
	  })], 1), _vm._v(" "), _c('v-col', [_c('ui_input', {
	    attrs: {
	      "label": "E-mail",
	      "rules": _vm.rules.email,
	      "required": ""
	    },
	    model: {
	      value: (_vm.advocate.email),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "email", $$v)
	      },
	      expression: "advocate.email"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('ui_input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ('+7(###)-###-##-##'),
	      expression: "'+7(###)-###-##-##'"
	    }],
	    attrs: {
	      "label": "Телефон",
	      "placeholder": "+7(###)-###-##-##",
	      "mask": "+7(###)-###-##-##",
	      "rules": _vm.rules.requared,
	      "required": ""
	    },
	    model: {
	      value: (_vm.advocate.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "phone", $$v)
	      },
	      expression: "advocate.phone"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-obr"
	  }, [_c('v-col', [_c('ui_check', {
	    model: {
	      value: (_vm.advocate.isFith),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "isFith", $$v)
	      },
	      expression: "advocate.isFith"
	    }
	  }, [_vm._v("\n                                С физическими лицами\n                            ")])], 1), _vm._v(" "), _c('v-col', [_c('ui_check', {
	    model: {
	      value: (_vm.advocate.isUr),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "isUr", $$v)
	      },
	      expression: "advocate.isUr"
	    }
	  }, [_vm._v("\n                                С юридическими лицами\n                            ")])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.step == 3) ? [_c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('ui_input', {
	    attrs: {
	      "label": "Стаж работы",
	      "rules": _vm.rules.number,
	      "required": ""
	    },
	    model: {
	      value: (_vm.advocate.experience),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "experience", $$v)
	      },
	      expression: "advocate.experience"
	    }
	  })], 1), _vm._v(" "), _c('v-col', [_c('ui_input', {
	    attrs: {
	      "label": "Номер в реестре",
	      "rules": _vm.rules.requared,
	      "required": ""
	    },
	    model: {
	      value: (_vm.advocate.certificate),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "certificate", $$v)
	      },
	      expression: "advocate.certificate"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('ui_check', {
	    attrs: {
	      "details": true,
	      "value": _vm.advocate.region_id && _vm.advocate.region_id.length == _vm.regions.length ? true : false
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setAll($event)
	      }
	    }
	  }, [_vm._v("\n                                  Выбрать все\n                              ")]), _vm._v(" "), _c('ui_auto', {
	    staticStyle: {
	      "margin-top": "1em"
	    },
	    attrs: {
	      "hide_details": false,
	      "rules": _vm.rules.requared,
	      "deletable_chips": true,
	      "chips": true,
	      "multiple": true,
	      "small_chips": true,
	      "label": "Регион",
	      "items": _vm.regions
	    },
	    model: {
	      value: (_vm.advocate.region_id),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "region_id", $$v)
	      },
	      expression: "advocate.region_id"
	    }
	  })], 1), _vm._v(" "), _c('v-col', [_c('ui_check', {
	    attrs: {
	      "details": true,
	      "value": _vm.advocate.specialization && _vm.advocate.specialization.length == _vm.specializations.length ? true : false
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setAllSpec($event)
	      }
	    }
	  }, [_vm._v("\n                                Выбрать все\n                            ")]), _vm._v(" "), _c('ui_auto', {
	    staticStyle: {
	      "margin-top": "1em"
	    },
	    attrs: {
	      "hide_details": false,
	      "rules": _vm.rules.requared,
	      "deletable_chips": true,
	      "chips": true,
	      "multiple": true,
	      "small_chips": true,
	      "label": "Специализация",
	      "items": _vm.specializations
	    },
	    model: {
	      value: (_vm.advocate.specialization),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "specialization", $$v)
	      },
	      expression: "advocate.specialization"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "helper-reg"
	  }, [_c('v-col', {
	    attrs: {
	      "cols": "6"
	    }
	  }, [_vm._v("\n                            *Необходимо для привлечения клиентов в Вашем регионе\n                          ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "pre-title"
	  }, [_c('v-col', [_vm._v("\n                            Выберите используемые услуги портала:\n                          ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-obr"
	  }, [_c('v-col', [_c('ui_check', {
	    model: {
	      value: (_vm.advocate.is24h),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "is24h", $$v)
	      },
	      expression: "advocate.is24h"
	    }
	  }, [_vm._v("\n                                Готовы ли вы работать в режиме “Тревожная кнопка” 24/7\n                            ")])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.step == 4) ? [_c('v-row', [_c('v-col', [_c('v-textarea', {
	    attrs: {
	      "outlined": "",
	      "rules": _vm.rules.requared,
	      "required": "",
	      "content-class": "elevation-0",
	      "label": "Краткая информация о себе"
	    },
	    model: {
	      value: (_vm.advocate.information),
	      callback: function($$v) {
	        _vm.$set(_vm.advocate, "information", $$v)
	      },
	      expression: "advocate.information"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-obr row-dowload-button align-center"
	  }, [_c('v-col', {
	    attrs: {
	      "cols-md": "8"
	    }
	  }, [_c('ui_text', [_vm._v("\n                              Прикрепить фотографии паспорта\n                            ")]), _vm._v(" "), _c('ui_sub_text', [_vm._v("\n                              Паспортные данные НЕ публикуются в профиле. Информация нужна только для прохождения модерации на сайте во избежание случаев мошенничеств.\n                            ")])], 1), _vm._v(" "), _c('v-col', [_c('input', {
	    ref: "filePasport",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "required": "",
	      "accept": "image/png, image/jpeg",
	      "type": "file"
	    },
	    on: {
	      "change": _vm.onFileChangePasport
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "grey-button",
	    on: {
	      "click": function($event) {
	        return _vm.$refs.filePasport.click()
	      }
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm.advocate.filePasport ? _vm.advocate.filePasport.name : 'Обзор') + " "), _c('img', {
	    attrs: {
	      "src": "/static/img/dowload_icon.svg"
	    }
	  })])])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-obr row-dowload-button align-center"
	  }, [_c('v-col', {
	    attrs: {
	      "cols-md": "8"
	    }
	  }, [_c('ui_text', [_vm._v("\n                              Прикрепить фотографии удостоверения\n                            ")])], 1), _vm._v(" "), _c('v-col', [_c('input', {
	    ref: "fileCertificate",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "accept": "image/png, image/jpeg",
	      "type": "file"
	    },
	    on: {
	      "change": _vm.onFileChangeCertificate
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "grey-button",
	    on: {
	      "click": function($event) {
	        return _vm.$refs.fileCertificate.click()
	      }
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm.advocate.fileCertificate ? _vm.advocate.fileCertificate.name : 'Обзор') + " "), _c('img', {
	    attrs: {
	      "src": "/static/img/dowload_icon.svg"
	    }
	  })])])], 1), _vm._v(" "), (_vm.isFileError) ? _c('v-row', {
	    staticClass: "text-obr"
	  }, [_c('v-col', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_c('span', [_c('p', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("Обязательные поля!")])])])], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.step == 5) ? [_c('v-row', {
	    staticClass: "text-last-step"
	  }, [_c('v-col', [_c('v-row', {
	    staticClass: "text-obr"
	  }, [_c('v-col', [_c('ui_check', {
	    attrs: {
	      "rules": _vm.rules.isTrue
	    },
	    model: {
	      value: (_vm.client.isOfert),
	      callback: function($$v) {
	        _vm.$set(_vm.client, "isOfert", $$v)
	      },
	      expression: "client.isOfert"
	    }
	  }, [_vm._v("\n                                    Я подтверждаю согласие с  "), _c('a', {
	    staticStyle: {
	      "color": "rgb(152, 16, 16) !important"
	    },
	    attrs: {
	      "href": "/static/doc/offerta.pdf",
	      "target": "_blank"
	    }
	  }, [_vm._v("публичной офертой")]), _vm._v(" и "), _c('a', {
	    staticStyle: {
	      "color": "rgb(152, 16, 16) !important"
	    },
	    attrs: {
	      "href": "/polit",
	      "target": "_blank"
	    }
	  }, [_vm._v(" политикой конфиденциальности ")])])], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "adv-fio"
	  }, [_c('v-col', [_vm._v("\n                                " + _vm._s(_vm.advocate.surname + ' ' + _vm.advocate.name + ' ' + _vm.advocate.patronymic || '') + "\n                              ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
	    staticClass: "text-system-adv"
	  }, [_vm._v("Email:")]), _vm._v(_vm._s(_vm.advocate.email) + "\n                              ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
	    staticClass: "text-system-adv"
	  }, [_vm._v("Телефон:")]), _vm._v(_vm._s(_vm.advocate.phone) + "\n                              ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
	    staticClass: "text-system-adv"
	  }, [_vm._v("Регион:")]), _vm._v(" "), _vm._l((_vm.advocate.region_id), function(uReg, index) {
	    return [_vm._l((_vm.regions), function(reg) {
	      return [(uReg == reg.id) ? [_c('br', {
	        key: reg.name + uReg.name + index + 'reg'
	      }), _vm._v(" "), _c('span', {
	        key: reg.name + uReg.name + index + 'reg2'
	      }, [_vm._v("\n                                        " + _vm._s(reg.name) + "\n                                      ")])] : _vm._e()]
	    })]
	  })], 2)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
	    staticClass: "text-system-adv"
	  }, [_vm._v("Номер в реестре адвокатов:")]), _vm._v(_vm._s(_vm.advocate.certificate) + "\n                              ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
	    staticClass: "text-system-adv"
	  }, [_vm._v("Стаж:")]), _vm._v(_vm._s(_vm.advocate.experience) + "\n                              ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
	    staticClass: "text-system-adv"
	  }, [_vm._v("Предоставляемые услуги:")]), _vm._v(" "), (_vm.advocate.isFith) ? [_c('br'), _vm._v(" "), _c('span', [_vm._v("Физическим лицам")])] : _vm._e(), _vm._v(" "), (_vm.advocate.isUr) ? [_c('br'), _vm._v(" "), _c('span', [_vm._v("Юридическим лицам")])] : _vm._e()], 2)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
	    staticClass: "text-system-adv"
	  }, [_vm._v("Специализация:")]), _vm._v(" "), _vm._l((_vm.advocate.specialization), function(uSpec, index) {
	    return [_vm._l((_vm.specializations), function(spec) {
	      return [(uSpec == spec.id) ? [_c('br', {
	        key: spec.name + uSpec.name + index + 'spec'
	      }), _vm._v(" "), _c('span', {
	        key: spec.name + uSpec.name + index + 'spec2'
	      }, [_vm._v("\n                                        " + _vm._s(spec.name) + "\n                                      ")])] : _vm._e()]
	    })]
	  })], 2)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
	    staticClass: "text-system-adv"
	  }, [_vm._v("О себе:")]), _vm._v(_vm._s(_vm.advocate.information) + "\n                              ")])], 1)], 1)], 1)] : _vm._e()] : _vm._e()]], 2)]), _vm._v(" "), (_vm.step != 6) ? _c('v-row', {
	    staticClass: "row-button"
	  }, [_c('v-col', [_c('ui_btn', {
	    attrs: {
	      "icon": "icon-plus",
	      "type": "main-btn full-width",
	      "disabled": _vm.isDisabled
	    },
	    on: {
	      "click": _vm.nextStep
	    }
	  }, [_vm._v("\n                    " + _vm._s((_vm.isClient && _vm.step == 2) || (!_vm.isClient && _vm.step == 5) ? 'Зарегистрироваться' : 'Далее') + "                  \n                  ")])], 1)], 1) : _vm._e()], 1)], 2)] : _vm._e(), _vm._v(" "), (_vm.isLoading) ? [_c('div', {
	    staticClass: "wrapper-loading"
	  }, [_c('v-progress-circular', {
	    attrs: {
	      "indeterminate": "",
	      "color": "red"
	    }
	  })], 1)] : _vm._e()], 2)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('v-row', [_c('v-dialog', {
	    attrs: {
	      "content-class": "all-dialog-wrapper",
	      "persistent": ""
	    },
	    model: {
	      value: (_vm.dialog),
	      callback: function($$v) {
	        _vm.dialog = $$v
	      },
	      expression: "dialog"
	    }
	  }, [_c('v-card', [(!_vm.isLoading) ? [_c('v-row', {
	    staticClass: "close-button"
	  }, [_c('v-col', [_c('img', {
	    staticClass: "closse-icon-modal",
	    attrs: {
	      "src": "/static/img/closse.svg"
	    },
	    on: {
	      "click": _vm.closse
	    }
	  })])], 1), _vm._v(" "), _c('v-form', {
	    staticClass: "wrapper-modal"
	  }, [_c('v-row', {
	    staticClass: "title-text"
	  }, [_c('v-col', [_vm._v("\n                Оплата \n              ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-auth"
	  }, [_c('v-col', [_c('div', {
	    attrs: {
	      "id": "payment-form"
	    }
	  })])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.isLoading) ? [_c('div', {
	    staticClass: "wrapper-loading"
	  }, [_c('v-progress-circular', {
	    attrs: {
	      "indeterminate": "",
	      "color": "red"
	    }
	  })], 1)] : _vm._e()], 2)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "adv-carusiel"
	  }, [_c('div', {
	    staticClass: "grid-adv is-desctop"
	  }, [_c('div', {
	    staticClass: "left-photo"
	  }, [_c('v-avatar', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "size": "250"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeBannerAdv(false)
	      }
	    }
	  }, [_c('v-img', {
	    attrs: {
	      "lazy-src": _vm.customer1,
	      "src": _vm.adv[_vm.advBefore].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advBefore].photo)) : _vm.customer1
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "center-wrapper"
	  }, [_c('img', {
	    staticClass: "control-adv__left",
	    attrs: {
	      "src": "/static/img/adv-left.svg"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeBannerAdv(false)
	      }
	    }
	  }), _vm._v(" "), _c('v-avatar', {
	    attrs: {
	      "size": "350"
	    }
	  }, [_c('v-img', {
	    attrs: {
	      "lazy-src": _vm.customer1,
	      "src": _vm.adv[_vm.advThis].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advThis].photo)) : _vm.customer1
	    }
	  })], 1), _vm._v(" "), _c('img', {
	    staticClass: "control-adv__rigth",
	    attrs: {
	      "src": "/static/img/adv-right.svg"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeBannerAdv(true)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "info-on-this"
	  }, [_c('div', [_c('span', {
	    staticClass: "name"
	  }, [_vm._v("\n            " + _vm._s(_vm.adv[_vm.advThis].surname) + " " + _vm._s(_vm.adv[_vm.advThis].name) + " " + _vm._s(_vm.adv[_vm.advThis].patronymic) + "\n          ")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "gray-text"
	  }, [_vm._v("\n              Опыт работы: "), _c('span', {
	    staticClass: "val-text"
	  }, [_vm._v(_vm._s(_vm.adv[_vm.advThis].experience))]), _vm._v(" лет\n            ")])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "-webkit-center"
	    }
	  }, [_c('div', {
	    staticClass: "button-wrapper"
	  }, [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn full-width"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toProfile(_vm.adv[_vm.advThis])
	      }
	    }
	  }, [_vm._v("Написать")])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "right-photo"
	  }, [_c('v-avatar', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "size": "250"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeBannerAdv(true)
	      }
	    }
	  }, [_c('v-img', {
	    attrs: {
	      "lazy-src": _vm.customer1,
	      "src": _vm.adv[_vm.advLate].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advLate].photo)) : _vm.customer1
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "is-mobile mobile-wrapper"
	  }, [_c('v-avatar', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "size": "150"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeBannerAdv(false)
	      }
	    }
	  }, [_c('v-img', {
	    staticClass: "small-img",
	    attrs: {
	      "lazy-src": _vm.customer1,
	      "src": _vm.adv[_vm.advBefore].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advBefore].photo)) : _vm.customer1
	    }
	  })], 1), _vm._v(" "), _c('v-avatar', {
	    staticClass: "av-center",
	    attrs: {
	      "size": "223"
	    }
	  }, [_c('v-img', {
	    attrs: {
	      "lazy-src": _vm.customer1,
	      "src": _vm.adv[_vm.advThis].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advThis].photo)) : _vm.customer1
	    }
	  })], 1), _vm._v(" "), _c('v-avatar', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "size": "150"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeBannerAdv(true)
	      }
	    }
	  }, [_c('v-img', {
	    staticClass: "small-img",
	    attrs: {
	      "lazy-src": _vm.customer1,
	      "src": _vm.adv[_vm.advLate].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advLate].photo)) : _vm.customer1
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "is-mobile mobile-info-on-this"
	  }, [_c('div', {
	    staticStyle: {
	      "text-align": "-webkit-center",
	      "margin-top": "1em"
	    }
	  }, [_c('span', {
	    staticClass: "name"
	  }, [_vm._v("\n        " + _vm._s(_vm.adv[_vm.advThis].surname) + " " + _vm._s(_vm.adv[_vm.advThis].name) + " " + _vm._s(_vm.adv[_vm.advThis].patronymic) + "\n      ")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "gray-text"
	  }, [_vm._v("\n          Опыт работы: "), _c('span', {
	    staticClass: "val-text"
	  }, [_vm._v(_vm._s(_vm.adv[_vm.advThis].experience))]), _vm._v(" лет\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "action-button"
	  }, [_c('img', {
	    staticClass: "control-adv__left",
	    staticStyle: {
	      "width": "34px",
	      "height": "34px"
	    },
	    attrs: {
	      "src": "/static/img/adv-left.svg"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeBannerAdv(false)
	      }
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "control-adv__rigth",
	    staticStyle: {
	      "width": "34px",
	      "height": "34px"
	    },
	    attrs: {
	      "src": "/static/img/adv-right.svg"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeBannerAdv(true)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "-webkit-center"
	    }
	  }, [_c('div', {
	    staticClass: "button-wrapper"
	  }, [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toProfile(_vm.adv[_vm.advThis])
	      }
	    }
	  }, [_vm._v("Написать")])], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {}, [_c('banner-main', {
	    attrs: {
	      "arr": _vm.bannerHome
	    }
	  }), _vm._v(" "), _c('ui_title_line', {
	    attrs: {
	      "text_decoration": "underline"
	    }
	  }, [_vm._v("\n      НАЙТИ НАДЕЖНОГО АДВОКАТА ПРОСТО!\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "contact-block-wraper container"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('ui_auto', {
	    attrs: {
	      "height": "50",
	      "dense": "",
	      "filled": "",
	      "solo": "",
	      "rounded": "",
	      "label": "Опишите свою проблему",
	      "items": _vm.specializations
	    },
	    model: {
	      value: (_vm.problem),
	      callback: function($$v) {
	        _vm.problem = $$v
	      },
	      expression: "problem"
	    }
	  }), _vm._v(" "), _c('ui_btn', {
	    attrs: {
	      "type": "main-btn",
	      "disabled": _vm.isDisabled
	    },
	    on: {
	      "click": _vm.toSearch
	    }
	  }, [_vm._v("Найти адвоката")])], 1)]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      О СЕРВИСЕ\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "wrapper-about-service container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col text-wraper-home"
	  }, [_c('ui_text', [_c('p', [_vm._v("\n               Сервис \"Мобильный адвокат\" - это площадка, на которой любой пользователь может найти адвоката, отвечающего всем его требованиям, а адвокату найти новых клиентов.\n            ")]), _vm._v(" "), _c('p', {
	    staticClass: "is-desctop"
	  }, [_vm._v("\n              Отличительной особенностью сервиса является \"Безопасная Сделка\": оплачивая услуги адвоката через наш сервис, клиент может быть уверен, что его деньги в сохранности. Адвокат получает деньги только после выполнения всех договоренностей. В противном случае деньги возвращаются клиенту в полном объеме\n            ")])]), _vm._v(" "), _c('ui_text_href', {
	    staticStyle: {
	      "margin-top": "59px"
	    },
	    attrs: {
	      "href": "/service"
	    }
	  }, [_vm._v("\n            Подробнее\n          ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 counter-wrapper-home"
	  }, [_c('adv-counter', {
	    attrs: {
	      "arr": _vm.countOne,
	      "titile": "Зарегистрировано адвокатов"
	    }
	  }), _vm._v(" "), _c('adv-counter', {
	    attrs: {
	      "arr": _vm.countTwo,
	      "titile": "Успешных сделок"
	    }
	  })], 1)])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      СЕРВИС ОТМЕНЫ СУДЕБНОГО ПРИКАЗА\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "wrapper-about-service container"
	  }, [_c('div', {
	    staticClass: "row for-mobile"
	  }, [_c('div', {
	    staticClass: "col-6 jus-center"
	  }, [_c('div', {
	    staticClass: "text-home-block"
	  }, [_c('ui_text', [_vm._v("\n              Автоматическое оформление заявления об отмене судебного приказа и отправление его в суд. За 5 минут.\n            ")]), _vm._v(" "), _c('ui_text', [_c('p', {
	    staticStyle: {
	      "padding-top": "1em"
	    }
	  }, [_vm._v("\n                Стоимость услуги составит: "), _c('span', {
	    staticStyle: {
	      "font-weight": "400"
	    }
	  }, [_vm._v("1500 р.")])])])], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "padding-top": "67px",
	      "z-index": "2"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/cancel"
	    }
	  }, [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn"
	    }
	  }, [_vm._v("Отменить судебный приказ")])], 1)], 1)]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      БЕЗОПАСНАЯ СДЕЛКА\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.adv.length > 3) ? _c('ui_title_line', [_vm._v("\n      ПОПУЛЯРНЫЕ АДВОКАТЫ\n    ")]) : _vm._e(), _vm._v(" "), (_vm.adv.length > 3) ? _c('adv-carusiel', {
	    attrs: {
	      "adv": _vm.adv
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      ФИЛЬТР АДВОКАТОВ\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "filter-adv"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col acord-wrapper"
	  }, [_c('div', {
	    staticClass: "accordion",
	    attrs: {
	      "id": "accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseOne",
	      "aria-labelledby": "headingOne",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_auto', {
	    attrs: {
	      "label": "Опишите свою проблему",
	      "items": _vm.specializations
	    },
	    model: {
	      value: (_vm.special),
	      callback: function($$v) {
	        _vm.special = $$v
	      },
	      expression: "special"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseTwo",
	      "aria-labelledby": "headingTwo",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_auto', {
	    attrs: {
	      "label": " Укажите регион в котором у вас возникла проблема",
	      "items": _vm.region
	    },
	    model: {
	      value: (_vm.regions),
	      callback: function($$v) {
	        _vm.regions = $$v
	      },
	      expression: "regions"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row button-row"
	  }, [_c('ui_btn', {
	    on: {
	      "click": _vm.toSearchTwoParametrs
	    }
	  }, [_vm._v("Подобрать")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 small-wrapper"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin-bottom": "1em"
	    }
	  }, [_vm._v("ВЫ АДВОКАТ?")]), _vm._v(" "), _c('ui_text', [_vm._v("\n            Зарегистрируйтесь\n            на нашем портале всего\n            за 10 минут и начните получать обращения от клиентов уже сегодня\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "button-row-small-col"
	  }, [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn full-width"
	    },
	    on: {
	      "click": _vm.reg
	    }
	  }, [_vm._v("Зарегистрироваться")])], 1)], 1)])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      ПОЛЕЗНЫЕ СТАТЬИ\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "row arcticl-news-row"
	  }, [_c('div', {
	    staticClass: "col-md-8 jt-c"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 mobile-padd jt-c"
	  }, [_c('img', {
	    staticClass: "big-img",
	    attrs: {
	      "src": _vm.article[_vm.nowArticle].img
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7 mobile-padd col-left-text"
	  }, [_c('ui_sub_title_text', [_vm._v("\n              " + _vm._s(_vm.article[_vm.nowArticle].title) + "\n            ")]), _vm._v(" "), _c('p', [_c('ui_text', {
	    attrs: {
	      "color": "#9D9D9D"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.article[_vm.nowArticle].text) + "\n              ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "button-row"
	  }, [_c('ui_text_href', {
	    attrs: {
	      "color": "#000000",
	      "href": _vm.article[_vm.nowArticle].href
	    }
	  }, [_vm._v("\n                Подробнее\n              ")])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row is-mobile control-button"
	  }, [_c('img', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "src": "/static/img/left-banner.png"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeArticleMobile(0)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-control"
	  }, [_vm._v("Следующие статьи")]), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "src": "/static/img/right-banner.png"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeArticleMobile(1)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col is-desctop jt-c main-article__list"
	  }, [_vm._l((_vm.article), function(item, index) {
	    return [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!item.isHide),
	        expression: "!item.isHide"
	      }],
	      key: index,
	      staticClass: "row select-arcticl",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.changeArticle(index)
	        }
	      }
	    }, [_c('img', {
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      attrs: {
	        "src": "/static/img/adv-left.svg"
	      }
	    }), _vm._v(" "), _c('ui_text', [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")])], 1)]
	  })], 2)]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      ОТВЕТЫ НА РАСПРОСТРАНЕННЫЕ ВОПРОСЫ\n    ")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "filter-adv"
	  }, [_c('div', {
	    staticClass: "acord-wrapper"
	  }, [_c('div', {
	    staticClass: "accordion",
	    attrs: {
	      "id": "accordionExample"
	    }
	  }, _vm._l((_vm.questions), function(item) {
	    return _c('div', {
	      key: item.id + '-card',
	      staticClass: "card"
	    }, [_c('div', {
	      staticClass: "card-header",
	      attrs: {
	        "id": "accordionHead1"
	      }
	    }, [_c('h2', {
	      staticClass: "mb-0"
	    }, [_c('button', {
	      staticClass: "btn btn-link text-left button-flex accordion-btn",
	      attrs: {
	        "type": "button",
	        "data-toggle": "collapse",
	        "data-target": '#accordionCollapse' + item.id,
	        "aria-expanded": "true",
	        "aria-controls": 'accordionCollapse' + item.id
	      }
	    }, [_c('ui_text', {
	      staticClass: "text-accord-overwflow"
	    }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                      ")]), _vm._v(" "), _c('img', {
	      attrs: {
	        "src": "/static/img/Accord-controll.svg"
	      }
	    })], 1)])]), _vm._v(" "), _c('div', {
	      staticClass: "collapse",
	      attrs: {
	        "id": 'accordionCollapse' + item.id,
	        "aria-labelledby": 'accordionHead' + item.id,
	        "data-parent": "#accordionExample"
	      }
	    }, [_c('div', {
	      staticClass: "card-body"
	    }, [_c('ui_text', [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])], 1)])])
	  }), 0)])])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      КОНТАКТНАЯ ИНФОРМАЦИЯ\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "wrapper-contact-information container"
	  }, [_c('div', {
	    staticClass: "row justify-content-between"
	  }, [_c('div', {
	    staticClass: "col-md-5 mobile-padd"
	  }, [_c('div', {
	    staticClass: "form"
	  }, [_c('div', {
	    staticClass: "form-group row"
	  }, [_c('label', {
	    attrs: {
	      "for": "emailInput"
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.support.email),
	      expression: "support.email"
	    }],
	    staticClass: "form-control gray-input",
	    attrs: {
	      "type": "email",
	      "id": "emailInput",
	      "placeholder": "Почта"
	    },
	    domProps: {
	      "value": (_vm.support.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.support, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group row"
	  }, [_c('label', {
	    attrs: {
	      "for": "nameInput"
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.support.name),
	      expression: "support.name"
	    }],
	    staticClass: "form-control gray-input",
	    attrs: {
	      "type": "text",
	      "id": "nameInput",
	      "placeholder": "Имя"
	    },
	    domProps: {
	      "value": (_vm.support.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.support, "name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group row"
	  }, [_c('label', {
	    attrs: {
	      "for": "textareaInput"
	    }
	  }), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.support.text),
	      expression: "support.text"
	    }],
	    staticClass: "form-control gray-textarea",
	    attrs: {
	      "id": "textareaInput",
	      "placeholder": "Введите сообщение..."
	    },
	    domProps: {
	      "value": (_vm.support.text)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.support, "text", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "button-text row",
	    staticStyle: {
	      "margin-top": "0"
	    }
	  }, [_c('ui_btn', {
	    attrs: {
	      "type": "gray-btn full-width"
	    },
	    on: {
	      "click": _vm.sendSupport
	    }
	  }, [_vm._v("Оставить заявку")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 text-wraper-home contact-last"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "row margin-top-1"
	  }, [_c('ui_text', {
	    attrs: {
	      "size": "18px"
	    }
	  }, [_vm._v("\n              Уникальный сервис по поиску адвокатских услуг\n            ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row margin-top-1"
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    attrs: {
	      "src": "/static/img/icon_phone.svg"
	    }
	  }), _vm._v(" "), _c('ui_text', {
	    attrs: {
	      "size": "18px"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "tel:+74956425292"
	    }
	  }, [_vm._v("+7 (495) 64 25 292")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row margin-top-1"
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    attrs: {
	      "src": "/static/img/icon_mail_light.svg"
	    }
	  }), _vm._v(" "), _c('ui_text', {
	    attrs: {
	      "size": "18px"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "mailto: info@mobileadvokat.ru"
	    }
	  }, [_vm._v("info@mobileadvokat.ru")])])], 1), _vm._v(" "), _vm._m(6)])])])], 1), _vm._v(" "), _c('br')])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-6 mobile-no-padding"
	  }, [_c('img', {
	    staticClass: "hummer-img",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/hummer.jpg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "img-only"
	  }, [_c('img', {
	    staticClass: "is-desctop",
	    attrs: {
	      "src": "/static/img/bezopas.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "is-mobile",
	    attrs: {
	      "src": "/static/img/mobile-bezopas.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingOne"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-block btn-link text-left button-h2-text",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseOne",
	      "aria-expanded": "true",
	      "aria-controls": "collapseOne"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title"
	  }, [_vm._v("\n                      По специализации\n                      "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingTwo"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left collapsed button-h2-text",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseTwo",
	      "aria-expanded": "false",
	      "aria-controls": "collapseTwo"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title"
	  }, [_vm._v("\n                      Регион оказания услуг\n                      "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "youtube-row"
	  }, [_c('iframe', {
	    attrs: {
	      "width": "1280",
	      "height": "720",
	      "src": "https://www.youtube.com/embed/BaeNwMYJmPI",
	      "title": "YouTube video player",
	      "frameborder": "0",
	      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
	      "allowfullscreen": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [_c('img', {
	    staticClass: "logo-full",
	    attrs: {
	      "src": "/static/img/logo_full.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row margin-top-1"
	  }, [_c('a', {
	    staticStyle: {
	      "display": "flex"
	    },
	    attrs: {
	      "href": "https://wa.me/79910830833"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "36px"
	    },
	    attrs: {
	      "src": "/static/img/icon_whatsapp_black.svg"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://vk.com/mob_advokat"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "50px"
	    },
	    attrs: {
	      "src": "/static/img/vk-02-01.svg"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.youtube.com/channel/UCOyKsErmFTcl23B2ckPA0MQ"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "50px"
	    },
	    attrs: {
	      "src": "/static/img/you-02-01.svg"
	    }
	  })])])
	}]}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n      КАК ЭТО РАБОТАЕТ\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "row pre-title"
	  }, [_c('div', {
	    staticClass: "col offset-2"
	  }, [_c('ui_text', [_vm._v("\n          Найти адвоката и клиента стало гораздо легче\n        ")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row step-row"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "step"
	  }, [_c('ui_sub_title_text', [_vm._v("Шаг 1")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_c('ui_text', [_vm._v("Адвокат заполняет анкету  в личном кабинете")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "step"
	  }, [_c('ui_sub_title_text', [_vm._v("Шаг 2")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_c('ui_text', [_vm._v("Клиент просматривает анкеты и выбирает подходящего адвоката")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "step"
	  }, [_c('ui_sub_title_text', [_vm._v("Шаг 3")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_c('ui_text', [_vm._v("Клиент создает обращение с адвокатом и обсуждает условия сделки")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "step"
	  }, [_c('ui_sub_title_text', [_vm._v("Шаг 4")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_c('ui_text', [_vm._v("По завершении заказа адвокат получает оговоренную сумму")])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "offset-md-2 col padding-on-mobile"
	  }, [_c('ui_title', [_vm._v("\n          ПРЕИМУЩЕСТВА\n        ")]), _vm._v(" "), _c('ui_text', {
	    staticStyle: {
	      "margin-top": "1em"
	    }
	  }, [_vm._v("\n          Зарегистрируйтесь и начните выполнять заказы в удобное для вас время\n        ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "offset-md-1 col-md-10"
	  }, [_c('div', {
	    staticClass: "row advantage-row"
	  }, [_c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/advantage_one.svg"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "advantage"
	  }, [_c('ui_sub_title_text', [_vm._v("Безопасный сервис")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_c('ui_text', [_vm._v("Выполняйте задания с безопасной сделкой: при успешном завершении работы вы гарантированно получите оплату на карту.")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/advantage_two.svg"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "advantage"
	  }, [_c('ui_sub_title_text', [_vm._v("Свободный график")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_c('ui_text', [_vm._v("На сервисе “Мобильный адвокат” вы выполняете задания в удобное для вас время и устраиваете выходные, когда захотите.")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/advantage_three.svg"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "advantage"
	  }, [_c('ui_sub_title_text', [_vm._v("Экономия на рекламе")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_c('ui_text', [_vm._v("Больше не нужно тратить деньги на собственный сайт и рекламу.")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/advantage_four.svg"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "advantage"
	  }, [_c('ui_sub_title_text', [_vm._v("Достойный заработок")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text"
	  }, [_c('ui_text', [_vm._v("Зарабатывайте на заказах с “Мобильным адвокатом” без ограничений. Используйте сервис для подработки или начните развивать собственное дело.")])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "offset-md-2 col-md-8 button-wrapper"
	  }, [_c('ui_btn', {
	    on: {
	      "click": _vm.reg
	    }
	  }, [_vm._v("Зарегистрироваться")])], 1)])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row line"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/line_work.svg"
	    }
	  })])])])
	}]}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('v-row', [_c('v-dialog', {
	    attrs: {
	      "content-class": "all-dialog-wrapper",
	      "persistent": ""
	    },
	    model: {
	      value: (_vm.dialog),
	      callback: function($$v) {
	        _vm.dialog = $$v
	      },
	      expression: "dialog"
	    }
	  }, [_c('v-card', [_c('v-row', {
	    staticClass: "close-button"
	  }, [_c('v-col', [_c('img', {
	    staticClass: "closse-icon-modal",
	    attrs: {
	      "src": "/static/img/closse.svg"
	    },
	    on: {
	      "click": _vm.closse
	    }
	  })])], 1), _vm._v(" "), (!_vm.isComplite) ? [_c('v-form', {
	    staticClass: "wrapper-modal"
	  }, [_c('v-row', {
	    staticClass: "title-text"
	  }, [_c('v-col', [_c('ui_title', [_vm._v("ОТПРАВИТЬ ЗАЯВКУ НА СРОЧНУЮ ПОМОЩЬ")])], 1)], 1), _vm._v(" "), [(!_vm.isAuth) ? _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "color": "grey",
	      "label": "Имя"
	    },
	    model: {
	      value: (_vm.select.name),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "name", $$v)
	      },
	      expression: "select.name"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isAuth) ? _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "color": "grey",
	      "label": "Email"
	    },
	    model: {
	      value: (_vm.select.email),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "email", $$v)
	      },
	      expression: "select.email"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isAuth) ? _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ('+7(###)-###-##-##'),
	      expression: "'+7(###)-###-##-##'"
	    }],
	    attrs: {
	      "placeholder": "+7(###)-###-##-##",
	      "color": "grey",
	      "label": "Номер телефона"
	    },
	    model: {
	      value: (_vm.select.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "phone", $$v)
	      },
	      expression: "select.phone"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('ui_auto', {
	    attrs: {
	      "label": "Регион оказания услуг",
	      "items": _vm.regions
	    },
	    model: {
	      value: (_vm.select.region),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "region", $$v)
	      },
	      expression: "select.region"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-textarea', {
	    attrs: {
	      "outlined": "",
	      "content-class": "elevation-0",
	      "label": "Введите сообщение..."
	    },
	    model: {
	      value: (_vm.select.text),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "text", $$v)
	      },
	      expression: "select.text"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-obr row-dowload-button"
	  }, [_c('v-col', {
	    attrs: {
	      "cols-md": "8"
	    }
	  }, [_vm._v("\n                  Прикрепить фотографии паспорта \n                ")]), _vm._v(" "), _c('v-col', [_c('input', {
	    ref: "filePasport",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": _vm.fileChange
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "grey-button",
	    on: {
	      "click": function($event) {
	        return _vm.$refs.filePasport.click()
	      }
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.select.file ? _vm.select.file.name : 'Загрузить') + " "), _c('img', {
	    attrs: {
	      "src": "/static/img/dowload_icon.svg"
	    }
	  })])])], 1)], _vm._v(" "), _c('v-row', {
	    staticClass: "row-button"
	  }, [_c('v-col', [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn full-width"
	    },
	    on: {
	      "click": _vm.send
	    }
	  }, [_vm._v("Отправить заявку")])], 1)], 1)], 2)] : _vm._e(), _vm._v(" "), (_vm.isComplite) ? [_c('div', [_c('v-row', {
	    staticClass: "img-complite-row"
	  }, [_c('v-col', {
	    staticStyle: {
	      "text-align": "-webkit-center"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/regComplited.svg"
	    }
	  })])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "title-text"
	  }, [_c('v-col', [_vm._v("\n                ОБРАЩЕНИЕ ОТПРАВЛЕНО АДВОКАТУ\n              ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-complite-reg"
	  }, [_c('v-col', [_vm._v("\n                Вы можете просмотреть его в личном кабинете в разделе обращения. В случае, если вы еще не зарегистрированы, вы можете выполнить вход по номеру телефона, для просмотра заявки.\n              ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-complite-reg"
	  }, [_c('v-col', [_vm._v("\n                или вернуться к поиску адвокатов \n              ")])], 1)], 1)] : _vm._e()], 2)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n    СТАТЬИ\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 padding-on-mobile"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("СТАТЬИ АДВОКАТОВ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col link-art"
	  }, [_c('ul', _vm._l((_vm.article), function(item) {
	    return _c('li', {
	      key: item.id,
	      staticStyle: {
	        "margin-bottom": "1em"
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "to": item.href
	      }
	    }, [_c('ui_text', [_vm._v(_vm._s(item.title))])], 1)], 1)
	  }), 0)])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col col-md-8 offset-md-2 padding-on-mobile"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("Как выбрать надежного адвоката??")]), _vm._v(" "), _c('ui_sub_title_text', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("Каждый адвокат — юрист, но не каждый юрист — адвокат.")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col col-md-10 padding-on-mobile"
	  }, [_c('ui_text', {
	    staticClass: "body-text"
	  }, [_c('v-img', {
	    staticClass: "img-main",
	    attrs: {
	      "src": "/static/img/show_art_all.png"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Нет специальных законов, регулирующих деятельность юристов. Юристы могут давать консультации, имея даже среднее юридическое образование. Их услуги не требуют особого статуса, в Российской Федерации отсутствуют организации, которые объединяют и контролируют деятельность обычных юристов.")]), _vm._v(" "), _c('p', [_vm._v("Другое дело, адвокат — юрист с особым статусом, имеющий высшее юридическое образование, состящим членом адвокатской палаты субъекта РФ. Адвокат проходит обязательную стажировку и имеет опыт работы в сфере юриспруденции. После присвоения статуса адвоката, ему выдается удостоверение. Деятельность всех адвокатов строго регламентируется Федеральным законом «Об адвокатской деятельности и адвокатуре в Российской Федерации» (N 63-ФЗ от 31.05.2002) и Кодексом профессиональной этики адвоката.")]), _vm._v(" "), _c('p', [_vm._v("Чтобы правильно выбрать адвоката, необходимо сначала обратить внимание на наличие у него официального адвокатского статуса. Для этого следует обратиться к официальному реестру адвокатской палаты и проверить действительность его статуса, не прекращен ли он, не приостановлен. Он находится в свободном доступе в Интернете.")]), _vm._v(" "), _c('p', [_vm._v("В каждом субъекте нашей страны созданы адвокатские палаты, которые следят за тем, чтобы адвокаты добросовестно оказывали юридические услуги и не нарушали закон и нормы профессиональной этики. В случае недобросовестного выполнения адвокатом своих обязанностей, дисциплинарная комиссия коллегии и совет адвокатской палаты вправе привлечь адвоката к дисциплинарной ответственности. В этом случае адвокат рискует лишиться адвокатского статуса.")]), _vm._v(" "), _c('p', [_vm._v("Юрист же в такой коллегии состоять не может и не имеет данного статуса в принципе. Соответственно степень его ответственности не так высока как у юриста.")]), _vm._v(" "), _c('p', [_vm._v("Как ни крути, опыт - важная составляющая профессионализма. Достаточный стаж работы и юридической практики - следующий фактор, который следует учитывать в выборе вашего правозащитника. Речь идет как об общей адвокатской деятельности, так и о конкретной юридической практике по той или иной специальности.")]), _vm._v(" "), _c('p', [_vm._v("Правовая область является достаточно обширной. Регулярно в силу вступают новые законы, вносятся поправки в действующее законодательство. Разбираться на высочайшем уровне во всех отраслях сразу практически невозможно. Поэтому следует уточнить юридический профиль кандидата, в котором он имеет наибольшие успехи.")]), _vm._v(" "), _c('p', [_vm._v("При выборе адвоката, обратите внимание на то, как он ведет себя на первичной консультации и насколько вам комфортно в общении с ним. Внимательно ли он вас выслушал, вникнул ли в суть дела? Хороший адвокат задает вопросы потенциальному клиенту, может совершать записи важных обстоятельств. И еще одна черта отличающая хорошего адвоката - это способность к равноправному диалогу с вами, способность объяснить юридические сложности простым и понятным языком.")]), _vm._v(" "), _c('p', [_vm._v("Адвокат, как доктор в мире юриспруденции, должен поставить четкий диагноз вашей ситуации и объяснить вам ваши перспективы в ходе разбирательства. Избегайте адвокатов не дающих объективной оценки происходящего, учитывающей как сильные, так и слабые стороны и предполагающей разные варианты развития событий. Убеждение клиента в том, что дело пойдет исключительно по выигрышному пути - то, что должно настораживать. Кодекс профессиональной этики запрещает адвокату заранее гарантировать победу своему клиенту. Кроме того, неприемлемым является излишняя самореклама, представление себя в качестве “лучшего” или “главного” адвоката. Такие эпитеты не принято использовать в профессиональном адвокатском сообществе, в виду их неэтичности и отсутствия параметров присвоения данной оценки.")]), _vm._v(" "), _c('p', [_vm._v("Стоимость адвокатских услуг зависит от множества факторов: стажа адвоката, сложности дела, требуемых временных затрат и т.д. Здесь важно понимать что трудные дела, требующие максимальной вовлеченности, не могут стоить дешево. Это законы рынка. Порядок оплаты адвокатских услуг может быть разным. Рекомендуется заранее уточнить у адвоката все нюансы денежного вознаграждения за его деятельность. Наиболее распространенным и удобным способом является поэтапная оплата, что дает возможность клиенту разбить стоимость услуги на части и вносить деньги за каждую пройденную стадию.")])], 1)], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n    СТАТЬИ\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 padding-on-mobile"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("СТАТЬИ АДВОКАТОВ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col link-art"
	  }, [_c('ul', _vm._l((_vm.article), function(item) {
	    return _c('li', {
	      key: item.id,
	      staticStyle: {
	        "margin-bottom": "1em"
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "to": item.href
	      }
	    }, [_c('ui_text', [_vm._v(_vm._s(item.title))])], 1)], 1)
	  }), 0)])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col col-md-8 offset-md-2 padding-on-mobile"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("Как строить работу с адвокатом, чтобы достичь максимального результата?")]), _vm._v(" "), _c('ui_sub_title_text', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("Каждый адвокат — юрист, но не каждый юрист — адвокат.")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col col-md-10 padding-on-mobile"
	  }, [_c('ui_text', {
	    staticClass: "body-text"
	  }, [_c('v-img', {
	    staticClass: "img-main",
	    attrs: {
	      "src": "/static/img/show_art_all.png"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("В жизни бывают ситуации, когда без адвоката сложно решить проблему. Люди живут своей жизнью, ходят на работу, воспитывают детей и тут …повестка в суд, или в организацию пришел запрос из правоохранительных органов на представление документов.")]), _vm._v(" "), _c('p', [_vm._v("Клиент – неважно, сотрудник организации или частное лицо, -- в своей работе с адвокатом должен ориентироваться на взаимодействие с врачами. Юридическая проблема – это болезнь, а помогает ее вылечить грамотный адвокат. А еще он может дать Вам рекомендации так вести дела, чтобы Вы не «болели», т.е. юридических проблем не возникало, но для этого нужно работать с адвокатом на постоянной основе.")]), _vm._v(" "), _c('p', [_c('ui_title', [_vm._v("Наши рекомендации:")])], 1), _vm._v(" "), _c('p', [_vm._v("• Выбирайте адвоката, который специализируется на категориях дел, сходных с Вашим. Вы же не будет лечить зубы у хирурга, а сердце у офтальмолога. Юриспруденция- это обширная сфера знаний, и во всем массиве законодательства и практике его применения не разбирается ни один судья, ни адвокат, ни прокурор.")]), _vm._v(" "), _c('p', [_vm._v("• Следует максимально подробно ознакомить адвоката со всеми аспектами возникшей проблемы. Ведь врачам же описывают все симптомы недомогания. Как бы это не было трудно, стоит избегать эмоциональной окраски (хотя, куда же без этого). При этом не пытайтесь давать свою юридическую квалификацию событиям, не перегружайте адвоката фамилиями и датами (если это важно, он сам уточнит). Описав адвокату ситуацию, представив все имеющиеся у Вас документы, у Вас должен быть только один вопрос –«Как мне лучше поступить в этой ситуации?». Если документов для правильно решения у Вас не хватает, то с помощью адвоката Вы можете собрать недостающие доказательства и выбрать верную тактику (помните, что в отличие от обычных юристов, адвокат может направлять адвокатские запросы на получение сведений, которые в большинстве случае, обязательны для исполнения). Исходя из этих данных адвокат выстраивает линию защиты. Если вы не договариваете или утаиваете нюансы, знайте, что в суде вас будут ждать неприятные сюрпризы, которых можно избежать, если заранее сообщить адвокату подробности. Конфиденциальность вашей информации адвокат будет хранить, поскольку к этому его обязывает закон.")]), _vm._v(" "), _c('p', [_vm._v("• Соблюдайте достигнутые с адвокатом договоренности и тактику действий. В каком бы стрессе во время следственного действия вы не находились, помните, что вы оговорили с адвокатом и следуйте этому. Любое отклонение от выбранной тактики может иметь непредвиденные последствия. Приведем пример. Гражданин был задержан за получение взятки. После первоначальных признательных показаний ему была избрана мера пресечения в виде содержания на домашнем аресте. При расследовании данной категории дел необходимо выяснить имело ли должностное лицо соответствующие полномочия, чтобы совершать действия, за которые он потребовал взятку. В противном случае в его действиях усматривается не получение взятки, а мошенничество с использованием служебного положения, что предусматривает более легкое наказание. Исследовав должностные инструкции, допросы взяткодателей, обвиняемый и защитник решили придерживаться тактики об отсутствии полномочий и переквалифиакции содеянного на мошенничество с использованием должностного положения. В суде, услышав от обвинителя, что он в этом случае будет просить 9 лет колоний, клиент дал признательные показания, в итоге получил многомиллионный штраф.")]), _vm._v(" "), _c('p', [_vm._v("• Поскольку отношение с адвокатом носят длительный и доверительный характер, нужно быть уверенным в мотивации адвоката оказывать услуги. Заранее обговорите с адвокатом стоимость и порядок оплаты его услуг. Конкретизируйте перечень действий адвоката, который он должен сделать. Это избавит Вас и адвоката от завышенных ожиданий друг от друга и возможных конфликтов. Добросовестно оплачивайте труд адвоката, иначе он потеряет интерес к Вашему делу и будет заниматься другими делами. Наш совет: не торгуйтесь по поводу стоимоcти услуг, если в состоянии их оплатить. Жизнь показывает, что можно в моменте уговорить адвоката снизить цену своих услуг, но работа адвокат будет сделана ровно на эту же суму.")]), _vm._v(" "), _c('p', [_vm._v("Поэтому, если Вы получили от адвокат скидку, радоваться рано. Лучше попросите дополнить объем оказываемых услуг.")]), _vm._v(" "), _c('p', [_vm._v("• Если адвокат после встречи с Вами начинает обещать стопроцентный результат, ссылаться на многочисленные связи, это должно Вас насторожить. Помните, в Вашей ситуации есть всегда третье лицо – следователь, судья и т.п. Они, а не адвокат, принимают решения. адвокат лишь может пообещать Вам квалифицированную и добросовестную помощь в Вашем деле. В противном случае, Вы можете быть обмануты или стать невольно соучастником преступления.")]), _vm._v(" "), _c('p', [_vm._v("• Если Вы перестали доверять вашему адвокату, вы можете в любой момент поменять защитника или привлечь дополнительного адвоката.")])], 1)], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-row', [_c('v-col', {
	    staticClass: "wrapper-pay"
	  }, [
	    [_c('span', {
	      staticClass: "title-pay sucsess"
	    }, [_vm._v("\n        УСПЕШНО ОТПРАВЛЕНО\n      ")]), _c('br'), _vm._v(" "), _c('span', {
	      staticClass: "text-pay"
	    }, [_vm._v("\n        Отмена приказа успешно отправлена на email судьи\n      ")]), _c('br')], _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": "/"
	      }
	    }, [_c('button', {
	      staticClass: "red-button"
	    }, [_vm._v("\n        Вернуться на главную\n      ")])])
	  ], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('v-row', [_c('v-dialog', {
	    attrs: {
	      "content-class": "all-dialog-wrapper",
	      "persistent": ""
	    },
	    model: {
	      value: (_vm.dialog),
	      callback: function($$v) {
	        _vm.dialog = $$v
	      },
	      expression: "dialog"
	    }
	  }, [_c('v-card', [_c('v-row', {
	    staticClass: "close-button"
	  }, [_c('v-col', [_c('img', {
	    staticClass: "closse-icon-modal",
	    attrs: {
	      "src": "/static/img/closse.svg"
	    },
	    on: {
	      "click": _vm.closse
	    }
	  })])], 1), _vm._v(" "), (!_vm.isComplite) ? [_c('v-form', {
	    staticClass: "wrapper-modal"
	  }, [_c('v-row', {
	    staticClass: "title-text"
	  }, [_c('v-col', [_vm._v("\n              ОТПРАВИТЬ ЗАЯВКУ \n            ")])], 1), _vm._v(" "), [(!_vm.getUser) ? _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.nameErrors,
	      "required": "",
	      "color": "grey",
	      "label": "Имя"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.name.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.name),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "name", $$v)
	      },
	      expression: "select.name"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.getUser) ? _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.emailErrors,
	      "required": "",
	      "color": "grey",
	      "label": "Email"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.email.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.email.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.email),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "email", $$v)
	      },
	      expression: "select.email"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.getUser) ? _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ('+7(###)-###-##-##'),
	      expression: "'+7(###)-###-##-##'"
	    }],
	    attrs: {
	      "error-messages": _vm.phoneErrors,
	      "required": "",
	      "placeholder": "+7(###)-###-##-##",
	      "color": "grey",
	      "label": "Номер телефона"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.phone.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.phone.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "phone", $$v)
	      },
	      expression: "select.phone"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-textarea', {
	    attrs: {
	      "error-messages": _vm.textErrors,
	      "required": "",
	      "outlined": "",
	      "content-class": "elevation-0",
	      "label": "Введите сообщение..."
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.text.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.text.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.text),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "text", $$v)
	      },
	      expression: "select.text"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-obr row-dowload-button"
	  }, [_c('v-col', {
	    attrs: {
	      "cols-md": "8"
	    }
	  }, [_vm._v("\n                  Прикрепить файл\n                ")]), _vm._v(" "), _c('v-col', [_c('input', {
	    ref: "filePasport",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": _vm.fileChange
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "grey-button",
	    on: {
	      "click": function($event) {
	        return _vm.$refs.filePasport.click()
	      }
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.select.file ? _vm.select.file.name : 'Загрузить') + " "), _c('img', {
	    attrs: {
	      "src": "/static/img/dowload_icon.svg"
	    }
	  })])])], 1)], _vm._v(" "), _c('v-row', {
	    staticClass: "row-button"
	  }, [_c('v-col', [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn full-width"
	    },
	    on: {
	      "click": _vm.send
	    }
	  }, [_vm._v("Отправить заявку")])], 1)], 1)], 2)] : _vm._e(), _vm._v(" "), (_vm.isComplite) ? [_c('div', [_c('v-row', {
	    staticClass: "img-complite-row"
	  }, [_c('v-col', {
	    staticStyle: {
	      "text-align": "-webkit-center"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/regComplited.svg"
	    }
	  })])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "title-text"
	  }, [_c('v-col', [_vm._v("\n                ОБРАЩЕНИЕ ОТПРАВЛЕНО АДВОКАТУ\n              ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-complite-reg"
	  }, [_c('v-col', [_vm._v("\n                Вы можете просмотреть его в личном кабинете в разделе обращения. В случае, если вы еще не зарегистрированы, вы можете выполнить вход по номеру телефона, для просмотра заявки.\n              ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-complite-reg"
	  }, [_c('v-col', [_vm._v("\n                или вернуться к поиску адвокатов \n              ")])], 1)], 1)] : _vm._e()], 2)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "footer"
	  }, [_c('div', {
	    staticClass: "main-wrapper__footer row is-desctop"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-foot col"
	  }, [_c('div', {
	    staticClass: "item_in-col"
	  }, [_c('ui_sub_title_text', [_vm._v("О сервисе:")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "item_in-col"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/work"
	    }
	  }, [_vm._v("Как это работает?")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "item_in-col"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/privacy"
	    }
	  }, [_vm._v("Политика конфиденциальности")])], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-foot col"
	  }, [_c('div', {
	    staticClass: "item_in-col"
	  }, [_c('ui_sub_title_text', [_vm._v("Клиентам:")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "item_in-col"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/safety"
	    }
	  }, [_vm._v("Безопасная сделка")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "item_in-col"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/search"
	    }
	  }, [_vm._v("Найти адвоката")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "item_in-col"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/privacy"
	    }
	  }, [_vm._v("Политика конфиденциальности")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "item_in-col"
	  }, [_c('button', {
	    staticStyle: {
	      "border": "none !important",
	      "outline": "none !important"
	    },
	    on: {
	      "click": _vm.toApplying
	    }
	  }, [_vm._v("Срочная помощь адвоката")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-foot col"
	  }, [_c('div', {
	    staticClass: "item_in-col"
	  }, [_c('ui_sub_title_text', [_vm._v("Адвокату:")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "item_in-col"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/insurance"
	    }
	  }, [_vm._v("Страхование")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "is-mobile"
	  }, [_c('div', {
	    staticClass: "red-line"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "list-button"
	  }, [_c('div', {
	    staticClass: "button-set-footer",
	    class: _vm.setFooter === 'service' ? 'button-set-footer__active' : '',
	    on: {
	      "click": function($event) {
	        return _vm.setList('service')
	      }
	    }
	  }, [_vm._v("\n        О сервисе\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "button-set-footer",
	    class: _vm.setFooter === 'advocate' ? 'button-set-footer__active' : '',
	    on: {
	      "click": function($event) {
	        return _vm.setList('advocate')
	      }
	    }
	  }, [_vm._v("\n        Адвокату\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "button-set-footer",
	    class: _vm.setFooter === 'client' ? 'button-set-footer__active' : '',
	    on: {
	      "click": function($event) {
	        return _vm.setList('client')
	      }
	    }
	  }, [_vm._v("\n        Клиенту\n      ")])]), _vm._v(" "), (_vm.itemsList.length > 0) ? _c('div', {
	    staticClass: "list-open animate__animated animate__fadeInLeft"
	  }, _vm._l((_vm.itemsList), function(item) {
	    return _c('div', {
	      key: 'list' + item.name,
	      staticClass: "item"
	    }, [(item.href !== '/static/doc/offerta.pdf') ? _c('router-link', {
	      attrs: {
	        "to": item.href
	      }
	    }, [_vm._v(_vm._s(item.name))]) : _c('a', {
	      attrs: {
	        "target": "_blank",
	        "href": item.href
	      }
	    }, [_vm._v(_vm._s(item.name))])], 1)
	  }), 0) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "offset-md-1 col-foot col"
	  }, [_c('div', {
	    staticClass: "item_in-col logo-wrapper"
	  }, [_c('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "max-width": "100%",
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/logo_full.svg"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "item_in-col"
	  }, [_c('img', {
	    staticClass: "img-soc",
	    attrs: {
	      "src": "/static/img/icon_phone.svg"
	    }
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "tel:+74956425292"
	    }
	  }, [_vm._v("+7 (495) 64 25 292")])]), _vm._v(" "), _c('div', {
	    staticClass: "item_in-col"
	  }, [_c('img', {
	    staticClass: "img-soc",
	    attrs: {
	      "src": "/static/img/icon_mail_dark.svg"
	    }
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "mailto: info@mobileadvokat.ru"
	    }
	  }, [_vm._v("info@mobileadvokat.ru")])]), _vm._v(" "), _c('div', {
	    staticClass: "item_in-col wrapper-icons-social"
	  }, [_c('a', {
	    staticStyle: {
	      "display": "flex"
	    },
	    attrs: {
	      "href": "https://wa.me/79910830833"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "36px"
	    },
	    attrs: {
	      "src": "/static/img/icon_whatsapp_black.svg"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://vk.com/mob_advokat"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "50px"
	    },
	    attrs: {
	      "src": "/static/img/vk-02-01.svg"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.youtube.com/channel/UCOyKsErmFTcl23B2ckPA0MQ"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "50px"
	    },
	    attrs: {
	      "src": "/static/img/you-02-01.svg"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "item_in-col"
	  }, [_c('a', {
	    attrs: {
	      "href": "/static/doc/offerta.pdf",
	      "target": "_blank"
	    }
	  }, [_vm._v("Условия использования")])])
	}]}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "v-alert v-notify v-sheet theme--dark v-alert--border v-alert--border-right",
	    class: [_vm.color, {
	      'show': _vm.show
	    }],
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('div', {
	    staticClass: "v-alert__wrapper"
	  }, [_c('i', {
	    staticClass: "v-icon notranslate v-alert__icon theme--dark",
	    class: _vm.icon,
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "v-alert__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "v-alert__border v-alert__border--right"
	  }), _vm._v(" "), _c('button', {
	    staticClass: "v-alert__dismissible v-btn v-btn--flat v-btn--icon v-btn--round theme--dark v-size--small",
	    attrs: {
	      "type": "button",
	      "aria-label": "Закрыть"
	    },
	    on: {
	      "click": _vm.destroy
	    }
	  }, [_vm._m(0)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "v-btn__content"
	  }, [_c('i', {
	    staticClass: "v-icon notranslate fas fa-times-circle theme--dark",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('Auth'), _vm._v(" "), _c('Reg'), _vm._v(" "), _c('Applying'), _vm._v(" "), _c('Create'), _vm._v(" "), _c('Help'), _vm._v(" "), _c('Pay')], 1)
	},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n    СТАТЬИ\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 padding-on-mobile"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("СТАТЬИ АДВОКАТОВ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col link-art"
	  }, [_c('ul', _vm._l((_vm.article), function(item) {
	    return _c('li', {
	      key: item.id,
	      staticStyle: {
	        "margin-bottom": "1em"
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "to": item.href
	      }
	    }, [_c('ui_text', [_vm._v(_vm._s(item.title))])], 1)], 1)
	  }), 0)])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col col-md-8 offset-md-2 padding-on-mobile"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("Что важно знать,  если вас вызвали на допрос к следователю.")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col col-md-10 padding-on-mobile"
	  }, [_c('ui_text', {
	    staticClass: "body-text"
	  }, [_c('v-img', {
	    staticClass: "img-main",
	    attrs: {
	      "src": "/static/img/show_art_all.png"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("По закону вызвать любого человека для дачи показаний может суд, следователь, дознаватель. Вызов сопровождается вручением повестки. Однако на практике следователь может позвонить вам по телефону и пригласить на допрос устно. Вы вправе согласовать удобные для вас время и дату. Если допрос производится в другом регионе, следователь обязан обеспечить вам компенсацию затрат на проезд.")]), _vm._v(" "), _c('p', [_vm._v("Игнорировать требование не стоит. Следователь вправе выписать постановление о вашем приводе. Поэтому лучше не препятствовать следствию и явиться для дачи показаний в удобное для Вас время.")]), _vm._v(" "), _c('p', [_vm._v("Вы вправе узнать, по какому поводу вас вызывают. Уточните заранее, какие документы могут понадобиться на допросе и какие обстоятельства требуется вспомнить.")]), _vm._v(" "), _c('p', [_vm._v("Помните: все, что вы скажете, может иметь последствия для вас и других людей. Не забудьте: даже если вас вызвали в качестве свидетеля, в процессе допроса ваш статус может поменяться на подозреваемого или обвиняемого.")]), _vm._v(" "), _c('p', [_vm._v("• Вы имеете право взять с собой адвоката на допрос и воспользоваться его квалифицированной помощью. Заранее обсудите с адвокатом вашу линию поведения на допросе и разберите возможные варианты развития событий.")]), _vm._v(" "), _c('p', [_vm._v("• Знайте: никто не обязан свидетельствовать против себя самого, против своего супруга и близких родственников. Нередко на допросе от следователя можно услышать предложение воспользоваться ст. 51 Конституции РФ (право не свидетельствовать против себя самого, против своего супруга и близких родственников). Мотивирует это он тем, что у него и так полно доказательств Вашей причастности к преступлению и Ваши показания ему не нужны.")]), _vm._v(" "), _c('p', [_vm._v("(!) Помните, 51 статья Конституции нужна только до тех пор, пока Вы не посовещались с защитником и не выработали согласованные показания. Если подозреваемый или обвиняемый берет статью 51 Коснтитуции –это подарок для следователя, поскольку он отрабатывает только Ваше обвинение, и не обязан опровергать вашу версию.")]), _vm._v(" "), _c('p', [_vm._v("• На допросе адвокат вправе давать вам краткие консультации как наедине, так и в присутствии следователя. Адвокат пресечёт нарушение ваших прав и не допустит психологического давления на вас. Дело в том, что сотрудники правоохранительных органов опасаются проверок на предмет злоупотребления и превышения должностных полномочий, фальсификации доказательств, поэтому в присутствии адвоката ведут себя более тактично. Кроме того, любой грамотный адвокат начинает знакомство со следователем с вопросам о наличии доказательств вашей причастности к преступлению.")]), _vm._v(" "), _c('p', [_vm._v("• Адвокат может задавать свои уточняющие вопросы, помогающие вам корректнее выразить свою мысль в ходе дачи показаний.")]), _vm._v(" "), _c('p', [_vm._v("• Выбирайте адвоката, который специализируется на тех вопросах, с которыми вы столкнулись. Вам будет спокойнее если вы выберете специалиста сами, а не воспользуетесь услугами дежурного адвоката, предоставленного следствием. Задумайтесь, какая мотивация у дежурного адвоката – получить свои полторы тысячи рублей от государства за судодень, оказать услугу следователю, отбыть повинность. Дежурный адвокат не плохой, просто все ищут заработка и если Вы ему этого не даете, то у него пропадает интерес помогать Вам. В последнем случае есть опасность того, что защитник работает не на ваши интересы.")]), _vm._v(" "), _c('p', [_vm._v("• Никогда не подписывайте протокол допроса, не прочитав его внимательно и не уточнив у адвоката всё, что вам осталось непонятным.")]), _vm._v(" "), _c('p', [_vm._v("• Очень важно, какие первоначальные показания Вы даете в присутствии адвоката. Суды практически всегда используют формулировку: оснований не доверять первоначальным объяснениям заявителя не имеется. Изменение своих показаний суд расценивает, как избранный способ защиты, с целью уклонения от ответственности за совершенное деяние. Поэтому, если Вы не признаете свою вину, то необходимо это сделать на первоначальном допросе. Другое дело, когда сначала Вы вины не признавали, а потом решили признать. Тут суд будет руководствоваться Вашими признательными показаниями.")])], 1)], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-app', [_c('div', {
	    staticClass: "row all",
	    staticStyle: {
	      "max-width": "100%"
	    }
	  }, [_c('Menu', {
	    ref: "menu"
	  }), _vm._v(" "), _c('div', {
	    ref: "content",
	    staticClass: "col all-col",
	    attrs: {
	      "id": "app-content"
	    }
	  }, [_c('Header'), _vm._v(" "), _c('Modal'), _vm._v(" "), _c('v-btn', {
	    staticClass: "botton-top-app",
	    staticStyle: {
	      "outline": "none"
	    },
	    attrs: {
	      "fab": "",
	      "dark": "",
	      "fixed": "",
	      "bottom": "",
	      "right": "",
	      "color": "#981010"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$refs.content.scrollTop = 0, _vm.$refs.content_mobile.scrollTop = 0, _vm.$root.$emit('all.scroll')
	      }
	    }
	  }, [_c('v-icon', [_vm._v("keyboard_arrow_up")])], 1), _vm._v(" "), [(_vm.isButton) ? _c('div', {
	    staticClass: "row is-mobile full-with-r-button",
	    staticStyle: {
	      "height": "34px"
	    }
	  }, [_c('div', {
	    staticClass: "col col-in-r-button"
	  }, [_c('span', {
	    staticClass: "text-r-button",
	    on: {
	      "click": function($event) {
	        _vm.$root.$emit('modal.applying'), _vm.isButton = false;
	      }
	    }
	  }, [_vm._v("\n              Срочная помощь адвоката\n            ")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.isButton = !_vm.isButton
	      }
	    }
	  }, [_vm._v("\n              X\n            ")])])]) : _vm._e()], _vm._v(" "), _c('div', {
	    ref: "content_mobile",
	    staticClass: "content-main",
	    attrs: {
	      "id": "app-content_mobile"
	    }
	  }, [_c('router-view', {
	    key: _vm.$route.params.id,
	    attrs: {
	      "id": "all_content"
	    }
	  })], 1), _vm._v(" "), (_vm.$route.meta.name != 'info') ? _c('Footer') : _vm._e()], 2)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('v-row', [_c('v-dialog', {
	    attrs: {
	      "content-class": "all-dialog-wrapper",
	      "persistent": ""
	    },
	    model: {
	      value: (_vm.dialog),
	      callback: function($$v) {
	        _vm.dialog = $$v
	      },
	      expression: "dialog"
	    }
	  }, [_c('v-card', [_c('v-row', {
	    staticClass: "close-button"
	  }, [_c('v-col', [_c('img', {
	    staticClass: "closse-icon-modal",
	    attrs: {
	      "src": "/static/img/closse.svg"
	    },
	    on: {
	      "click": _vm.closse
	    }
	  })])], 1), _vm._v(" "), _c('v-form', {
	    ref: "form",
	    staticClass: "wrapper-modal"
	  }, [_c('v-row', {
	    staticClass: "title-text"
	  }, [_c('v-col', [_vm._v("\n              Отправить обращение\n            ")])], 1), _vm._v(" "), (!_vm.isAuth) ? _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "rules": _vm.rules.requared,
	      "color": "grey",
	      "label": "Имя"
	    },
	    model: {
	      value: (_vm.select.name),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "name", $$v)
	      },
	      expression: "select.name"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isAuth) ? _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "rules": _vm.rules.requared,
	      "color": "grey",
	      "label": "Email"
	    },
	    model: {
	      value: (_vm.select.email),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "email", $$v)
	      },
	      expression: "select.email"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isAuth) ? _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ('+7(###)-###-##-##'),
	      expression: "'+7(###)-###-##-##'"
	    }],
	    attrs: {
	      "rules": _vm.rules.requared,
	      "placeholder": "+7(###)-###-##-##",
	      "color": "grey",
	      "label": "Номер телефона"
	    },
	    model: {
	      value: (_vm.select.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "phone", $$v)
	      },
	      expression: "select.phone"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "rules": _vm.rules.requared,
	      "color": "grey",
	      "label": "Тема"
	    },
	    model: {
	      value: (_vm.select.title),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "title", $$v)
	      },
	      expression: "select.title"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-select', {
	    attrs: {
	      "rules": _vm.rules.requared,
	      "items": _vm.items,
	      "item-value": "value",
	      "item-text": "name",
	      "label": "Выбор области проблемы",
	      "outlined": ""
	    },
	    model: {
	      value: (_vm.select.type),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "type", $$v)
	      },
	      expression: "select.type"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-textarea', {
	    attrs: {
	      "rules": _vm.rules.requared,
	      "outlined": "",
	      "content-class": "elevation-0",
	      "label": "Введите сообщение..."
	    },
	    model: {
	      value: (_vm.select.text),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "text", $$v)
	      },
	      expression: "select.text"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-obr row-dowload-button"
	  }, [_c('v-col', {
	    attrs: {
	      "cols-md": "8"
	    }
	  }, [_vm._v("\n                Прикрепить файл \n              ")]), _vm._v(" "), _c('v-col', [_c('input', {
	    ref: "filePasport",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": _vm.fileChange
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "grey-button",
	    on: {
	      "click": function($event) {
	        return _vm.$refs.filePasport.click()
	      }
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.select.file ? _vm.select.file.name : 'Загрузить') + " "), _c('img', {
	    attrs: {
	      "src": "/static/img/dowload_icon.svg"
	    }
	  })])])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "row-button"
	  }, [_c('v-col', [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn full-width"
	    },
	    on: {
	      "click": _vm.send
	    }
	  }, [_vm._v("Отправить обращение")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ("auto-contain auto-contain__" + _vm.type)
	  }, [(_vm.placeholder) ? _c('span', {
	    staticClass: "auto-placeholder"
	  }, [_vm._v(_vm._s(_vm.placeholder)), (_vm.required) ? _c('span', {
	    staticClass: "auto-placeholder__required"
	  }, [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-autocomplete', {
	    attrs: {
	      "height": _vm.height,
	      "solo": _vm.solo,
	      "dense": _vm.dense,
	      "filled": _vm.filled,
	      "rounded": _vm.rounded,
	      "chips": _vm.chips,
	      "deletable-chips": _vm.deletable_chips,
	      "multiple": _vm.multiple,
	      "small-chips": _vm.small_chips,
	      "value": _vm.value,
	      "input-value": _vm.value,
	      "hide-details": _vm.hide_details,
	      "items": _vm.items,
	      "clearable": _vm.clearable,
	      "label": _vm.label,
	      "rules": _vm.rules || [],
	      "color": _vm.color,
	      "item-value": _vm.item_value,
	      "item-text": _vm.item_text
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$emit('change', $event)
	      },
	      "input": function($event) {
	        return _vm.$emit('input', $event)
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.isLoad && !_vm.isLoadDoc) ? [(_vm.step == 1) ? [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n        ОТМЕНА ПРИКАЗА\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col li-cancel"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin-bottom": "1em"
	    }
	  }, [_vm._v("\n                  ПРЕИМУЩЕСТВА\n                ")]), _vm._v(" "), _c('ul', [_c('li', [_c('ui_text', [_vm._v("Алгоритмы заявлений для мировых судей или арбитражных судов")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Алгоритмы для отмены требований по налогам, алиментам, коммунальным платежам, кредитам и займам")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Генерация обоснования пропущенного срока по необходимости")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Автоматический подбор правильных реквизитов организаций")])], 1)]), _vm._v(" "), _c('ui_btn', {
	    on: {
	      "click": _vm.toCancel
	    }
	  }, [_vm._v("Отменить судебный приказ")])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "cancel-title"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("Информация для отмены судебного приказа и восстановления сроков")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "cancel-text"
	  }, [_c('ui_text', [_vm._v("Наш уникальный сервис позволит Вам автоматически создать и отправить в суд все необходимые документы для отмены судебного приказа. Загрузите фотографию судебного приказа или введите данные вручную - система распознает данные и подготовит материалы для отправки. После оплаты мы автоматически отправим подписанные документы в суд, а также копию письма с файлами на Вашу электронную почту.")])], 1)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 mobile-padding",
	    attrs: {
	      "id": "info"
	    }
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("\n            Бесплатное изготовление и просмотр готового документа\n          ")]), _vm._v(" "), _c('ui_text', [_vm._v("\n            Стоимость услуги по отмене судебного приказа составляет "), _c('span', {
	    staticStyle: {
	      "font-weight": "bolder"
	    }
	  }, [_vm._v(_vm._s(_vm.settings.priceСancellation) + " руб")]), _vm._v(".\n          ")]), _vm._v(" "), _c('ui_sub_title_text', {
	    staticStyle: {
	      "margin": "1em 0"
	    },
	    attrs: {
	      "name": "info"
	    }
	  }, [_vm._v("\n            В услугу отмены приказа входят:\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_c('ui_text', [_vm._v("Автоматическое распознавание изображения судебного приказа (при надлежащем качестве фото)")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Автоматическое формирование документов с подписью адвоката")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Отправка документов на электронный адрес судьи")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Отправка копии письма заявителю")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col row-dowload-button"
	  }, [_c('input', {
	    ref: "filePasport",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": _vm.fileChange
	    }
	  }), _vm._v(" "), _c('ui_btn', {
	    on: {
	      "click": function($event) {
	        return _vm.$refs.filePasport.click()
	      }
	    }
	  }, [_vm._v("\n              Загрузить фото приказа\n            ")]), _vm._v(" "), _c('ui_btn', {
	    on: {
	      "click": function($event) {
	        return _vm.nextStep(2)
	      }
	    }
	  }, [_vm._v("\n              Ввести данные вручную\n            ")])], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "margin-bottom": "50px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.select.isTrue3),
	      expression: "select.isTrue3"
	    }],
	    staticStyle: {
	      "margin-right": "1em"
	    },
	    attrs: {
	      "type": "checkbox",
	      "disabled": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.select.isTrue3) ? _vm._i(_vm.select.isTrue3, null) > -1 : (_vm.select.isTrue3)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.select.isTrue3,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.select, "isTrue3", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.select, "isTrue3", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.select, "isTrue3", $$c)
	        }
	      }
	    }
	  }), _c('ui_sub_text', [_vm._v(" Загружая файл или нажимая на кнопку \"Ввести данные вручную\", я подтверждаю согласие с "), _c('a', {
	    staticStyle: {
	      "color": "rgb(152, 16, 16) !important"
	    },
	    attrs: {
	      "href": "../../static/pdf-fiels/publicoffert2.pdf",
	      "target": "_blank"
	    }
	  }, [_vm._v(" Публичной Офертой отмены судебного приказа ")]), _vm._v(" и "), _c('a', {
	    staticStyle: {
	      "color": "rgb(152, 16, 16) !important"
	    },
	    attrs: {
	      "href": "/polit",
	      "target": "_blank"
	    }
	  }, [_vm._v(" Политикой Конфиденциальности ")])])], 1)], 1)])] : _vm._e(), _vm._v(" "), (_vm.step == 2) ? [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n        ПРОВЕРЬТЕ ВАШИ ДАННЫЕ\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col check-cancel"
	  }, [_c('ui_text', [_vm._v("Проверьте все указанные данные, при несовпадении информации просим вас вернуться назад и загрузить другую фотографию документа, либо заполнить данные самостоятельно")])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "inputs-wrapper"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col input-row"
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ('+7(###)-###-##-##'),
	      expression: "'+7(###)-###-##-##'"
	    }],
	    attrs: {
	      "outlined": "",
	      "rounded": "",
	      "error-messages": _vm.phoneErrors(),
	      "required": "",
	      "label": "Ваш номер телефона"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.phone.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.phone.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "phone", $$v)
	      },
	      expression: "select.phone"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col input-row"
	  }, [_c('v-text-field', {
	    attrs: {
	      "outlined": "",
	      "rounded": "",
	      "error-messages": _vm.emailErrors(),
	      "required": "",
	      "label": "Ваш Email"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.email.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.email.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.email),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "email", $$v)
	      },
	      expression: "select.email"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col input-row"
	  }, [_c('v-menu', {
	    ref: "menu",
	    attrs: {
	      "nudge-width": 0,
	      "close-on-content-click": true,
	      "offset-y": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "activator",
	      fn: function(ref) {
	        var on = ref.on;
	        var attrs = ref.attrs;
	
	        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-text-field', {
	          attrs: {
	            "outlined": "",
	            "rounded": "",
	            "error-messages": _vm.emailSudErrors(),
	            "required": "",
	            "hide-details": "",
	            "autocomplete": "none",
	            "label": "Email судьи"
	          },
	          on: {
	            "input": function($event) {
	              return _vm.$v.select.emailSud.$touch()
	            },
	            "blur": function($event) {
	              return _vm.$v.select.emailSud.$touch()
	            }
	          },
	          model: {
	            value: (_vm.select.emailSud),
	            callback: function($$v) {
	              _vm.$set(_vm.select, "emailSud", $$v)
	            },
	            expression: "select.emailSud"
	          }
	        })], 1)]
	      }
	    }, (_vm.select.emailSud) ? {
	      key: "default",
	      fn: function() {
	        return [_c('v-card', {
	          staticStyle: {
	            "max-height": "200px"
	          }
	        }, [(_vm.loading.emailSud) ? [_c('div', {
	          staticStyle: {
	            "justify-content": "center",
	            "display": "flex",
	            "padding": "10px"
	          }
	        }, [_c('v-progress-circular', {
	          attrs: {
	            "indeterminate": "",
	            "color": "red"
	          }
	        })], 1)] : [(_vm.judges.length > 0) ? [_c('v-list', _vm._l((_vm.judges), function(item, index) {
	          return _c('v-list-item', {
	            key: index,
	            on: {
	              "click": function($event) {
	                return _vm.selectJudges(item)
	              }
	            }
	          }, [_c('v-list-item-title', [_vm._v(_vm._s(item.email))])], 1)
	        }), 1)] : [_c('div', {
	          staticStyle: {
	            "justify-content": "center",
	            "display": "flex",
	            "padding": "10px"
	          }
	        }, [_c('i', [_vm._v("совпадений не найдено")])])]]], 2)]
	      },
	      proxy: true
	    } : null], null, true)
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    ref: "rowuchastok",
	    staticClass: "col input-row"
	  }, [_c('v-menu', {
	    ref: "menu",
	    attrs: {
	      "nudge-width": 0,
	      "close-on-content-click": true,
	      "offset-y": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "activator",
	      fn: function(ref) {
	        var on = ref.on;
	        var attrs = ref.attrs;
	
	        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-textarea', {
	          attrs: {
	            "hide-details": "",
	            "autocomplete": "none",
	            "error-messages": _vm.uchastokErrors(),
	            "required": "",
	            "outlined": "",
	            "rounded": "",
	            "content-class": "elevation-0",
	            "label": "Адресc судебного участка",
	            "placeholder": "№ 348 Савеловского района г.Москвы 125252. г.Москва. Ходынский бульвар, д.5, корп.З"
	          },
	          on: {
	            "input": function($event) {
	              return _vm.$v.select.uchastok.$touch()
	            },
	            "blur": function($event) {
	              return _vm.$v.select.uchastok.$touch()
	            }
	          },
	          model: {
	            value: (_vm.select.uchastok),
	            callback: function($$v) {
	              _vm.$set(_vm.select, "uchastok", $$v)
	            },
	            expression: "select.uchastok"
	          }
	        })], 1)]
	      }
	    }, (_vm.select.uchastok) ? {
	      key: "default",
	      fn: function() {
	        return [_c('v-card', {
	          ref: "adresslist",
	          staticStyle: {
	            "max-height": "200px"
	          }
	        }, [(_vm.loading.uchastok) ? [_c('div', {
	          staticStyle: {
	            "justify-content": "center",
	            "display": "flex",
	            "padding": "10px"
	          }
	        }, [_c('v-progress-circular', {
	          attrs: {
	            "indeterminate": "",
	            "color": "red"
	          }
	        })], 1)] : [(_vm.judges.length > 0) ? [_c('v-list', _vm._l((_vm.judges), function(item, index) {
	          return _c('v-list-item', {
	            key: index,
	            on: {
	              "click": function($event) {
	                return _vm.selectJudges(item)
	              }
	            }
	          }, [_c('div', [_c('v-list-item-title', {
	            staticClass: "text-wrap pb-2"
	          }, [_vm._v("\n                                    " + _vm._s(item.adress) + "\n                                  ")])], 1)])
	        }), 1)] : [_c('div', {
	          staticStyle: {
	            "justify-content": "center",
	            "display": "flex",
	            "padding": "10px"
	          }
	        }, [_c('i', [_vm._v("совпадений не найдено")])])]]], 2)]
	      },
	      proxy: true
	    } : null], null, true)
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col input-row"
	  }, [_c('v-textarea', {
	    attrs: {
	      "outlined": "",
	      "rounded": "",
	      "error-messages": _vm.adressErrors(),
	      "required": "",
	      "content-class": "elevation-0",
	      "label": "Адресc заявителя",
	      "placeholder": "г. Москва, Петровско-Разумовский проезд, 123 к.1, кв. 123."
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.adress.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.adress.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.adress),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "adress", $$v)
	      },
	      expression: "select.adress"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col input-row"
	  }, [_c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.fioErrors(),
	      "required": "",
	      "color": "grey",
	      "outlined": "",
	      "rounded": "",
	      "label": "ФИО заявителя"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.fio.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.fio.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.fio),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "fio", $$v)
	      },
	      expression: "select.fio"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col input-row"
	  }, [_c('v-menu', {
	    attrs: {
	      "close-on-content-click": false,
	      "nudge-right": 40,
	      "transition": "scale-transition",
	      "offset-y": "",
	      "min-width": "auto"
	    },
	    scopedSlots: _vm._u([{
	      key: "activator",
	      fn: function(ref) {
	        var on = ref.on;
	        var attrs = ref.attrs;
	
	        return [_c('v-text-field', _vm._g(_vm._b({
	          attrs: {
	            "error-messages": _vm.dtErrors(),
	            "required": "",
	            "label": "Дата судебного приказа",
	            "prepend-icon": "mdi-calendar",
	            "readonly": "",
	            "outlined": "",
	            "rounded": ""
	          },
	          on: {
	            "input": function($event) {
	              return _vm.$v.select.dt.$touch()
	            },
	            "blur": function($event) {
	              return _vm.$v.select.dt.$touch()
	            }
	          },
	          model: {
	            value: (_vm.select.dt),
	            callback: function($$v) {
	              _vm.$set(_vm.select, "dt", $$v)
	            },
	            expression: "select.dt"
	          }
	        }, 'v-text-field', attrs, false), on))]
	      }
	    }], null, false, 2866204527),
	    model: {
	      value: (_vm.menu2),
	      callback: function($$v) {
	        _vm.menu2 = $$v
	      },
	      expression: "menu2"
	    }
	  }, [_vm._v(" "), _c('v-date-picker', {
	    on: {
	      "input": function($event) {
	        _vm.menu2 = false
	      }
	    },
	    model: {
	      value: (_vm.select.dt),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "dt", $$v)
	      },
	      expression: "select.dt"
	    }
	  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col input-row"
	  }, [_c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.deloErrors(),
	      "required": "",
	      "color": "grey",
	      "outlined": "",
	      "rounded": "",
	      "label": "№ дела"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.delo.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.delo.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.delo),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "delo", $$v)
	      },
	      expression: "select.delo"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('v-row', [_c('v-col', [_c('v-select', {
	    attrs: {
	      "error-messages": _vm.sudiaErrors(),
	      "required": "",
	      "items": _vm.typeSud,
	      "item-text": 'name',
	      "item-value": 'id',
	      "input-value": "select.sudia",
	      "label": "Судья",
	      "outlined": "",
	      "rounded": ""
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.sudia.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.sudia.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.sudia),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "sudia", $$v)
	      },
	      expression: "select.sudia"
	    }
	  })], 1)], 1)], 1)]), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.select.isTrue),
	      expression: "select.isTrue"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.select.isTrue) ? _vm._i(_vm.select.isTrue, null) > -1 : (_vm.select.isTrue)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.select.isTrue,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.select, "isTrue", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.select, "isTrue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.select, "isTrue", $$c)
	        }
	      }
	    }
	  }), _vm._v("\n               Деньги уже списались/приказ вступил в силу?\n            ")]), _vm._v(" "), _c('v-col', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.select.isTrue2),
	      expression: "select.isTrue2"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "error-messages": _vm.isTrue2Errors(),
	      "required": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.select.isTrue2) ? _vm._i(_vm.select.isTrue2, null) > -1 : (_vm.select.isTrue2)
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.isTrue2.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.isTrue2.$touch()
	      },
	      "change": function($event) {
	        var $$a = _vm.select.isTrue2,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.select, "isTrue2", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.select, "isTrue2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.select, "isTrue2", $$c)
	        }
	      }
	    }
	  }), _vm._v("\n               Я согласен(на) с "), _c('a', {
	    staticStyle: {
	      "color": "rgb(152, 16, 16) !important"
	    },
	    attrs: {
	      "href": "/privacy",
	      "target": "_blank"
	    }
	  }, [_vm._v("Политикой Конфиденциальности")])])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "row row-red-grey-button"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('v-row', [_c('v-col', [_c('ui_btn', {
	    attrs: {
	      "type": "gray-btn"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.lastStep(1)
	      }
	    }
	  }, [_vm._v(" Вернуться назад")])], 1), _vm._v(" "), _c('v-col', [_c('ui_btn', {
	    on: {
	      "click": function($event) {
	        return _vm.send()
	      }
	    }
	  }, [_vm._v(" Сформировать документы")]), _vm._v(" "), (_vm.$v.select.$invalid) ? _c('span', {
	    staticStyle: {
	      "color": "darkred",
	      "font-weight": "bolder"
	    }
	  }, [_vm._v("Проверьте поля!")]) : _vm._e()], 1)], 1)], 1)])] : _vm._e(), _vm._v(" "), (_vm.step == 3) ? [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n        ПРОВЕРЬТЕ ВАШИ ДАННЫЕ\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 wrapper-iframe"
	  }, [_c('button', {
	    staticClass: "is-mobile red-button",
	    on: {
	      "click": function($event) {
	        return _vm.dowloadPdf()
	      }
	    }
	  }, [_vm._v("Открыть пдф")]), _vm._v(" "), _c('iframe', {
	    attrs: {
	      "id": "iframe",
	      "width": "100%",
	      "height": "100%",
	      "src": _vm.pdfBlobURL + '#toolbar=0'
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row row-red-grey-button last-step-row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('v-row', [_c('v-col', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.select.isTrue2),
	      expression: "select.isTrue2"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "error-messages": _vm.isTrue2Errors(),
	      "required": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.select.isTrue2) ? _vm._i(_vm.select.isTrue2, null) > -1 : (_vm.select.isTrue2)
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.isTrue2.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.isTrue2.$touch()
	      },
	      "change": function($event) {
	        var $$a = _vm.select.isTrue2,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.select, "isTrue2", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.select, "isTrue2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.select, "isTrue2", $$c)
	        }
	      }
	    }
	  }), _vm._v("\n                Нажимая на кнопку \"Оплатить и отправить документы\" я принимаю "), _c('a', {
	    staticStyle: {
	      "color": "rgb(152, 16, 16) !important"
	    },
	    attrs: {
	      "href": "../../static/pdf-fiels/publicoffert.pdf",
	      "target": "_blank"
	    }
	  }, [_vm._v(" условия Договора-оферты.")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('ui_btn', {
	    attrs: {
	      "type": "gray-btn"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep(2)
	      }
	    }
	  }, [_vm._v(" Вернуться назад")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('ui_btn', {
	    on: {
	      "click": function($event) {
	        return _vm.toPay()
	      }
	    }
	  }, [_vm._v(" Оплатить и отправить документы")])], 1)])], 1)])] : _vm._e(), _vm._v(" "), (_vm.step == 4) ? [_c('div', [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n          ОПЛАТА\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "row pre-title"
	  }, [_c('div', {
	    staticClass: "col offset-md-2 col-md-8"
	  }, [_c('v-row', [_c('v-col', [_c('div', {
	    staticClass: "col offset-md-2 col-md-8 pt-8"
	  }, [_c('div', {
	    attrs: {
	      "id": "payment-form"
	    }
	  })])])], 1)], 1)])], 1)] : _vm._e(), _vm._v(" "), (_vm.step == 5) ? [_c('div', {
	    staticClass: "wrapper-loading"
	  }, [_c('v-row', [_c('v-col', {
	    staticClass: "loading-text"
	  }, [_c('ui_text', [_vm._v("Письмо успешно отправлено на почту Мирового судьи. Копия письма отправлена на Вашу почту.")]), _c('br')], 1)], 1)], 1)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLoad) ? [_c('div', {
	    staticClass: "wrapper-loading"
	  }, [_c('v-row', [_c('v-col', {
	    staticClass: "loading-text"
	  }, [_c('ui_text', [_vm._v("Пожалуйста подождите, файл проходит проверку")]), _c('br'), _vm._v(" "), _c('v-progress-circular', {
	    attrs: {
	      "indeterminate": "",
	      "color": "red"
	    }
	  })], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.isLoadDoc) ? [_c('div', {
	    staticClass: "wrapper-loading"
	  }, [_c('v-row', [_c('v-col', {
	    staticClass: "loading-text"
	  }, [_c('ui_text', [_vm._v("Пожалуйста подождите, подготавливаем документ")]), _c('br'), _vm._v(" "), _c('v-progress-circular', {
	    attrs: {
	      "indeterminate": "",
	      "color": "red"
	    }
	  })], 1)], 1)], 1)] : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-5 col-img-cancel"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/docs.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col img-only-cancel"
	  }, [_c('img', {
	    staticClass: "is-desctop",
	    attrs: {
	      "src": "/static/img/lineImgCancel.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "is-mobile",
	    attrs: {
	      "src": "/static/img/lineImgCancelMobile.svg"
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-2 col-img-center min-conent"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/warning-icon.svg"
	    }
	  })])
	}]}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', [_vm._v("\n    СТАТЬИ\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 mr-mob"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col link-art"
	  }, [_c('ul', _vm._l((_vm.news), function(item) {
	    return _c('li', {
	      key: item.id
	    }, [_c('router-link', {
	      attrs: {
	        "to": item.href
	      }
	    }, [_vm._v(_vm._s(item.title))])], 1)
	  }), 0)])])])]), _vm._v(" "), (_vm.news) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "title-art"
	  }, [_vm._v("\n          " + _vm._s(_vm.newt.title) + "\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "text-art"
	  }, [_c('img', {
	    staticStyle: {
	      "float": "left",
	      "margin": "0em 1em 1em 0em"
	    },
	    attrs: {
	      "src": _vm.newt.img
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.newt.text) + "\n        ")])])])]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title-home pre-title"
	  }, [_c('div', {
	    staticClass: "col title-home-text"
	  }, [_vm._v("СТАТЬИ АДВОКАТОВ")])])
	}]}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui-sub-title-text",
	    style: (_vm.style)
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    key: _vm.getUser && _vm.getUser.id ? _vm.getUser.id : 'header-id',
	    staticClass: "menu"
	  }, [(!_vm.user) ? _c('div', {
	    staticClass: "all-row"
	  }, [_c('div', {
	    staticClass: "menu-item-button item-menu is-mobile"
	  }, [_c('div', {
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('img', {
	    staticClass: "is-menu-button",
	    attrs: {
	      "src": "/static/img/menu_button.svg"
	    },
	    on: {
	      "click": _vm.isMenu
	    }
	  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "item-menu",
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.isAuthModal
	    }
	  }, [_c('ui_sub_title_text', {
	    staticStyle: {
	      "margin-right": "1em"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/human.svg"
	    }
	  }), _vm._v("Вход\n        ")])], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.isRegModal
	    }
	  }, [_c('ui_sub_title_text', [_vm._v("\n          Регистрация\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
	    staticClass: "all-row-logined"
	  }, [_c('div', {
	    staticClass: "menu-item-button item-menu is-mobile"
	  }, [_c('div', {
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('img', {
	    staticClass: "is-menu-button",
	    attrs: {
	      "src": "/static/img/menu_button.svg"
	    },
	    on: {
	      "click": _vm.isMenu
	    }
	  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "left-menu is-desctop"
	  }, [_c('div', {
	    staticClass: "item-menu left-wrapper"
	  }, [_c('ui_sub_title_text', [_c('router-link', {
	    attrs: {
	      "to": "/deals"
	    }
	  }, [_vm._v(" Сделки ")])], 1), _vm._v(" "), (_vm.user.role_id == 1) ? [_c('ui_sub_title_text', [_c('router-link', {
	    staticClass: "margion-none",
	    attrs: {
	      "to": "/create_ticket"
	    }
	  }, [_vm._v("\n              Создать обращение\n            ")])], 1)] : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "margion-none",
	    attrs: {
	      "to": "/safety"
	    }
	  }, [_c('ui_sub_title_text', [_vm._v("\n            О безопасной сделке\n          ")])], 1)], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "right-menu"
	  }, [_c('div', {
	    key: _vm.rerender,
	    staticStyle: {
	      "position": "relative"
	    },
	    on: {
	      "click": _vm.letter
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/letterIcon.svg"
	    }
	  }), _vm._v(" "), (_vm.isNew) ? _c('div', {
	    staticClass: "red-point"
	  }) : _vm._e()]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/colIcon.svg"
	    },
	    on: {
	      "click": _vm.bellClick
	    }
	  }), _vm._v(" "), _c('v-menu', {
	    staticClass: "menu-header",
	    attrs: {
	      "min-width": "330",
	      "offset-y": "",
	      "transition": "scale-transition"
	    },
	    scopedSlots: _vm._u([{
	      key: "activator",
	      fn: function(ref) {
	        var on = ref.on;
	        var attrs = ref.attrs;
	
	        return [_c('v-avatar', _vm._g(_vm._b({
	          staticStyle: {
	            "vertical-align": "unset",
	            "margin-left": "3%"
	          },
	          attrs: {
	            "size": "61"
	          }
	        }, 'v-avatar', attrs, false), on), [_c('img', {
	          staticStyle: {
	            "object-fit": "cover"
	          },
	          attrs: {
	            "src": _vm.user.photo ? (_vm.getApi + "file/" + (_vm.user.photo)) : _vm.customer1,
	            "alt": ""
	          }
	        })])]
	      }
	    }], null, false, 1663641846)
	  }, [_vm._v(" "), _c('v-card', [_c('v-row', {
	    staticStyle: {
	      "padding": "15px 20px"
	    }
	  }, [_c('v-col', {
	    attrs: {
	      "cols": "3"
	    }
	  }, [_c('v-avatar', {
	    staticStyle: {
	      "vertical-align": "unset"
	    },
	    attrs: {
	      "size": "61"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "object-fit": "cover"
	    },
	    attrs: {
	      "src": _vm.user.photo ? (_vm.getApi + "file/" + (_vm.user.photo)) : _vm.customer1,
	      "alt": ""
	    }
	  })])], 1), _vm._v(" "), _c('v-col', {
	    staticClass: "name-email-user"
	  }, [_c('v-row', {
	    staticClass: "name"
	  }, [_vm._v("\n                " + _vm._s(_vm.user.name) + " " + _vm._s(_vm.user.patronymic) + "\n              ")]), _vm._v(" "), _c('v-row', {
	    staticClass: "email"
	  }, [_vm._v("\n                " + _vm._s(_vm.user.email) + "\n              ")])], 1)], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.menuitems), function(item, index) {
	    return [_c('v-divider', {
	      key: index + Math.floor(Math.random() * (10 - 1 + 1)) + 1 + item.title,
	      class: {
	        'is-mobile': item.isMobile
	      },
	      staticStyle: {
	        "margin-top": "0 !important",
	        "margin-bottom": "0  !important"
	      }
	    }), _vm._v(" "), (item.met === 'logout') ? _c('v-list-item', {
	      key: index + Math.floor(Math.random() * (10 - 1 + 1)) + 1 + item.title,
	      class: {
	        'is-mobile': item.isMobile
	      },
	      attrs: {
	        "link": ""
	      },
	      on: {
	        "click": function($event) {
	          return _vm.logout()
	        }
	      }
	    }, [_c('v-list-item-title', [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (item.met != 'logout') ? _c('v-list-item', {
	      key: index + Math.floor(Math.random() * (10 - 1 + 1)) + 1 + item.title,
	      class: {
	        'is-mobile': item.isMobile
	      },
	      attrs: {
	        "link": "",
	        "to": item.href
	      }
	    }, [_c('v-list-item-title', [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")])], 1) : _vm._e()]
	  })], 2)], 1)], 1)], 1)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "item-menu is-mobile"
	  }, [_c('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [_c('img', {
	    staticClass: "logo-menu-mobile",
	    attrs: {
	      "src": "/static/img/logo_full.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "item-menu is-mobile"
	  }, [_c('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [_c('img', {
	    staticClass: "logo-menu-mobile",
	    attrs: {
	      "src": "/static/img/logo_full.svg"
	    }
	  })])])
	}]}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-container', [_c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n       Политика в отношении обработки персональных данных\n    ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n        1. Общие положения\n      ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n          Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006. №152-ФЗ «О персональных данных» (далее - Закон о персональных данных) и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые ООО \"ОМТ Софт\" (далее – Оператор).\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                1.1. Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                1.2. Настоящая политика Оператора в отношении обработки персональных данных (далее – Политика) применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта https://mobileadvokat.ru.\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n                2. Основные понятия, используемые в Политике\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                2.1. Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств вычислительной техники.\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.2. Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных).\n        \t")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.3. Веб-сайт – совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу https://mobileadvokat.ru.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.4. Информационная система персональных данных — совокупность содержащихся в базах данных персональных данных, и обеспечивающих их обработку информационных технологий и технических средств.\n        \t")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.5. Обезличивание персональных данных — действия, в результате которых невозможно определить без использования дополнительной информации принадлежность персональных данных конкретному Пользователю или иному субъекту персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.6. Обработка персональных данных – любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.7. Оператор – государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.8. Персональные данные – любая информация, относящаяся прямо или косвенно к определенному или определяемому Пользователю веб-сайта https://mobileadvokat.ru.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.9. Персональные данные, разрешенные субъектом персональных данных для распространения, - персональные данные, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных путем дачи согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения в порядке, предусмотренном Законом о персональных данных (далее - персональные данные, разрешенные для распространения).\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.10. Пользователь – любой посетитель веб-сайта https://mobileadvokat.ru.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.11. Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.12. Распространение персональных данных – любые действия, направленные на раскрытие персональных данных неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными данными неограниченного круга лиц, в том числе обнародование персональных данных в средствах массовой информации, размещение в информационно-телекоммуникационных сетях или предоставление доступа к персональным данным каким-либо иным способом.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.13. Трансграничная передача персональных данных – передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому или иностранному юридическому лицу.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            2.14. Уничтожение персональных данных – любые действия, в результате которых персональные данные уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в информационной системе персональных данных и (или) уничтожаются материальные носители персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            3. Основные права и обязанности Оператора\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            3.1. Оператор имеет право:\n            – получать от субъекта персональных данных достоверные информацию и/или документы, содержащие персональные данные;\n            – в случае отзыва субъектом персональных данных согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в Законе о персональных данных;\n            – самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения обязанностей, предусмотренных Законом о персональных данных и принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено Законом о персональных данных или другими федеральными законами.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            3.2. Оператор обязан:\n            – предоставлять субъекту персональных данных по его просьбе информацию, касающуюся обработки его персональных данных;\n            – организовывать обработку персональных данных в порядке, установленном действующим законодательством РФ;\n            – отвечать на обращения и запросы субъектов персональных данных и их законных представителей в соответствии с требованиями Закона о персональных данных;\n            – сообщать в уполномоченный орган по защите прав субъектов персональных данных по запросу этого органа необходимую информацию в течение 30 дней с даты получения такого запроса;\n            – публиковать или иным образом обеспечивать неограниченный доступ к настоящей Политике в отношении обработки персональных данных;\n            – принимать правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от иных неправомерных действий в отношении персональных данных;\n            – прекратить передачу (распространение, предоставление, доступ) персональных данных, прекратить обработку и уничтожить персональные данные в порядке и случаях, предусмотренных Законом о персональных данных;\n            – исполнять иные обязанности, предусмотренные Законом о персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            4. Основные права и обязанности субъектов персональных данных\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            4.1. Субъекты персональных данных имеют право:\n            – получать информацию, касающуюся обработки его персональных данных, за исключением случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту персональных данных Оператором в доступной форме, и в них не должны содержаться персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. Перечень информации и порядок ее получения установлен Законом о персональных данных;\n            – требовать от оператора уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав;\n            – выдвигать условие предварительного согласия при обработке персональных данных в целях продвижения на рынке товаров, работ и услуг;\n            – на отзыв согласия на обработку персональных данных;\n            – обжаловать в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке неправомерные действия или бездействие Оператора при обработке его персональных данных;\n            – на осуществление иных прав, предусмотренных законодательством РФ.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            4.2. Субъекты персональных данных обязаны:\n            – предоставлять Оператору достоверные данные о себе;\n            – сообщать Оператору об уточнении (обновлении, изменении) своих персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            4.3. Лица, передавшие Оператору недостоверные сведения о себе, либо сведения о другом субъекте персональных данных без согласия последнего, несут ответственность в соответствии с законодательством РФ.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            5. Оператор может обрабатывать следующие персональные данные Пользователя\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.1. Фамилия, имя, отчество.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.2. Электронный адрес.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.3. Номера телефонов.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.4. Год, месяц, дата и место рождения.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.5. Фотографии.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.6. Стаж работы по юридической специальности.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.7. Номер адвокатского удостоверения.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.8. Область специализации.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.9. Регион оказания услуг.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.10. Также на сайте происходит сбор и обработка обезличенных данных о посетителях (в т.ч. файлов «cookie») с помощью сервисов интернет-статистики (Яндекс Метрика и Гугл Аналитика и других).\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.11. Вышеперечисленные данные далее по тексту Политики объединены общим понятием Персональные данные.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.12. Обработка специальных категорий персональных данных, касающихся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, интимной жизни, Оператором не осуществляется.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.13. Обработка персональных данных, разрешенных для распространения, из числа специальных категорий персональных данных, указанных в ч. 1 ст. 10 Закона о персональных данных, допускается, если соблюдаются запреты и условия, предусмотренные ст. 10.1 Закона о персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.13.1. Согласие Пользователя на обработку персональных данных, разрешенных для распространения, оформляется отдельно от других согласий на обработку его персональных данных. При этом соблюдаются условия, предусмотренные, в частности, ст. 10.1 Закона о персональных данных. Требования к содержанию такого согласия устанавливаются уполномоченным органом по защите прав субъектов персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.13.2. Согласие на обработку персональных данных, разрешенных для распространения, Пользователь предоставляет Оператору непосредственно.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.13.3. Оператор обязан в срок не позднее трех рабочих дней с момента получения указанного согласия Пользователя опубликовать информацию об условиях обработки, о наличии запретов и условий на обработку неограниченным кругом лиц персональных данных, разрешенных для распространения.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.13.4 Передача (распространение, предоставление, доступ) персональных данных, разрешенных субъектом персональных данных для распространения, должна быть прекращена в любое время по требованию субъекта персональных данных. Данное требование должно включать в себя фамилию, имя, отчество (при наличии), контактную информацию (номер телефона, адрес электронной почты или почтовый адрес) субъекта персональных данных, а также перечень персональных данных, обработка которых подлежит прекращению. Указанные в данном требовании персональные данные могут обрабатываться только Оператором, которому оно направлено.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            5.14. Согласие на обработку персональных данных, разрешенных для распространения, прекращает свое действие с момента поступления Оператору требования, указанного в п. 5.15.3 настоящей Политики в отношении обработки персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            6. Принципы обработки персональных данных\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            6.1. Обработка персональных данных осуществляется на законной и справедливой основе.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            6.2. Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            6.3. Не допускается объединение баз данных, содержащих персональные данные, обработка которых осуществляется в целях, несовместимых между собой.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            6.4. Обработке подлежат только персональные данные, которые отвечают целям их обработки.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            6.5. Содержание и объем обрабатываемых персональных данных соответствуют заявленным целям обработки. Не допускается избыточность обрабатываемых персональных данных по отношению к заявленным целям их обработки.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            6.6. При обработке персональных данных обеспечивается точность персональных данных, их достаточность, а в необходимых случаях и актуальность по отношению к целям обработки персональных данных. Оператор принимает необходимые меры и/или обеспечивает их принятие по удалению или уточнению неполных или неточных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            6.7. Хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных. Обрабатываемые персональные данные уничтожаются либо обезличиваются по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено федеральным законом.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            7. Цели обработки персональных данных\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            7.1. Цель обработки персональных данных Пользователя:\n            – информирование Пользователя посредством отправки электронных писем;\n            – заключение, исполнение и прекращение гражданско-правовых договоров;\n            – предоставление доступа Пользователю к сервисам, информации и/или материалам, содержащимся на веб-сайте https://mobileadvokat.ru.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            7.2. Также Оператор имеет право направлять Пользователю уведомления о новых продуктах и услугах, специальных предложениях и различных событиях. Пользователь всегда может отказаться от получения информационных сообщений, направив Оператору письмо на адрес электронной почты privacy@mobileadvokat.ru с пометкой «Отказ от уведомлений о новых продуктах и услугах и специальных предложениях».\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            7.3. Обезличенные данные Пользователей, собираемые с помощью сервисов интернет-статистики, служат для сбора информации о действиях Пользователей на сайте, улучшения качества сайта и его содержания.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            8. Правовые основания обработки персональных данных\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            8.1. Правовыми основаниями обработки персональных данных Оператором являются:\n            – договоры, заключаемые между оператором и субъектом персональных данных;\n            – федеральные законы, иные нормативно-правовые акты в сфере защиты персональных данных;\n            – согласия Пользователей на обработку их персональных данных, на обработку персональных данных, разрешенных для распространения.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            8.2. Оператор обрабатывает персональные данные Пользователя только в случае их заполнения и/или отправки Пользователем самостоятельно через специальные формы, расположенные на сайте https://mobileadvokat.ru или направленные Оператору посредством электронной почты. Заполняя соответствующие формы и/или отправляя свои персональные данные Оператору, Пользователь выражает свое согласие с данной Политикой.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            8.3. Оператор обрабатывает обезличенные данные о Пользователе в случае, если это разрешено в настройках браузера Пользователя (включено сохранение файлов «cookie» и использование технологии JavaScript).\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            8.4. Субъект персональных данных самостоятельно принимает решение о предоставлении его персональных данных и дает согласие свободно, своей волей и в своем интересе.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            9. Условия обработки персональных данных\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            9.1. Обработка персональных данных осуществляется с согласия субъекта персональных данных на обработку его персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            9.2. Обработка персональных данных необходима для достижения целей, предусмотренных международным договором Российской Федерации или законом, для осуществления возложенных законодательством Российской Федерации на оператора функций, полномочий и обязанностей.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            9.3. Обработка персональных данных необходима для осуществления правосудия, исполнения судебного акта, акта другого органа или должностного лица, подлежащих исполнению в соответствии с законодательством Российской Федерации об исполнительном производстве.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            9.4. Обработка персональных данных необходима для исполнения договора, стороной которого либо выгодоприобретателем или поручителем по которому является субъект персональных данных, а также для заключения договора по инициативе субъекта персональных данных или договора, по которому субъект персональных данных будет являться выгодоприобретателем или поручителем.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            9.5. Обработка персональных данных необходима для осуществления прав и законных интересов оператора или третьих лиц либо для достижения общественно значимых целей при условии, что при этом не нарушаются права и свободы субъекта персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            9.6. Осуществляется обработка персональных данных, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных либо по его просьбе (далее – общедоступные персональные данные).\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            9.7. Осуществляется обработка персональных данных, подлежащих опубликованию или обязательному раскрытию в соответствии с федеральным законом.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            10. Порядок сбора, хранения, передачи и других видов обработки персональных данных\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            10.1 Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых, организационных и технических мер, необходимых для выполнения в полном объеме требований действующего законодательства в области защиты персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            10.2. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            10.3. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства либо в случае, если субъектом персональных данных дано согласие Оператору на передачу данных третьему лицу для исполнения обязательств по гражданско-правовому договору.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            10.4. В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно, путем направления Оператору уведомление на адрес электронной почты Оператора privacy@mobileadvokat.ru с пометкой «Актуализация персональных данных».\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            10.5. Срок обработки персональных данных определяется достижением целей, для которых были собраны персональные данные, если иной срок не предусмотрен договором или действующим законодательством.\n            Пользователь может в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору уведомление посредством электронной почты на электронный адрес Оператора privacy@mobileadvokat.ru с пометкой «Отзыв согласия на обработку персональных данных».\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            10.6. Вся информация, которая собирается сторонними сервисами, в том числе платежными системами, средствами связи и другими поставщиками услуг, хранится и обрабатывается указанными лицами (Операторами) в соответствии с их Пользовательским соглашением и Политикой конфиденциальности. Субъект персональных данных и/или Пользователь обязан самостоятельно своевременно ознакомиться с указанными документами. Оператор не несет ответственность за действия третьих лиц, в том числе указанных в настоящем пункте поставщиков услуг.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            10.7. Установленные субъектом персональных данных запреты на передачу (кроме предоставления доступа), а также на обработку или условия обработки (кроме получения доступа) персональных данных, разрешенных для распространения, не действуют в случаях обработки персональных данных в государственных, общественных и иных публичных интересах, определенных законодательством РФ.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            10.8. Оператор при обработке персональных данных обеспечивает конфиденциальность персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            10.9. Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n            10.10. Условием прекращения обработки персональных данных может являться достижение целей обработки персональных данных, истечение срока действия согласия субъекта персональных данных или отзыв согласия субъектом персональных данных, а также выявление неправомерной обработки персональных данных.\n        ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            11. Перечень действий, производимых Оператором с полученными персональными данными\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                11.1. Оператор осуществляет сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление и уничтожение персональных данных.\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                11.2. Оператор осуществляет автоматизированную обработку персональных данных с получением и/или передачей полученной информации по информационно-телекоммуникационным сетям или без таковой.\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            12. Трансграничная передача персональных данных\n             ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                12.1. Оператор до начала осуществления трансграничной передачи персональных данных обязан убедиться в том, что иностранным государством, на территорию которого предполагается осуществлять передачу персональных данных, обеспечивается надежная защита прав субъектов персональных данных.\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                12.2. Трансграничная передача персональных данных на территории иностранных государств, не отвечающих вышеуказанным требованиям, может осуществляться только в случае наличия согласия в письменной форме субъекта персональных данных на трансграничную передачу его персональных данных и/или исполнения договора, стороной которого является субъект персональных данных.\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            13. Конфиденциальность персональных данных\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                13.1 Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим лицам и не распространять персональные данные без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом.\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "title-text-privacy",
	    attrs: {
	      "cols": "12"
	    }
	  }, [_vm._v("\n            14. Заключительные положения\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                14.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору с помощью электронной почты privacy@mobileadvokat.ru.\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                14.2. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором. Политика действует бессрочно до замены ее новой версией.\n            ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticClass: "text-privacy",
	    attrs: {
	      "cols": "12",
	      "sm": "10",
	      "md": "10"
	    }
	  }, [_vm._v("\n                14.3. Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу https://mobileadvokat.ru/privacy.\n            ")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title-home row",
	    style: (_vm.style)
	  }, [_c('v-divider', {
	    staticClass: "divider-left",
	    class: _vm.no_left ? 'no_left' : ''
	  }), _vm._v(" "), _c('div', {
	    staticClass: "title-home__text-wrapper"
	  }, [_c('span', {
	    staticClass: "title-home__text"
	  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-divider', {
	    staticClass: "divider-right"
	  })], 1), _vm._v(" "), _c('v-divider')], 1)
	},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-contain"
	  }, [_c('v-text-field', {
	    staticClass: "input-text",
	    attrs: {
	      "value": _vm.value,
	      "v-mask": _vm.mask,
	      "input-value": _vm.value,
	      "append-icon": _vm.type === 'password' ? _vm.show ? 'mdi-eye' : 'mdi-eye-off' : '',
	      "height": "44",
	      "show_password": _vm.show,
	      "placeholder": _vm.placeholder,
	      "required": _vm.required,
	      "content-class": "input-text__content",
	      "type": _vm.type === 'password' && _vm.show ? 'password' : _vm.type === 'password' && !_vm.show ? 'text' : _vm.type,
	      "rules": _vm.rules || [],
	      "hide-details": "auto",
	      "clearable": _vm.clearable,
	      "disabled": _vm.disabled,
	      "label": _vm.label,
	      "color": _vm.color
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$emit('input', $event)
	      },
	      "click:append": function($event) {
	        _vm.show = !_vm.show
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "hint"
	  }, [_vm._v(_vm._s(_vm.hint))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-row')
	},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n      О СЕРВИСЕ\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "row row-logo-with-text"
	  }, [_c('div', {
	    staticClass: "col-12 col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col padd-mobile"
	  }, [_c('ui_sub_title_text', [_vm._v("\n              Сервис «Мобильный адвокат» — уникальная площадка по поиску адвокатских услуг в России\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ui_text', [_c('p', [_vm._v("\n                На нашем портале Вы можете найти проверенного адвоката с любой специализацией в Вашем городе. Гарантом выполнения услуг выступает «Безопасная сделка». Вы можете не беспокоиться о деньгах: специалист получит их после выполнения всех обязательств. С другой стороны, адвокат спокоен за оплату своих услуг: деньги хранятся на безопасном счету до завершения сделки\n              ")])])], 1), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col offset-md-2 col-md-8"
	  }, [_c('div', {
	    staticClass: "row row-two-colm"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('div', {
	    staticClass: "row row-img-wrapp"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "title-col"
	  }, [_c('ui_sub_title_text', [_vm._v("Уникальность")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text-col"
	  }, [_c('ui_text', [_vm._v("Портал, где можно быстро найти адвоката с любой специализацией")])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('div', {
	    staticClass: "row row-img-wrapp no-wrap-desc"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "title-col"
	  }, [_c('ui_sub_title_text', [_vm._v("Конфиденциальность")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text-col"
	  }, [_c('ui_text', [_vm._v("Мы не вмешиваемся в Ваши договоренности. О Вашей сделке знаете только Вы и адвокат")])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row row-two-colm"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('div', {
	    staticClass: "row row-img-wrapp"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "title-col"
	  }, [_c('ui_sub_title_text', [_vm._v("Мы на связи")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text-col"
	  }, [_c('ui_text', [_vm._v("Круглосуточная поддержка. Мы поможем!")])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('div', {
	    staticClass: "row row-img-wrapp"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "title-col"
	  }, [_c('ui_sub_title_text', [_vm._v("Безопасность")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text-col"
	  }, [_c('ui_text', [_vm._v("Мы сохраним Ваши деньги, пока адвокат не выполнит условия сделки")])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row row-two-colm"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('div', {
	    staticClass: "row row-img-wrapp"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "title-col"
	  }, [_c('ui_sub_title_text', [_vm._v("Надежность")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text-col"
	  }, [_c('ui_text', [_vm._v("Всех зарегистрированных адвокатов мы проверяем на присутствие в Министерстве Юстиции РФ")])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('div', {
	    staticClass: "row row-img-wrapp"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "title-col"
	  }, [_c('ui_sub_title_text', [_vm._v("Бесплатно")])], 1), _vm._v(" "), _c('p', {
	    staticClass: "text-col"
	  }, [_c('ui_text', [_vm._v("За пользование нашей площадкой мы не берем деньги с клиента")])], 1)])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 padd-mobile"
	  }, [_c('ui_title', [_vm._v("\n          НАШИ КОНТАКТЫ\n        ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 padd-mobile offset-md-2"
	  }, [_c('div', {
	    staticClass: "row contact-info"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('ui_text', [_c('img', {
	    attrs: {
	      "src": "/static/img/icon_phone.svg"
	    }
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "tel:+74956425292"
	    }
	  }, [_vm._v("+7 (495) 64 25 292")])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row contact-info"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('ui_text', [_c('img', {
	    attrs: {
	      "src": "/static/img/icon_mail_dark.svg"
	    }
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "mailto: info@mobileadvokat.ru"
	    }
	  }, [_vm._v("info@mobileadvokat.ru")])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row contact-info"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('ui_text', [_vm._v("с 10.00 до 18.00 по МСК, Пн-Пт")])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 padd-mobile"
	  }, [_c('ui_title', [_vm._v("\n        РЕКВИЗИТЫ\n      ")]), _vm._v(" "), _c('ui_text', [_vm._v("ООО «ОМТ СОФТ»")]), _vm._v(" "), _c('ui_text', [_vm._v("ИНН 9710008096")]), _vm._v(" "), _c('ui_text', [_vm._v("ОГРН 1167746187058")]), _vm._v(" "), _c('ui_text', [_vm._v("117105, город Москва, Варшавское шоссе, дом 1, строение 1-2, этаж 6, комната 33")])], 1)])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 col-md-4 logo-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/newLogo.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-3 col-img"
	  }, [_c('img', {
	    staticClass: "img-150",
	    attrs: {
	      "src": "/static/img/loop.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 col-md-3 col-img"
	  }, [_c('img', {
	    staticClass: "img-150",
	    attrs: {
	      "src": "/static/img/hands.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 col-md-3 col-img"
	  }, [_c('img', {
	    staticClass: "img-150",
	    attrs: {
	      "src": "/static/img/clock.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 col-md-3 col-img"
	  }, [_c('img', {
	    staticClass: "img-150",
	    attrs: {
	      "src": "/static/img/dollars.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 col-md-3 col-img"
	  }, [_c('img', {
	    staticClass: "img-150",
	    attrs: {
	      "src": "/static/img/ves.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 col-md-3 col-img"
	  }, [_c('img', {
	    staticClass: "img-150",
	    attrs: {
	      "src": "/static/img/bm.svg"
	    }
	  })])
	}]}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', {
	    staticClass: "mobile-no-margin"
	  }, [_vm._v("\n      БЕЗОПАСНАЯ СДЕЛКА\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col li-cancel"
	  }, [_c('p', {
	    staticClass: "cansel-text",
	    staticStyle: {
	      "font-weight": "bolder"
	    }
	  }, [_c('ui_sub_title_text', [_vm._v("Безопасные переводы между физическими лицами")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('ui_text', [_vm._v("Деньги придут, когда услуга будет оказана")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Ваш расчетный счет не участвует в сделке")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Длительная заморозка денег заказчика")])], 1)]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/search"
	    }
	  }, [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn"
	    }
	  }, [_vm._v("Найти адвоката")])], 1)], 1)])])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      ТЕХНОЛОГИЯ РАБОТЫ\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row cancel-col-button"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/search"
	    }
	  }, [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn"
	    }
	  }, [_vm._v("Провести сделку")])], 1)], 1)])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-5 col-img-cancel"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/pc-new.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col img-only-cancel"
	  }, [_c('img', {
	    staticClass: "is-desctop-s",
	    attrs: {
	      "src": "/static/img/bezopas.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "is-mobile-s",
	    attrs: {
	      "src": "/static/img/mobile-bezopas.svg"
	    }
	  })])])])])
	}]}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('v-row', [_c('v-dialog', {
	    attrs: {
	      "content-class": "all-dialog-wrapper",
	      "persistent": ""
	    },
	    model: {
	      value: (_vm.dialog),
	      callback: function($$v) {
	        _vm.dialog = $$v
	      },
	      expression: "dialog"
	    }
	  }, [_c('v-card', [(!_vm.isLoading) ? [_c('v-row', {
	    staticClass: "close-button"
	  }, [_c('v-col', [_c('img', {
	    staticClass: "closse-icon-modal",
	    attrs: {
	      "src": "/static/img/closse.svg"
	    },
	    on: {
	      "click": _vm.closse
	    }
	  })])], 1), _vm._v(" "), _c('v-form', {
	    staticClass: "wrapper-modal"
	  }, [_c('v-row', {
	    staticClass: "title-text"
	  }, [_c('v-col', [_vm._v("\n                АВТОРИЗАЦИЯ \n              ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "text-auth"
	  }, [_c('v-col', [_vm._v("\n                  Пожалуйста, авторизируйтесь с помощью вашего номера телефона\n                ")])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "input-row"
	  }, [_c('v-col', [_c('v-text-field', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ('+7(###)-###-##-##'),
	      expression: "'+7(###)-###-##-##'"
	    }],
	    attrs: {
	      "color": "grey",
	      "placeholder": "+7(###)-###-##-##",
	      "label": "Ваш номер телефона",
	      "error-messages": _vm.phoneErrors,
	      "required": ""
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.phone.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.phone.$touch()
	      }
	    },
	    model: {
	      value: (_vm.phone),
	      callback: function($$v) {
	        _vm.phone = $$v
	      },
	      expression: "phone"
	    }
	  })], 1)], 1), _vm._v(" "), (_vm.isSenden) ? _c('v-row', {
	    staticClass: "input-row border-last"
	  }, [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "color": "grey",
	      "error-messages": _vm.codeErrors,
	      "counter": 6,
	      "required": "",
	      "label": "Код из смс"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.code.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.code.$touch()
	      }
	    },
	    model: {
	      value: (_vm.code),
	      callback: function($$v) {
	        _vm.code = $$v
	      },
	      expression: "code"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
	    staticClass: "red-text"
	  }, [_c('v-col', [_c('span', {
	    class: [_vm.isLoad ? 'timer-gray' : 'timer-red'],
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.sendCode
	    }
	  }, [_vm._v("\n                    Отправить код\n                  ")]), _vm._v(" "), (_vm.isLoad) ? _c('span', {
	    staticStyle: {
	      "color": "black"
	    }
	  }, [_vm._v(_vm._s(_vm.currentTime) + " ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-row', {
	    staticClass: "row-button"
	  }, [_c('v-col', [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn full-width"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n                    Войти               \n                  ")])], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.isLoading) ? [_c('div', {
	    staticClass: "wrapper-loading"
	  }, [_c('v-progress-circular', {
	    attrs: {
	      "indeterminate": "",
	      "color": "red"
	    }
	  })], 1)] : _vm._e()], 2)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-text",
	    class: _vm.size ? 'custom-size' : '',
	    style: (_vm.style)
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-row', [_c('v-col', {
	    staticClass: "wrapper-pay"
	  }, [(_vm.pay == 'true') ? [_c('span', {
	    staticClass: "title-pay sucsess"
	  }, [_vm._v("\n        ОПЛАТА ПРОШЛА УСПЕШНО\n      ")]), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "text-pay"
	  }, [_vm._v("\n        Мы получили ваш платеж\n      ")]), _c('br')] : _vm._e(), _vm._v(" "), (_vm.pay == 'false') ? [_c('span', {
	    staticClass: "title-pay error-custom"
	  }, [_vm._v("\n        ОПЛАТА НЕ ПРОШЛА\n      ")]), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "text-pay"
	  }, [_vm._v("\n        Мы не получили ваш платеж\n      ")]), _c('br')] : _vm._e(), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('button', {
	    staticClass: "red-button"
	  }, [_vm._v("\n        Вернуться на главную\n      ")])])], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n    СТАТЬИ\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 padding-on-mobile"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("СТАТЬИ АДВОКАТОВ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col link-art"
	  }, [_c('ul', _vm._l((_vm.article), function(item) {
	    return _c('li', {
	      key: item.id,
	      staticStyle: {
	        "margin-bottom": "1em"
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "to": item.href
	      }
	    }, [_c('ui_text', [_vm._v(_vm._s(item.title))])], 1)], 1)
	  }), 0)])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col col-md-8 offset-md-2 padding-on-mobile"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("Что такое безопасная сделка")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col col-md-10 padding-on-mobile"
	  }, [_c('ui_text', {
	    staticClass: "body-text"
	  }, [_c('v-img', {
	    staticClass: "img-main",
	    attrs: {
	      "src": "/static/img/imgleft2.svg"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Безопасная сделка - опция, доступная на нашем портале. Она обеспечивает защиту интересов и адвоката, и его доверителя. В процессе оказания юридических услуг у клиента может возникнуть недовольство некачественной помощью адвоката. В свою очередь, адвокат заинтересован в том, чтобы деньги за его труд были ему своевременно уплачены клиентом, иначе пропадает мотивация к работе.")]), _vm._v(" "), _c('p', [_vm._v("Например, гражданин обратился в суд с иском о взыскании стоимости юридических услуг с адвоката. Иск мотивирован тем обстоятельством, что между сторонами было заключено соглашение об оказании юридической помощи в целях признания права собственности в порядке наследования. Стороны согласовали стоимость юридических услуг в сумме 130 000 руб., которые истцом были переданы ответчику. Однако ответчиком обязательства по договору выполнены не были. Суд, установив ненадлежащее оказание услуг, иск частично удовлетворил. Обращает внимание то обстоятельство, что суд по взысканию денег с адвоката занял около трех лет.")]), _vm._v(" "), _c('p', [_vm._v("Итог: работа адвоката выполнена некачественно, в результате дело проиграно, клиентка потратила три года и потратилась на другого адвоката, чтобы вернуть свои деньги.")]), _vm._v(" "), _c('p', [_vm._v("С другой стороны, и клиенты не всегда добросовестно оплачивают услуги адвоката. Так, гражданин заключил соглашение с адвокатом на представление его интересов по двум гражданским делам. После того, как адвокат оказал услуги, клиент отказался от его услуг (закон это разрешает) и уклонился от оплаты выставленных счетов. Понадобилось судебное разбирательство в течение года, чтобы вознаграждение адвоката было взыскано. Все это время адвокат отвлекался от основной работы, тратил время на участие в заседаниях, понес репутационные потери. Закон теперь разрешает оплату по схеме «гонорар успеха», но жизнь показывает, что мотивация у адвоката снижается, как только по делу возникают трудности либо он заключает соглашение, по которому ему оплатили аванс.")]), _vm._v(" "), _c('p', [_vm._v("Мы предлагаем форму оплаты, которая учитывает риски и опасения обеих сторон - «безопасная сделка». В момент заключения сделки, внесённые вами деньги резервируются (замораживаются) на специальном эскроу-счете, и перечисляются адвокату только после успешного завершения его работы по вашему делу.")]), _vm._v(" "), _c('p', [_vm._v("Банк, в котором открыт эскроу-счет, является гарантом ваших интересов: деньги поступят адвокату только в случае отсутствия обоснованных (подчеркиваем, обоснованных) претензий к качеству оказанных юридических услуг. В случае недобросовестных действий адвоката деньги возвращаются вам.")]), _vm._v(" "), _c('p', [_vm._v("В случае претензий к работе адвоката у вас есть возможность обратиться к модератору портала с жалобой. Модератор рассматривает спорную ситуацию, и, в случае сомнений в добросовестности адвоката, вам будут возвращены деньги и оказана помощь в подборе другого специалиста.")])], 1)], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "adv-counter"
	  }, [_c('div', {
	    staticClass: "wrapper-number"
	  }, _vm._l((_vm.arr), function(number) {
	    return _c('div', {
	      key: 'number-' + Math.random() + number,
	      staticClass: "text-number"
	    }, [_vm._v("\n        " + _vm._s(number) + "\n    ")])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "title-text"
	  }, [_vm._v(_vm._s(_vm.titile))])])
	},staticRenderFns: []}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.isLoad) ? [_c('v-row', {
	    staticStyle: {
	      "text-align": "-webkit-center"
	    }
	  }, [_c('v-col', [_c('v-progress-circular', {
	    attrs: {
	      "width": 3,
	      "color": "red",
	      "indeterminate": ""
	    }
	  })], 1)], 1)] : _vm._e(), _vm._v(" "), (!_vm.isLoad & !_vm.isTrue) ? [_c('v-row', [_c('v-col', [(_vm.cards.length > 0) ? _c('v-select', {
	    attrs: {
	      "required": "",
	      "items": _vm.cards,
	      "clearable": "",
	      "item-text": 'Purse',
	      "item-value": 'Guid',
	      "label": "Выбор карты"
	    },
	    model: {
	      value: (_vm.card.guid),
	      callback: function($$v) {
	        _vm.$set(_vm.card, "guid", $$v)
	      },
	      expression: "card.guid"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.card.guid) ? _c('v-col', [_vm._v("\n           CVC Код\n            "), _c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.cardCodeErrors,
	      "color": "grey",
	      "required": "",
	      "outlined": "",
	      "label": "CVC код"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.card.CardCode.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.card.CardCode.$touch()
	      }
	    },
	    model: {
	      value: (_vm.card.CardCode),
	      callback: function($$v) {
	        _vm.$set(_vm.card, "CardCode", $$v)
	      },
	      expression: "card.CardCode"
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.phoneErrors,
	      "color": "grey",
	      "counter": 16,
	      "required": "",
	      "label": "Номер телефона"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.card.Phone.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.card.Phone.$touch()
	      }
	    },
	    model: {
	      value: (_vm.card.Phone),
	      callback: function($$v) {
	        _vm.$set(_vm.card, "Phone", $$v)
	      },
	      expression: "card.Phone"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.emailErrors,
	      "color": "grey",
	      "required": "",
	      "label": "Email"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.card.Email.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.card.Email.$touch()
	      }
	    },
	    model: {
	      value: (_vm.card.Email),
	      callback: function($$v) {
	        _vm.$set(_vm.card, "Email", $$v)
	      },
	      expression: "card.Email"
	    }
	  })], 1)], 1), _vm._v(" "), (!_vm.card.guid) ? _c('v-row', {
	    staticClass: "card-wrapper"
	  }, [_c('v-col', [_c('v-row', [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.payeePurseErrors,
	      "color": "grey",
	      "counter": 16,
	      "required": "",
	      "outlined": "",
	      "label": "Номер карты"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.card.PayeePurse.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.card.PayeePurse.$touch()
	      }
	    },
	    model: {
	      value: (_vm.card.PayeePurse),
	      callback: function($$v) {
	        _vm.$set(_vm.card, "PayeePurse", $$v)
	      },
	      expression: "card.PayeePurse"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
	    attrs: {
	      "cols": "6"
	    }
	  }, [_vm._v("\n            Срок действия\n            "), _c('div', {
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.cardMonthErrors,
	      "color": "grey",
	      "required": "",
	      "outlined": "",
	      "label": "Месяц"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.card.CardMonth.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.card.CardMonth.$touch()
	      }
	    },
	    model: {
	      value: (_vm.card.CardMonth),
	      callback: function($$v) {
	        _vm.$set(_vm.card, "CardMonth", $$v)
	      },
	      expression: "card.CardMonth"
	    }
	  }), _vm._v(" "), _c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.cardYearErrors,
	      "color": "grey",
	      "required": "",
	      "outlined": "",
	      "label": "Год"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.card.CardYear.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.card.CardYear.$touch()
	      }
	    },
	    model: {
	      value: (_vm.card.CardYear),
	      callback: function($$v) {
	        _vm.$set(_vm.card, "CardYear", $$v)
	      },
	      expression: "card.CardYear"
	    }
	  })], 1)]), _vm._v(" "), _c('v-col', [_vm._v("\n            Код\n            "), _c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.cardCodeErrors,
	      "color": "grey",
	      "required": "",
	      "outlined": "",
	      "label": "CVC код"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.card.CardCode.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.card.CardCode.$touch()
	      }
	    },
	    model: {
	      value: (_vm.card.CardCode),
	      callback: function($$v) {
	        _vm.$set(_vm.card, "CardCode", $$v)
	      },
	      expression: "card.CardCode"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-text-field', {
	    attrs: {
	      "error-messages": _vm.cardHolderErrors,
	      "color": "grey",
	      "required": "",
	      "outlined": "",
	      "label": "Владелец карты"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.card.CardHolder.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.card.CardHolder.$touch()
	      }
	    },
	    model: {
	      value: (_vm.card.CardHolder),
	      callback: function($$v) {
	        _vm.$set(_vm.card, "CardHolder", $$v)
	      },
	      expression: "card.CardHolder"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
	    staticStyle: {
	      "text-align": "end"
	    }
	  }, [_c('button', {
	    staticClass: "red-button",
	    staticStyle: {
	      "min-width": "20%"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.send()
	      }
	    }
	  }, [_vm._v("Оплатить")])])], 1)] : _vm._e(), _vm._v(" "), (!_vm.isLoad & _vm.isTrue) ? [_c('div', {
	    staticClass: "wrapper-pay"
	  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('button', {
	    staticClass: "red-button"
	  }, [_vm._v("\n          Вернуться на главную\n        ")])])], 1)] : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "title-pay sucsess"
	  }, [_vm._v("\n        Оплата прошла успешно "), _c('br')])
	}]}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sub-text",
	    style: (_vm.style)
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.size
	  }, [(_vm.isPanel) ? _c('div', {
	    staticClass: "left-panel-wraper animate__animated"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "menu"
	  }, [_c('div', {
	    staticClass: "button-menu"
	  }, [_c('img', {
	    staticClass: "is-menu-button",
	    attrs: {
	      "src": "/static/img/menu_button.svg"
	    },
	    on: {
	      "click": _vm.isMenu
	    }
	  })])]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.isPanel) ? _c('div', {
	    staticClass: "left-menu-wraper animate__animated animate__fadeInLeft"
	  }, [_c('div', {
	    staticClass: "menu-wrap-stepper one-menu"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-2",
	    staticStyle: {
	      "text-align": "-webkit-right"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "src": "/static/img/closse.svg"
	    },
	    on: {
	      "click": _vm.isMenu
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row menu-item"
	  }, [_c('ui_btn', {
	    attrs: {
	      "type": "main-btn full-width"
	    },
	    on: {
	      "click": _vm.toHelp
	    }
	  }, [_vm._v("\n          Срочная помощь адвоката\n        ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "menu-wrap-stepper two-menu"
	  }, _vm._l((_vm.menuList), function(menu, index) {
	    return _c('div', {
	      key: 'menu' + index,
	      staticClass: "acord-custom",
	      class: menu.opened ? 'acord-custom-closse' : ''
	    }, [_c('div', {
	      staticClass: "header",
	      on: {
	        "click": function($event) {
	          menu.opened = !menu.opened
	        }
	      }
	    }, [_c('div', {
	      staticClass: "text"
	    }, [_vm._v("\n            " + _vm._s(menu.name) + "\n          ")]), _vm._v(" "), _c('img', {
	      class: menu.opened ? 'open-menu' : '',
	      attrs: {
	        "src": "/static/img/Accord-controll.svg"
	      }
	    })]), _vm._v(" "), (menu.opened) ? _vm._l((menu.routs), function(item, index) {
	      return _c('div', {
	        key: index + 'menu-item',
	        staticClass: "item",
	        on: {
	          "click": function($event) {
	            return _vm.onClickToItem(item.href)
	          }
	        }
	      }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
	    }) : _vm._e()], 2)
	  }), 0), _vm._v(" "), _vm._m(3)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "logo"
	  }, [_c('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/logo_small.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "social-wrapper"
	  }, [_c('div', {
	    staticClass: "social"
	  }, [_c('a', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "href": "https://wa.me/79910830833"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "36px"
	    },
	    attrs: {
	      "src": "/static/img/icon_whatsapp_black.svg"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://vk.com/mob_advokat"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "50px"
	    },
	    attrs: {
	      "src": "/static/img/vk-02-01.svg"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.youtube.com/channel/UCOyKsErmFTcl23B2ckPA0MQ"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "50px"
	    },
	    attrs: {
	      "src": "/static/img/you-02-01.svg"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-10"
	  }, [_c('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/logo_full.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "menu-wrap-stepper three-menu"
	  }, [_c('div', {
	    staticClass: "social-row"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://wa.me/79910830833"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "36px"
	    },
	    attrs: {
	      "src": "/static/img/icon_whatsapp_black.svg"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://vk.com/mob_advokat"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "50px"
	    },
	    attrs: {
	      "src": "/static/img/vk-02-01.svg"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.youtube.com/channel/UCOyKsErmFTcl23B2ckPA0MQ"
	    }
	  }, [_c('img', {
	    staticClass: "margin-right-1",
	    staticStyle: {
	      "width": "50px"
	    },
	    attrs: {
	      "src": "/static/img/you-02-01.svg"
	    }
	  })])])])
	}]}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n    СТАТЬИ\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 padding-on-mobile"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("СТАТЬИ АДВОКАТОВ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col link-art"
	  }, [_c('ul', _vm._l((_vm.article), function(item) {
	    return _c('li', {
	      key: item.id,
	      staticStyle: {
	        "margin-bottom": "1em"
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "to": item.href
	      }
	    }, [_c('ui_text', [_vm._v(_vm._s(item.title))])], 1)], 1)
	  }), 0)])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col col-md-8 offset-md-2 padding-on-mobile"
	  }, [_c('ui_title', {
	    staticStyle: {
	      "margin": "50px 0"
	    }
	  }, [_vm._v("Лжеюристы в России")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col col-md-10 padding-on-mobile"
	  }, [_c('ui_text', {
	    staticClass: "body-text"
	  }, [_c('v-img', {
	    staticClass: "img-main",
	    attrs: {
	      "src": "/static/img/show_art_all.png"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Лжеюристы в России")]), _vm._v(" "), _c('p', [_vm._v("В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае составляют безграмотный иск, отправляют его по почте в суд. В результате проигранное дело в суде, никто уплаченные деньги не возвращает. В ряде случаев, после уплаты аванса за юридические услуги продолжалось вымогательство денег, а обещанные услуги не оказывались.")]), _vm._v(" "), _c('p', [_vm._v("Так, в Москве возбуждены уголовные дела в отношении мошенников, которые действовали под вывеской юридической фирмы. Жертвами сотрудников становились, в основном, пожилые люди. Их заманивали бесплатными консультациями, после чего навязывали услуги за астрономические гонорары. Ссылки на сюжет можно посмотреть здесь.")]), _vm._v(" "), _c('p', [_vm._v("Даже автор этих строк столкнулся с вопиющим случаем в этой сфере, когда попросили о помощи пенсионерке, которая обратилась к юристам по поводу ситуации с неправильно рассчитанной пенсией. На мое возражение, что я не являюсь специалистом в области пенсионного законодательства, пояснили, что тут вопрос скорее в сфере мошеннических действий и попросили разобраться. Придя в указанную юридическую фирму в центре Москвы, я представился племянником пенсионерки, чтобы не вызывать подозрений, и попросил рассказать о правах моей «родственницы». В ответ я услышал нечто фантастическое, где пенсионное законодательство смешалось с Законом о защите прав потребителя и наложилось на Гражданский кодекс. Суммы, которые должны были присудить пенсионерке, росли поминутно. На мой вопрос, могут ли они предъявить аналогичные выигранные дела для ознакомления перед внесением аванса за услуги (250 тысяч рублей, между прочим) меня отправили к генеральному директору, где мне было показано два решения совсем не по интересующему нас вопросу.")]), _vm._v(" "), _c('p', [_vm._v("Я понял, что толку от этих остапбендеров не будет, и предложил им вернуть пенсионерке деньги за консультацию, а ей, в свою очередь, порекомендовал обходить эту контору стороной. Поднялся крик, мне было заявлено, что сейчас вызовут полицию, на что я пояснил, что буду только рад, если в эту организацию приедут сотрудники правоохранительных органов. Полицию не вызвали…")]), _vm._v(" "), _c('p', [_vm._v("Эти случаи, увы, не единичны. В СМИ были иные сообщения о лжеюристах: https://www.1tv.ru/news/2019-08-08/370066-v_moskve_presechena_deyatelnost_lzheyuristov ,https://smotrim.ru/video/2313826, https://www.vesti.ru/video/2307524.")]), _vm._v(" "), _c('p', [_vm._v("Достаточно в поисковике ввести словосочетание «лжеюристы мошенничество». Несмотря на возбужденные уголовные дела, интернет полон хвалебных отзывов и благодарностей этим торговцам юридическими иллюзиями. Что делать? Ведь «реклама -- двигатель торговли». Люди, поверившие этим специалистам, признаны потерпевшими по уголовным делам, но потраченных денег, скорее всего, уже не увидят.")]), _vm._v(" "), _c('p', [_vm._v("Как же получить качественную юридическую помощь и не попасть в лапы подобным жуликам?")]), _vm._v(" "), _c('p', [_vm._v("Приложение “Мобильный адвокат» предлагает форму оплаты «безопасная сделка». Безопасная сделка -- опция, доступная на нашем портале. Она обеспечивает защиту интересов и адвоката, и его доверителя. В процессе оказания юридических услуг у клиента может возникнуть недовольство некачественной помощью адвоката. В свою очередь, адвокат заинтересован в том, чтобы деньги за его труд были ему своевременно уплачены клиентом, иначе пропадает мотивация к работе.")]), _vm._v(" "), _c('p', [_vm._v("Например, гражданин обратился в суд с иском о взыскании стоимости юридических услуг с адвоката. Иск мотивирован тем обстоятельством, что между сторонами было заключено соглашение об оказании юридической помощи целях признание праа собственности в порядке наследования. Стороны согласовали стоимость юридических услуг в сумме 130 000 руб., которые истцом были переданы ответчику. Однако ответчиком обязательства по договору выполнены не были. Суд, установив ненадлежащее оказание услуг, иск частично удовлетворил. Обращает внимание то обстоятельство, что суд по взысканию денег с адвоката занял около трех лет.")]), _vm._v(" "), _c('p', [_vm._v("Итог:")]), _vm._v(" "), _c('p', [_vm._v("работа адвоката выполнена некачественно, в результате дело проиграно, клиентка потратила три года и потратилась на другого адвоката, чтобы вернуть свои деньги.")]), _vm._v(" "), _c('p', [_vm._v("С другой стороны, и клиенты не всегда добросовестно оплачивают услуги адвоката. Так, гражданин заключил соглашение с адвокатом на представление его интересов по двум гражданским делам. После того, как адвокат оказал услуги, клиент отказался от его услуг (закон это разрешает) и уклонился от оплаты выставленных счетов. Понадобилось судебное разбирательство в течение года, чтобы вознаграждение адвоката было взыскано. Все это время адвокат отвлекался от основной работы, тратил время на участие в заседаниях, понес репутационные потери. Закон теперь разрешает оплату по схеме «гонорар успеха», но жизнь показывает, что мотивация у адвоката снижается, как только по делу возникают трудности либо он заключает соглашение, по которому ему оплатили аванс.")]), _vm._v(" "), _c('p', [_vm._v("Мы предлагаем форму оплаты, которая учитывает риски и опасения обеих сторон - «безопасная сделка». В момент заключения сделки, внесённые вами деньги резервируются (замораживаются) на специальном эскроу-счете, и перечисляются адвокату только после успешного завершения его работы по вашему делу.")]), _vm._v(" "), _c('p', [_vm._v("Банк, в котором открыт эскроу-счет, является гарантом ваших интересов: деньги поступят адвокату только в случае отсутствия обоснованных (подчеркиваем, обоснованных) претензий к качеству оказанных юридических услуг. В случае недобросовестных действий адвоката деньги возвращаются вам.")]), _vm._v(" "), _c('p', [_vm._v("В случае претензий к работе адвоката у вас есть возможность обратиться к модератору портала с жалобой. Модератор рассматривает спорную ситуацию, и, в случае сомнений в добросовестности адвоката, вам будут возвращены деньги и оказана помощь в подборе другого специалиста.")])], 1)], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-main-wrapper"
	  }, [_c('v-checkbox', {
	    key: _vm.value,
	    class: ("check-box check-box__" + (_vm.value ? 'activate' : 'deactivate')),
	    attrs: {
	      "error": _vm.error,
	      "input-value": _vm.value,
	      "disabled": _vm.disabled,
	      "label": _vm.placeholder,
	      "color": "red accent-4",
	      "hide-details": _vm.details,
	      "rules": _vm.rules || [],
	      "false-value": _vm.falseVal,
	      "true-value": _vm.trueVal
	    },
	    on: {
	      "change": _vm.change
	    },
	    scopedSlots: _vm._u([{
	      key: "label",
	      fn: function() {
	        return [_c('span', {
	          staticClass: "label"
	        }, [_vm._t("default")], 2)]
	      },
	      proxy: true
	    }], null, true)
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n      СТАТЬИ\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 mr-mob"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col link-art"
	  }, [_c('ul', _vm._l((_vm.article), function(item) {
	    return _c('li', {
	      key: item.id
	    }, [_c('router-link', {
	      staticStyle: {
	        "text-decoration": "underline"
	      },
	      attrs: {
	        "to": item.href
	      }
	    }, [_vm._v(_vm._s(item.title))])], 1)
	  }), 0)])])])]), _vm._v(" "), (_vm.art) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('p', {
	    staticClass: "title-art"
	  }, [_vm._v("\n          " + _vm._s(_vm.art.title) + "\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "text-art"
	  }, [_c('img', {
	    staticStyle: {
	      "float": "left",
	      "margin": "0em 1em 1em 0em"
	    },
	    attrs: {
	      "src": _vm.art.img
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.art.text) + "\n        ")])])])]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title-home pre-title"
	  }, [_c('div', {
	    staticClass: "col title-home-text"
	  }, [_vm._v("СТАТЬИ АДВОКАТОВ")])])
	}]}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-btn', {
	    class: ("button " + _vm.type),
	    attrs: {
	      "disabled": _vm.disabled
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('click')
	      }
	    }
	  }, [(_vm.type) ? _vm._t("default") : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', [_vm._v("\n      ОПЛАТА\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "row pre-title"
	  }, [_c('div', {
	    staticClass: "col offset-md-2 col-md-8"
	  }, [_c('Pay')], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    attrs: {
	      "to": _vm.href
	    }
	  }, [_c('span', {
	    staticClass: "href-text-ui",
	    style: (_vm.style)
	  }, [_vm._t("default"), _vm._v(" "), (_vm.arrow) ? _c('img', {
	    staticClass: "arrow-next",
	    attrs: {
	      "src": "/static/img/next-controll.svg"
	    }
	  }) : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n    СТРАХОВАНИЕ АДВОКАТОВ\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row row-img-text"
	  }, [_c('div', {
	    staticClass: "col-with-text col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col center-desc"
	  }, [_c('div', {
	    staticClass: "text"
	  }, [_c('ui_text', [_vm._v("\n                Даже огромный опыт и высокая квалификация адвоката не могут, к сожалению, служить гарантией отсутствия ошибок, малейшая из которых может принести значительные убытки. Для минимизации возможных потерь мы предлагаем уникальные программы страхования профессиональной ответственности адвокатов.\n              ")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-top": "1em"
	    }
	  }, [_c('ui_text', [_vm._v("Страховые риски")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('ui_text', [_vm._v("ошибочного толкования законодательства")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("ошибок при предоставлении письменных юридических консультаций")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("ошибок в составлении заявлений, жалоб, ходатайств и других документов правового характера")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("неизвещение клиента о последствиях совершаемых юридических действий")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("иные упущения при осуществлении адвокатской деятельности")])], 1)])], 1)])])])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n    ЗАЯВКА НА ОКАЗАНИЕ УСЛУГИ\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row input-send"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v("Имя")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.adv.name),
	      expression: "adv.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "name",
	      "placeholder": "Имя"
	    },
	    domProps: {
	      "value": (_vm.adv.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.adv, "name", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "row input-send"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "phone"
	    }
	  }, [_vm._v("Телефон")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.adv.phone),
	      expression: "adv.phone"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('+7(###)-###-##-##'),
	      expression: "'+7(###)-###-##-##'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "+7(###)-###-##-##",
	      "type": "text",
	      "id": "phone"
	    },
	    domProps: {
	      "value": (_vm.adv.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.adv, "phone", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "row input-send"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.adv.email),
	      expression: "adv.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "id": "email",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": (_vm.adv.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.adv, "email", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "row button-send"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('ui_btn', {
	    attrs: {
	      "disabled": _vm.isDisabled
	    },
	    on: {
	      "click": _vm.send
	    }
	  }, [_vm._v("Отправить заявку")])], 1)])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col col-md-5",
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/money.svg"
	    }
	  })])
	}]}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', [_vm._v("\n      СТОИМОСТЬ РАЗМЕЩЕНИЯ НА ПОРТАЛЕ ДЛЯ АДВОКАТОВ\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col li-cancel"
	  }, [_c('p', {
	    staticClass: "cansel-text"
	  }, [_c('ui_text', [_vm._v("При оформлении подписки на тариф Вы получаете возможность неограниченного пользования услугами портала. Всем новым адвокатам мы предоставляем доступ к порталу на 60 дней без абонентской платы:")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('ui_text', [_vm._v("Вашу анкету видят клиенты")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Персональный рейтинг, который влияет на место в поиске")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("\"Безопасная сделка\" - гарант того, что Вы получите деньги за работу")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Конфиденциальность информации: мы не вмешиваемся в ваши договоренности. О них знаете только Вы и клиент. Все данные защищены надежным шифрованием")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Круглосуточная поддержка. Мы всегда на связи по любым вопросам")])], 1)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row row-tarif"
	  }, [_c('div', {
	    staticClass: "col tarif-wrapper"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row tarif-price"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_vm._v("\n                  " + _vm._s(_vm.settings.priceMonth1) + " Р\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row tarif-button"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('button', {
	    staticClass: "grey-button",
	    on: {
	      "click": function($event) {
	        return _vm.pay(_vm.settings.priceMonth1)
	      }
	    }
	  }, [_vm._v("Подключить")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col tarif-wrapper"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "row tarif-price"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_vm._v("\n                  " + _vm._s(_vm.settings.priceMonth3) + " Р\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row tarif-button"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('button', {
	    staticClass: "grey-button",
	    on: {
	      "click": function($event) {
	        return _vm.pay(_vm.settings.priceMonth3)
	      }
	    }
	  }, [_vm._v("Подключить")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col tarif-wrapper"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "row tarif-price"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_vm._v("\n                  " + _vm._s(_vm.settings.priceMonth6) + " Р\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row tarif-button"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('button', {
	    staticClass: "grey-button",
	    on: {
	      "click": function($event) {
	        return _vm.pay(_vm.settings.priceMonth6)
	      }
	    }
	  }, [_vm._v("Подключить")])]), _vm._v(" "), _c('v-row', [_c('v-col', [_c('div', {
	    attrs: {
	      "id": "pm-widget-1635797042453"
	    }
	  })])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col tarif-wrapper"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "row tarif-price"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_vm._v("\n                  " + _vm._s(_vm.settings.priceYear) + " Р\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row tarif-button"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('button', {
	    staticClass: "grey-button",
	    on: {
	      "click": function($event) {
	        return _vm.pay(_vm.settings.priceYear)
	      }
	    }
	  }, [_vm._v("Подключить")])])])])])])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      ОТВЕТЫ НА РАСПРОСТРАНЕННЫЕ ВОПРОСЫ\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "filter-adv"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col acord-wrapper"
	  }, [_c('div', {
	    staticClass: "accordion",
	    attrs: {
	      "id": "accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingOne"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseOne",
	      "aria-expanded": "true",
	      "aria-controls": "collapseOne"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v("Можно ли бесплатно попробовать Ваш сервис?")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseOne",
	      "aria-labelledby": "headingOne",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("Да, всем новым адвокатам мы предоставляем доступ к порталу на 60 дней без абонентской платы с полным функционалом")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingTwo"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left collapsed",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseTwo",
	      "aria-expanded": "false",
	      "aria-controls": "collapseTwo"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v("Как разместиться на портале?")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseTwo",
	      "aria-labelledby": "headingTwo",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("Вам нужно пройти простую регистрацию, которая займет не более 5 минут. Пожалуйста, подготовьте фотографии паспорта и удостоверения адвоката. После регистрации Ваша анкета попадет на модерацию. После успешного прохождения модерации Ваша анкета появится на портале и Вы получите соответствующее уведомление")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingThree"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseThree",
	      "aria-expanded": "true",
	      "aria-controls": "collapseThree"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v("Я не прошел модерацию. В чем дело?")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseThree",
	      "aria-labelledby": "headingThree",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("\n                    Если Ваша анкета по каким-то причинам не прошла модерацию, Вы получите письмо от нас с комментариями. Вот несколько причин, по которым доступ к сервису может быть запрещен:\n                    "), _c('li', [_vm._v("Неверно указанные данные при регистрации")]), _vm._v(" "), _c('li', [_vm._v("Нечеткие фотографии паспорта или удостоверения адвоката")]), _vm._v(" "), _c('li', [_vm._v("Ваш статус адвоката прекращен или приостановлен")]), _vm._v(" "), _c('li', [_vm._v("Вы занесены в черный список портала")]), _vm._v("\n                      Пожалуйста, предоставьте запрошенные нами данные. После, Ваша анкета снова попадет на модерацию\n                  ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingFour"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseFour",
	      "aria-expanded": "true",
	      "aria-controls": "collapseFour"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v(" Как долго будет проходить модерация?")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseFour",
	      "aria-labelledby": "headingFour",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("Мы стараемся как можно скорее проверить всех новых пользователей. Обычно это происходит в течение 1 дня. Вы можете уточнить статус Вашей анкеты, написав нам в техподдержку")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingFive"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseFive",
	      "aria-expanded": "true",
	      "aria-controls": "collapseFive"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v("Что произойдет когда бесплатный период/подписка истечет?")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseFive",
	      "aria-labelledby": "headingFive",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("Ваша анкета не будет отображаться на сайте. Доступ к переписке и к заявкам тоже будет ограничен. Вы сможете завершить текущие(оплаченные) сделки, однако новые создать не сможете. После оплаты любого тарифа доступ будет восстановлен")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingSix"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseSix",
	      "aria-expanded": "true",
	      "aria-controls": "collapseSix"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v("Как мне привлечь больше клиентов на вашем портале?")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseSix",
	      "aria-labelledby": "headingSix",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("\n                  Пожалуйста, укажите в анкете достоверные данные о себе: специализации, стаж работы и тд. Загрузите фотографию, добавьте описание. В личном кабинете\n                  Вы сможете редактировать информацию о себе: добавлять специализации, менять описание и тд.\n                  В нашем сервисе действует гибкая система рейтингов: проводите сделки на нашем портале и Ваш рейтинг будет расти.\n                  Адвокаты с наибольшим рейтингом показываются на главной странице, а также на первых позициях поиска для клиентов\n                  ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingSeven"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseSeven",
	      "aria-expanded": "true",
	      "aria-controls": "collapseSeven"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v("Нет смысла регистрироваться. Адвокаты, которые зарегистрировались ранее, будут выше в поиске и соответственно получать больше заявок")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseSeven",
	      "aria-labelledby": "headingSeven",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("Не переживайте, мы разработали справедливую систему рейтингов, учитывающую множество факторов, в том числе время пребывания на портале. Все новые пользователи получают возможность находиться на верхних позициях в поиске. Подробнее на странице:"), _c('a', {
	    staticStyle: {
	      "color": "rgb(152, 16, 16) !important"
	    },
	    attrs: {
	      "href": "/work",
	      "target": "_blank"
	    }
	  }, [_vm._v(" Как это работает. ")])])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingEight"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseEight",
	      "aria-expanded": "true",
	      "aria-controls": "collapseEight"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v("Я нашел клиентов, как мне дальше с ними работать?")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseEight",
	      "aria-labelledby": "headingEight",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("В личном кабинете Вам надо создать сделку с этим клиентом и прописать условия сотрудничества в ней: стоимость, предмет договора, сроки выполнения")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingNine"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseNine",
	      "aria-expanded": "true",
	      "aria-controls": "collapseNine"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v("Когда я получу оплату за свои услуги?")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseNine",
	      "aria-labelledby": "headingNine",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("После оплаты клиентом сделки средства резервируются на специальном счете. Как только работа будет выполнена и подтверждена клиентом, Вы получите оплату на реквизиты, указанные в личном кабинете")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingTen"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseTen",
	      "aria-expanded": "true",
	      "aria-controls": "collapseTen"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v("Я выполнил договоренности с клиентом, но он не согласен. Что делать?")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseTen",
	      "aria-labelledby": "headingTen",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("Не переживайте, все спорные сделки попадают к нам на модерацию. Мы во всем разберемся и примем решение по Вашей сделке")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-header",
	    attrs: {
	      "id": "headingEleven"
	    }
	  }, [_c('h2', {
	    staticClass: "mb-0"
	  }, [_c('button', {
	    staticClass: "btn btn-link btn-block text-left",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#collapseEleven",
	      "aria-expanded": "true",
	      "aria-controls": "collapseEleven"
	    }
	  }, [_c('div', {
	    staticClass: "row text-title fix-header"
	  }, [_c('span', {
	    staticClass: "text-accord-overwflow"
	  }, [_c('ui_text', [_vm._v("\n                        У клиента большое и долгое дело. Я хочу получать оплату поэтапно.\n                        Как я могу это сделать?\n                        ")])], 1), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/img/Accord-controll.svg"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse",
	    attrs: {
	      "id": "collapseEleven",
	      "aria-labelledby": "headingEleven",
	      "data-parent": "#accordionExample"
	    }
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('ui_text', [_vm._v("Вы можете создавать неограниченное количество сделок с клиентом. Слона лучше есть по кусочкам. Создавайте сделки на небольшие суммы с четко прописанными договоренностями. Так Вы сможете получать оплату за каждую выполненную услугу, а клиент будет понимать весь процесс взаимодействия")])], 1)])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-5 col-img-cancel"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/cube.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row tarif-title"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_vm._v("\n                  1 месяц\n                ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row tarif-title"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_vm._v("\n                  3 месяц\n                ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row tarif-title"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_vm._v("\n                  6 месяц\n                ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row tarif-title"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_vm._v("\n                  12 месяц\n                ")])])
	}]}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ui_title_line', [_vm._v("\n      Политика конфиденциальности\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2 mr-mob polit-text"
	  }, [_c('ui_text', [_vm._v("\n     Политика в отношении обработки персональных данных"), _c('br'), _vm._v("\n      1. Общие положения\n      Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006. №152-ФЗ «О персональных данных» (далее - Закон о персональных данных) и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые Михайловым Иваном Сергеевичем (далее – Оператор).\n      1.1. Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.\n      1.2. Настоящая политика Оператора в отношении обработки персональных данных (далее – Политика) применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта httpsː//thismywebsite·com.\n      2. Основные понятия, используемые в Политике\n      2.1. Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств вычислительной техники.\n      2.2. Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных).\n      2.3. Веб-сайт – совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу httpsː//thismywebsite·com.\n      2.4. Информационная система персональных данных — совокупность содержащихся в базах данных персональных данных, и обеспечивающих их обработку информационных технологий и технических средств.\n      2.5. Обезличивание персональных данных — действия, в результате которых невозможно определить без использования дополнительной информации принадлежность персональных данных конкретному Пользователю или иному субъекту персональных данных.\n      2.6. Обработка персональных данных – любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных.\n      2.7. Оператор – государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными.\n      2.8. Персональные данные – любая информация, относящаяся прямо или косвенно к определенному или определяемому Пользователю веб-сайта httpsː//thismywebsite·com.\n      2.9. Персональные данные, разрешенные субъектом персональных данных для распространения, - персональные данные, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных путем дачи согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения в порядке, предусмотренном Законом о персональных данных (далее - персональные данные, разрешенные для распространения).\n      2.10. Пользователь – любой посетитель веб-сайта httpsː//thismywebsite·com.\n      2.11. Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц.\n      2.12. Распространение персональных данных – любые действия, направленные на раскрытие персональных данных неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными данными неограниченного круга лиц, в том числе обнародование персональных данных в средствах массовой информации, размещение в информационно-телекоммуникационных сетях или предоставление доступа к персональным данным каким-либо иным способом.\n      2.13. Трансграничная передача персональных данных – передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому или иностранному юридическому лицу.\n      2.14. Уничтожение персональных данных – любые действия, в результате которых персональные данные уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в информационной системе персональных данных и (или) уничтожаются материальные носители персональных данных.\n      3. Основные права и обязанности Оператора\n      3.1. Оператор имеет право:\n      – получать от субъекта персональных данных достоверные информацию и/или документы, содержащие персональные данные;\n      – в случае отзыва субъектом персональных данных согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в Законе о персональных данных;\n      – самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения обязанностей, предусмотренных Законом о персональных данных и принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено Законом о персональных данных или другими федеральными законами.\n      3.2. Оператор обязан:\n      – предоставлять субъекту персональных данных по его просьбе информацию, касающуюся обработки его персональных данных;\n      – организовывать обработку персональных данных в порядке, установленном действующим законодательством РФ;\n      – отвечать на обращения и запросы субъектов персональных данных и их законных представителей в соответствии с требованиями Закона о персональных данных;\n      – сообщать в уполномоченный орган по защите прав субъектов персональных данных по запросу этого органа необходимую информацию в течение 30 дней с даты получения такого запроса;\n      – публиковать или иным образом обеспечивать неограниченный доступ к настоящей Политике в отношении обработки персональных данных;\n      – принимать правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от иных неправомерных действий в отношении персональных данных;\n      – прекратить передачу (распространение, предоставление, доступ) персональных данных, прекратить обработку и уничтожить персональные данные в порядке и случаях, предусмотренных Законом о персональных данных;\n      – исполнять иные обязанности, предусмотренные Законом о персональных данных.\n      4. Основные права и обязанности субъектов персональных данных\n      4.1. Субъекты персональных данных имеют право:\n      – получать информацию, касающуюся обработки его персональных данных, за исключением случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту персональных данных Оператором в доступной форме, и в них не должны содержаться персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. Перечень информации и порядок ее получения установлен Законом о персональных данных;\n      – требовать от оператора уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав;\n      – выдвигать условие предварительного согласия при обработке персональных данных в целях продвижения на рынке товаров, работ и услуг;\n      – на отзыв согласия на обработку персональных данных;\n      – обжаловать в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке неправомерные действия или бездействие Оператора при обработке его персональных данных;\n      – на осуществление иных прав, предусмотренных законодательством РФ.\n      4.2. Субъекты персональных данных обязаны:\n      – предоставлять Оператору достоверные данные о себе;\n      – сообщать Оператору об уточнении (обновлении, изменении) своих персональных данных.\n      4.3. Лица, передавшие Оператору недостоверные сведения о себе, либо сведения о другом субъекте персональных данных без согласия последнего, несут ответственность в соответствии с законодательством РФ.\n      5. Оператор может обрабатывать следующие персональные данные Пользователя\n      5.1. Фамилия, имя, отчество.\n      5.2. Электронный адрес.\n      5.3. Номера телефонов.\n      5.4. Также на сайте происходит сбор и обработка обезличенных данных о посетителях (в т.ч. файлов «cookie») с помощью сервисов интернет-статистики (Яндекс Метрика и Гугл Аналитика и других).\n      5.5. Вышеперечисленные данные далее по тексту Политики объединены общим понятием Персональные данные.\n      5.6. Обработка специальных категорий персональных данных, касающихся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, интимной жизни, Оператором не осуществляется.\n      5.7. Обработка персональных данных, разрешенных для распространения, из числа специальных категорий персональных данных, указанных в ч. 1 ст. 10 Закона о персональных данных, допускается, если соблюдаются запреты и условия, предусмотренные ст. 10.1 Закона о персональных данных.\n      5.8. Согласие Пользователя на обработку персональных данных, разрешенных для распространения, оформляется отдельно от других согласий на обработку его персональных данных. При этом соблюдаются условия, предусмотренные, в частности, ст. 10.1 Закона о персональных данных. Требования к содержанию такого согласия устанавливаются уполномоченным органом по защите прав субъектов персональных данных.\n      5.8.1 Согласие на обработку персональных данных, разрешенных для распространения, Пользователь предоставляет Оператору непосредственно.\n      5.8.2 Оператор обязан в срок не позднее трех рабочих дней с момента получения указанного согласия Пользователя опубликовать информацию об условиях обработки, о наличии запретов и условий на обработку неограниченным кругом лиц персональных данных, разрешенных для распространения.\n      5.8.3 Передача (распространение, предоставление, доступ) персональных данных, разрешенных субъектом персональных данных для распространения, должна быть прекращена в любое время по требованию субъекта персональных данных. Данное требование должно включать в себя фамилию, имя, отчество (при наличии), контактную информацию (номер телефона, адрес электронной почты или почтовый адрес) субъекта персональных данных, а также перечень персональных данных, обработка которых подлежит прекращению. Указанные в данном требовании персональные данные могут обрабатываться только Оператором, которому оно направлено.\n      5.8.4 Согласие на обработку персональных данных, разрешенных для распространения, прекращает свое действие с момента поступления Оператору требования, указанного в п. 5.8.3 настоящей Политики в отношении обработки персональных данных.\n      6. Принципы обработки персональных данных\n      6.1. Обработка персональных данных осуществляется на законной и справедливой основе.\n      6.2. Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных.\n      6.3. Не допускается объединение баз данных, содержащих персональные данные, обработка которых осуществляется в целях, несовместимых между собой.\n      6.4. Обработке подлежат только персональные данные, которые отвечают целям их обработки.\n      6.5. Содержание и объем обрабатываемых персональных данных соответствуют заявленным целям обработки. Не допускается избыточность обрабатываемых персональных данных по отношению к заявленным целям их обработки.\n      6.6. При обработке персональных данных обеспечивается точность персональных данных, их достаточность, а в необходимых случаях и актуальность по отношению к целям обработки персональных данных. Оператор принимает необходимые меры и/или обеспечивает их принятие по удалению или уточнению неполных или неточных данных.\n      6.7. Хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных. Обрабатываемые персональные данные уничтожаются либо обезличиваются по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено федеральным законом.\n      7. Цели обработки персональных данных\n      7.1. Цель обработки персональных данных Пользователя:\n      – информирование Пользователя посредством отправки электронных писем;\n      – заключение, исполнение и прекращение гражданско-правовых договоров;\n      – предоставление доступа Пользователю к сервисам, информации и/или материалам, содержащимся на веб-сайте httpsː//thismywebsite·com.\n      7.2. Также Оператор имеет право направлять Пользователю уведомления о новых продуктах и услугах, специальных предложениях и различных событиях. Пользователь всегда может отказаться от получения информационных сообщений, направив Оператору письмо на адрес электронной почты privacy@thismywebsite·com с пометкой «Отказ от уведомлений о новых продуктах и услугах и специальных предложениях».\n      7.3. Обезличенные данные Пользователей, собираемые с помощью сервисов интернет-статистики, служат для сбора информации о действиях Пользователей на сайте, улучшения качества сайта и его содержания.\n      8. Правовые основания обработки персональных данных\n      8.1. Правовыми основаниями обработки персональных данных Оператором являются:\n      – перечислите нормативно-правовые акты, регулирующие отношения, связанные с вашей деятельностью, например, если ваша деятельность связана с информационными технологиями, в частности с созданием сайтов, то здесь можно указать Федеральный закон \"Об информации, информационных технологиях и о защите информации\" от 27.07.2006 N 149-ФЗ;\n      – уставные документы Оператора;\n      – договоры, заключаемые между оператором и субъектом персональных данных;\n      – федеральные законы, иные нормативно-правовые акты в сфере защиты персональных данных;\n      – согласия Пользователей на обработку их персональных данных, на обработку персональных данных, разрешенных для распространения.\n      8.2. Оператор обрабатывает персональные данные Пользователя только в случае их заполнения и/или отправки Пользователем самостоятельно через специальные формы, расположенные на сайте httpsː//thismywebsite·com или направленные Оператору посредством электронной почты. Заполняя соответствующие формы и/или отправляя свои персональные данные Оператору, Пользователь выражает свое согласие с данной Политикой.\n      8.3. Оператор обрабатывает обезличенные данные о Пользователе в случае, если это разрешено в настройках браузера Пользователя (включено сохранение файлов «cookie» и использование технологии JavaScript).\n      8.4. Субъект персональных данных самостоятельно принимает решение о предоставлении его персональных данных и дает согласие свободно, своей волей и в своем интересе.\n      9. Условия обработки персональных данных\n      9.1. Обработка персональных данных осуществляется с согласия субъекта персональных данных на обработку его персональных данных.\n      9.2. Обработка персональных данных необходима для достижения целей, предусмотренных международным договором Российской Федерации или законом, для осуществления возложенных законодательством Российской Федерации на оператора функций, полномочий и обязанностей.\n      9.3. Обработка персональных данных необходима для осуществления правосудия, исполнения судебного акта, акта другого органа или должностного лица, подлежащих исполнению в соответствии с законодательством Российской Федерации об исполнительном производстве.\n      9.4. Обработка персональных данных необходима для исполнения договора, стороной которого либо выгодоприобретателем или поручителем по которому является субъект персональных данных, а также для заключения договора по инициативе субъекта персональных данных или договора, по которому субъект персональных данных будет являться выгодоприобретателем или поручителем.\n      9.5. Обработка персональных данных необходима для осуществления прав и законных интересов оператора или третьих лиц либо для достижения общественно значимых целей при условии, что при этом не нарушаются права и свободы субъекта персональных данных.\n      9.6. Осуществляется обработка персональных данных, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных либо по его просьбе (далее – общедоступные персональные данные).\n      9.7. Осуществляется обработка персональных данных, подлежащих опубликованию или обязательному раскрытию в соответствии с федеральным законом.\n      10. Порядок сбора, хранения, передачи и других видов обработки персональных данных\n      Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых, организационных и технических мер, необходимых для выполнения в полном объеме требований действующего законодательства в области защиты персональных данных.\n      10.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц.\n      10.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства либо в случае, если субъектом персональных данных дано согласие Оператору на передачу данных третьему лицу для исполнения обязательств по гражданско-правовому договору.\n      10.3. В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно, путем направления Оператору уведомление на адрес электронной почты Оператора privacy@thismywebsite·com с пометкой «Актуализация персональных данных».\n      10.4. Срок обработки персональных данных определяется достижением целей, для которых были собраны персональные данные, если иной срок не предусмотрен договором или действующим законодательством.\n      Пользователь может в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору уведомление посредством электронной почты на электронный адрес Оператора privacy@thismywebsite·com с пометкой «Отзыв согласия на обработку персональных данных».\n      10.5. Вся информация, которая собирается сторонними сервисами, в том числе платежными системами, средствами связи и другими поставщиками услуг, хранится и обрабатывается указанными лицами (Операторами) в соответствии с их Пользовательским соглашением и Политикой конфиденциальности. Субъект персональных данных и/или Пользователь обязан самостоятельно своевременно ознакомиться с указанными документами. Оператор не несет ответственность за действия третьих лиц, в том числе указанных в настоящем пункте поставщиков услуг.\n      10.6. Установленные субъектом персональных данных запреты на передачу (кроме предоставления доступа), а также на обработку или условия обработки (кроме получения доступа) персональных данных, разрешенных для распространения, не действуют в случаях обработки персональных данных в государственных, общественных и иных публичных интересах, определенных законодательством РФ.\n      10.7. Оператор при обработке персональных данных обеспечивает конфиденциальность персональных данных.\n      10.8. Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных.\n      10.9. Условием прекращения обработки персональных данных может являться достижение целей обработки персональных данных, истечение срока действия согласия субъекта персональных данных или отзыв согласия субъектом персональных данных, а также выявление неправомерной обработки персональных данных.\n      11. Перечень действий, производимых Оператором с полученными персональными данными\n      11.1. Оператор осуществляет сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление и уничтожение персональных данных.\n      11.2. Оператор осуществляет автоматизированную обработку персональных данных с получением и/или передачей полученной информации по информационно-телекоммуникационным сетям или без таковой.\n      12. Трансграничная передача персональных данных\n      12.1. Оператор до начала осуществления трансграничной передачи персональных данных обязан убедиться в том, что иностранным государством, на территорию которого предполагается осуществлять передачу персональных данных, обеспечивается надежная защита прав субъектов персональных данных.\n      12.2. Трансграничная передача персональных данных на территории иностранных государств, не отвечающих вышеуказанным требованиям, может осуществляться только в случае наличия согласия в письменной форме субъекта персональных данных на трансграничную передачу его персональных данных и/или исполнения договора, стороной которого является субъект персональных данных.\n      13. Конфиденциальность персональных данных\n      Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим лицам и не распространять персональные данные без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом.\n      14. Заключительные положения\n      14.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору с помощью электронной почты privacy@thismywebsite·com.\n      14.2. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором. Политика действует бессрочно до замены ее новой версией.\n      14.3. Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу httpsː//thismywebsite·com/privacy/.\n      ")])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.isLoading) ? [_c('ui_title_line', {
	    attrs: {
	      "no_left": ""
	    }
	  }, [_vm._v("\n      НАЙТИ АДВОКАТА\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "inputs-wrapper"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col input-row"
	  }, [_c('div', {
	    staticClass: "img-war-warpper"
	  }, [_c('img', {
	    staticClass: "warning-img",
	    attrs: {
	      "src": "/static/img/warning-icon.svg"
	    }
	  }), _vm._v(" "), _c('ui_text', [_vm._v(" Вы можете выбрать подходящего специалиста и отправить ему заявку на выполнение работ или просмотреть его профиль ")])], 1), _vm._v(" "), _c('v-select', {
	    attrs: {
	      "error-messages": _vm.specializationErrors,
	      "required": "",
	      "items": _vm.spec,
	      "item-text": 'name',
	      "item-value": 'id',
	      "input-value": "select.specialization",
	      "label": "Область специализации",
	      "outlined": ""
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.specialization.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.specialization.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.specialization),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "specialization", $$v)
	      },
	      expression: "select.specialization"
	    }
	  }), _vm._v(" "), _c('p', [_c('v-checkbox', {
	    attrs: {
	      "label": "Выбрать все",
	      "content-class": "asdas",
	      "hide-details": "",
	      "value": _vm.select.region && _vm.select.region.length == this.region.length ? true : false,
	      "color": "red darken-3"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.setAll($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-autocomplete', {
	    attrs: {
	      "error-messages": _vm.regionErrors,
	      "required": "",
	      "items": _vm.region,
	      "multiple": "",
	      "item-text": 'name',
	      "item-value": 'id',
	      "clearable": "",
	      "label": "Регион",
	      "outlined": ""
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.select.region.$touch()
	      },
	      "blur": function($event) {
	        return _vm.$v.select.region.$touch()
	      }
	    },
	    model: {
	      value: (_vm.select.region),
	      callback: function($$v) {
	        _vm.$set(_vm.select, "region", $$v)
	      },
	      expression: "select.region"
	    }
	  })], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 offset-md-2"
	  }, [_c('v-row', {
	    staticClass: "search-button"
	  }, [_c('v-col', [_c('ui_btn', {
	    attrs: {
	      "type": [!_vm.$v.select.$invalid ? 'main-btn' : 'gray-btn']
	    },
	    on: {
	      "click": function($event) {
	        return _vm.loadAdvocate()
	      }
	    }
	  }, [_vm._v("Подобрать")])], 1)], 1)], 1)]), _vm._v(" "), (_vm.advocats.length != 0) ? [_c('div', {
	    staticClass: "main-wrapper"
	  }, _vm._l((_vm.advocats), function(item) {
	    return _c('div', {
	      key: item.id,
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-md-8 offset-md-2 item-adv"
	    }, [_c('div', {}, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col item-img"
	    }, [_c('img', {
	      attrs: {
	        "src": item.photo ? (_vm.getApi + "file/" + (item.photo)) : _vm.customer1,
	        "alt": ""
	      }
	    })])]), _vm._v(" "), (item.star) ? _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col"
	    }, [_c('v-rating', {
	      attrs: {
	        "color": "#981010",
	        "background-color": "black",
	        "hover": "",
	        "half-increments": "",
	        "length": "5",
	        "value": item.star,
	        "readonly": "",
	        "size": "33"
	      }
	    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "row is-mobile"
	    }, [_c('div', {
	      staticClass: "col item-name"
	    }, [_c('ui_text', [_vm._v("\n                        " + _vm._s(item.surname) + " " + _vm._s(item.name) + " " + _vm._s(item.patronymic) + "\n                      ")])], 1)]), _vm._v(" "), _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col"
	    }, [_c('span', {
	      staticClass: "item-system"
	    }, [_vm._v("\n                        Стаж:\n                      ")]), _vm._v(" "), _c('span', {
	      staticClass: "item-specific"
	    }, [_vm._v("\n                        " + _vm._s(item.experience) + "\n                      ")])])]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
	      staticClass: "row item-specific is-mobile"
	    }, [_c('div', {
	      staticClass: "col"
	    }, [_c('ul', _vm._l((item.specialization), function(spec) {
	      return _c('li', {
	        key: spec
	      }, [_vm._v("\n                          " + _vm._s(spec) + "\n                        ")])
	    }), 0)])]), _vm._v(" "), _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col"
	    }, [_c('div', {
	      staticClass: "item-system",
	      staticStyle: {
	        "margin-bottom": "1em"
	      }
	    }, [_vm._v("\n                        Адрес:\n                      ")]), _vm._v(" "), _c('ul', _vm._l((item.region), function(reg) {
	      return _c('li', {
	        key: reg,
	        staticClass: "item-specific"
	      }, [_vm._v("\n                          " + _vm._s(reg) + "\n                        ")])
	    }), 0)])])]), _vm._v(" "), _c('div', {
	      staticClass: "col"
	    }, [_c('div', {
	      staticClass: "row is-desctop"
	    }, [_c('div', {
	      staticClass: "col item-name"
	    }, [_c('ui_text', [_vm._v("\n                        " + _vm._s(item.surname) + " " + _vm._s(item.name) + " " + _vm._s(item.patronymic) + "\n                      ")])], 1)]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
	      staticClass: "row item-specific is-desctop"
	    }, [_c('div', {
	      staticClass: "col"
	    }, [_c('ul', _vm._l((item.specialization), function(spec) {
	      return _c('li', {
	        key: spec
	      }, [_vm._v("\n                          " + _vm._s(spec) + "\n                        ")])
	    }), 0)])])]), _vm._v(" "), _c('div', {
	      staticClass: "col is-desctop col-button"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col"
	    }, [_c('ui_btn', {
	      attrs: {
	        "type": "gray-btn full-width"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toProfile(item)
	        }
	      }
	    }, [_vm._v("Посмотреть профиль")])], 1)]), _vm._v(" "), _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col"
	    }, [_c('ui_btn', {
	      attrs: {
	        "type": "main-btn full-width"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toCreate(item)
	        }
	      }
	    }, [_vm._v("Отправить заявку")])], 1)])])]), _vm._v(" "), _c('div', {
	      staticClass: "row is-mobile"
	    }, [_c('div', {
	      staticClass: "col"
	    }, [_c('ui_btn', {
	      attrs: {
	        "type": "gray-btn full-width"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toProfile(item)
	        }
	      }
	    }, [_vm._v("Посмотреть профиль")])], 1), _vm._v(" "), _c('div', {
	      staticClass: "col"
	    }, [_c('ui_btn', {
	      attrs: {
	        "type": "main-btn full-width"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toCreate(item)
	        }
	      }
	    }, [_vm._v("Отправить заявку")])], 1)])])])])
	  }), 0), _vm._v(" "), _c('v-pagination', {
	    staticClass: "my-4",
	    attrs: {
	      "length": _vm.total
	    },
	    model: {
	      value: (_vm.page),
	      callback: function($$v) {
	        _vm.page = $$v
	      },
	      expression: "page"
	    }
	  })] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLoading) ? [_c('div', {
	    staticClass: "wrapper-loading",
	    staticStyle: {
	      "height": "100vh"
	    }
	  }, [_c('v-progress-circular', {
	    staticStyle: {
	      "height": "61.6 vh"
	    },
	    attrs: {
	      "indeterminate": "",
	      "size": 70,
	      "width": 7,
	      "color": "red"
	    }
	  })], 1)] : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row is-mobile"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('span', {
	    staticClass: "item-system"
	  }, [_vm._v("\n                        Специализация:\n                      ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row is-desctop"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('span', {
	    staticClass: "item-system"
	  }, [_vm._v("\n                        Специализация:\n                      ")])])])
	}]}

/***/ }),
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.8b0f62d2d0f636d64cf1.js